import config from '../libs/webIMConfig';
import images from '../themes/constantsImages';
import urls from '../api/urls';
import * as eventTypes from './eventTypes';
import * as messageTypes from './messageTypes';
// eslint-disable-next-line import/no-duplicates
import {
  giftIconLevel1,
  giftIconLevel2,
  giftIconLevel3,
  giftIconLevel4,
  giftIconLevel5,
  giftIconLevel6,
  icAccountSettings,
  icAmateurPics,
  icBlockUserOption,
  icCameraBlack,
  icCameraOrange,
  icCameraRedBenefit,
  icChatBlack,
  icChatOrange,
  icChatRed,
  icChatRoomBlack,
  icChatRoomOrange,
  icChatRoomRed,
  icChatRooms,
  icCommunity,
  icCreateGroupBlack,
  icCreateGroupOrange,
  icCreateGroupRed,
  icDateFinderSetting,
  icDeleteTrash,
  icEditReport,
  icFollowOption,
  icForums,
  icGroupMenu,
  icGuessBlack,
  icHeartBlack,
  icHeartOrange,
  icHeartRed,
  icHelp,
  icInviteBlack,
  icInviteBlue,
  icInviteOrange,
  icInviteRed,
  icLeaveGroup,
  icLegalEProfile,
  icLegalEProfileActive,
  icLogOut,
  icMultiStreamBlack,
  icMultiStreamRed,
  icMyLists,
  icNotificationSettings,
  icPartiesEvents,
  icPhoneBlack,
  icPhoneRed,
  icPostEventBlack,
  icPostEventOrange,
  icPostEventRed,
  icPrivacySettings,
  icPrivateAlbum,
  icProfileAccount,
  icProfileAccountActive,
  icProfileEdit,
  icProfileEditActive,
  icProfileHelp,
  icProfileHelpActive,
  icProfileManagePhotos,
  icProfileManagePhotosActive,
  icProfileMyList,
  icProfileMyListActive,
  icProfileNotification,
  icProfileNotificationActive,
  icProfilePrivacy,
  icProfilePrivacyActive,
  icProfileSubscriptions,
  icProfileSubscriptionsActive,
  icPublicAlbum,
  icReportMess,
  icReportOption,
  icRHPStore,
  icRHPStoreActive,
  icSendFavBlack,
  icSendFavOrange,
  icSendFavRed,
  icSendHeartBlack,
  icSendHeartOrange,
  icSendHeartRed,
  icShare,
  icStealthBlack,
  icStealthOrange,
  icStealthRed,
  icSubscriptions,
  icTravelSetting,
  icUndoBlack,
  icUndoOrange,
  icUndoRed,
  icUnFollowOption,
  icUnlimitBlack,
  icVerifyPendingOutline,
  icVideoBlack,
  icVideoOrange,
  icVideoRed,
  icVisibilityBlack,
  icVisibilityBlue,
  icVisibilityOrange,
  icVisibilityRed,
} from '../themes/ImagesSVG';
import * as routes from './routes';
import {
  ABOUT_RHP,
  ACCESS_LIST,
  ACCOUNT,
  ACCOUNT_SETTING,
  ARTICLES,
  BLOCK_LIST,
  CHAT_ROOMS,
  COMMUNITY,
  DATE_FINDER_ADD_DATE,
  DATE_FINDER_MY_DATE,
  DATE_FINDER_PAGE,
  DESCRIPTION,
  EDIT_GENERAL_INFO,
  EDIT_PROFILE_DK,
  EDIT_SETTING_INFO,
  EMAIL_NOTIFICATION,
  FEED_HOME,
  FRIEND,
  GALLERY,
  HELP_AND_SUPPORT,
  HELP_SUPPORT,
  HOME,
  IDEAL_PARTNER as IDEAL_PARTNER_MENU,
  IGNORE,
  INTERESTS,
  INTIMATE_INFO,
  LEGAL,
  LIST,
  MAIN_SETTING,
  MANAGE_SUBSCRIPTION,
  MANAGER_CONVERSATION_CREDITS,
  MEMBER,
  NOTIFICATION,
  ON_THE_GROUND,
  PARTNER_DESCRIPTION,
  PHOTO,
  PRIVACY,
  PROSPECT,
  PUSH_NOTIFICATION,
  RHP_STORE,
  ROOT_FOLDER,
  STORIES,
  SUBSCRIPTION,
  SUPPORT_VIEW,
  TESTIMONIALS,
  TICKET_LIST,
  TRAVEL_PLAN,
  USER,
  USER_LIST,
  VALIDATION,
} from './routes';

export const LOCATION_SEARCH_TYPE = {
  COUNTRY_STATE: 'CountryState',
  SUB_URB_ONLY: 'SubUrbOnly',
  NOT_APPLICABLE: 'NotApplicable',
};

export const MAXIMUM_LENGTH_TEXT_GROUP_CHAT_MESSAGE = 200;
export const MAXIMUM_DATE_FINDER = 5;
export const TIMEOUT_SET_USER_OFFLINE = 120000;

export const MAXIMUM_TEXT_REPLY_LENGTH = 512;

export const ONE_MINUTE = 1000 * 60;
export const FIVE_MINUTES = ONE_MINUTE * 5;
export const ONE_HOUR = 1000 * 60 * 60;
export const ONE_DAY = ONE_HOUR * 24;
export const ONE_WEEK = ONE_DAY * 7;
export const ONE_MONTH = ONE_DAY * 30;
export const THREE_MONTHS = ONE_MONTH * 3;

export const APP_IN_ACTIVE = 'active';
export const APP_IN_BACKGROUND = 'background';

export const TOGGLE_COLOR = 'TOGGLE_COLOR';
export const EXAMPLE_REQUEST_START = 'EXAMPLE_REQUEST_START';
export const EXAMPLE_REQUEST_DATA = 'EXAMPLE_REQUEST_DATA';
export const TRUE_VALUE = true;
export const FALSE_VALUE = true;

export const TIMEOUT_TRY_RECONNECT_NOW = 3000;

export const GIPHY_KEY = 'kGRjfVGfJaA1S62du1IkWnZ6JtyJvbv4';
export const RE_CAPTCHA_SITE_KEY = '6Le9c94ZAAAAAHzHqp1flQ8kWOfT_-3AURkZr7y5';
export const RE_CAPTCHA_DOMAIN = 'https://redhotpie.com.au';
export const LINE_TEXTAREA_LIMIT = {
  MAX: 5,
  MIN: 1,
};

export const MAXIMUM_RECORDING_TIME_VOICE_MESSAGE = 1000 * 60 * 15; // 15 minutes;

// FILTER_CATEGORY_ITEM_TYPE
export const FILTER_CATEGORY_ITEM_TYPE = {
  CATEGORY_ITEM_GREEN: 1,
};
export const UPGRADE_MEMBER_SHIP_ID = {
  PLUS: 1,
  PREMIUM: 2,
  PREMIUM_PLUS: 3,
  PLATINUM: 4,
  DIAMOND: 5,
  EXTRAS: 6,
};
// KEY
export const KEY = {
  GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY,
  GOOGLE_WEB_CLIENT_ID: '294081325808-ueofb1pv7m7ultvn7kvcfht3r5epg6df.apps.googleusercontent.com', // Client id of redhotpie
  /**
   * WEB_CLIENT_ID for test
   */
  // GOOGLE_WEB_CLIENT_ID: '186628956912-4a2990c0sallhplqlkl9v5knt7i95rrs.apps.googleusercontent.com',
  GOOGLE_API_KEY_IOS: 'AIzaSyCPWdWJ8eQExUVJ9P1jbEg60quTsDBP7n0',
  GOOGLE_API_KEY_ANDROID: 'AIzaSyAKSoqkh5ct2FAbRF-QfYJJAVYM30viFBk',
  FACEBOOK_API_KEY: 229417623770081,
};

export const FILE_TYPE_TEXT_INPUT = {
  IMAGE: 'Photo',
  GIF: 'Gif',
  VIDEO: 'Video',
  VIDEO_URL: 'VideoUrl',
};

export const SCROLL_BOTTOM = 'SCROLL_BOTTOM';
export const SCROLL_INIT_BOTTOM = 'SCROLL_INIT_BOTTOM';
export const SCROLL_BOTTOM_PUBLIC_GROUP_CHAT = 'SCROLL_BOTTOM_PUBLIC_GROUP_CHAT';

// REACTJS:
export const DEFAULT_HEIGHT = 9;
export const DEFAULT_SYSTEM = {
  LIMIT_CONVERSATION_PINNED: 2,
};

export const MAX_COUNT_IMAGE_SHOW_GALLERY_MOBILE = 3;
export const MAX_COUNT_IMAGE_SHOW_GALLERY_DESKTOP = 4;
export const MAX_EVENT_TITLE = 60;
export const MAX_LENGTH = 100000000000;

export const ORIENTATION = {
  PORTRAIT: 'PORTRAIT',
  LANDSCAPE: 'LANDSCAPE',
  LANDSCAPELEFT: 'LANDSCAPE-LEFT',
  LANDSCAPERIGHT: 'LANDSCAPE-RIGHT',
};
export const SCREENS_NAME = {
  START: 'START',
  DEFAULT_VALUE: '',
  MESSENGERS_INBOX: 'MESSENGERS_INBOX',
  GROUPS_CHAT: 'GROUPS_CHAT',
  GROUP_CHAT_DETAIL: 'GROUP_CHAT_DETAIL',
  MESSENGERS_SETTINGS: 'MESSENGERS_SETTINGS',
  CONVERSATION: 'CONVERSATION',
  CONVERSATION_BY_PROFILE: 'CONVERSATION_BY_PROFILE',
  INBOX_DETAIL: 'INBOX_DETAIL',
  LOGIN: 'LOGIN',
  USER_LOGIN: 'USER_LOGIN',
  USER_LOGIN_NEW_PASS: 'USER_LOGIN_NEW_PASS',
  SPLASH: 'SPLASH',
  SPLASH_ANIMATED: 'SPLASH_ANIMATED',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  RESET_PASSWORD: 'RESET_PASSWORD',
  FACE_BOOK_ACTIVE: 'FACE_BOOK_ACTIVE',
  LOCATION_SELECTOR: 'LOCATION_SELECTOR',
  LOOKING_TO_MEET: 'LOOKING_TO_MEET',
  TELL_US_ABOUT_YOURSELF_1: 'TELL_US_ABOUT_YOURSELF_1',
  TELL_US_ABOUT_YOURSELF_2: 'TELL_US_ABOUT_YOURSELF_2',
  WHAT_ARE_YOUR_INTERESTS: ' WHAT_ARE_YOUR_INTERESTS',
  INTRODUCE_YOURSELF: 'INTRODUCE_YOURSELF',
  PROFILE_BUILDER: 'PROFILE_BUILDER',
  CREATE_ACCOUNT: 'CREATE_ACCOUNT',
  MEMBER_SEARCH: 'MEMBER_SEARCH',
  MEMBER_PROSPECT: 'MEMBER_PROSPECT',
  TAB_BOTTOM: 'TAB_BOTTOM',
  PROFILE_NOT_FOUND: 'PROFILE_NOT_FOUND',
  LIST_VIDEOCALL_COMPONENT: 'LIST_VIDEOCALL_COMPONENT',
  REGISTRATION_CREATE_ACCOUNT: 'REGISTRATION_CREATE_ACCOUNT',
  CHAT_ROOMS: 'CHAT_ROOMS',
  CHAT_ROOMS_CONVERSATIONS: 'CHAT_ROOMS_CONVERSATIONS',
  LIVE_STREAM_CONVERSATIONS: 'LIVE_STREAM_CONVERSATIONS',
  WELCOME_SCREEN: 'WELCOME_SCREEN',
  BROWSER_WEB_VIEW: 'BROWSER_WEB_VIEW',
  USER_INFO_SETTING: 'USER_INFO_SETTING',
  NOTIFICATION: 'NOTIFICATION',
  VIDEO_FULL_SCREEN: 'VIDEO_FULL_SCREEN',
  FRIENDS_SCREEN: 'FRIENDS_SCREEN',
  PHOTO_LIKES: 'PHOTO_LIKES',
  EVENT_INTERESTS: 'EVENT_INTERESTS',
  DATE_FINDER_INTEREST_SCREEN: 'DATE_FINDER_INTEREST_SCREEN',
  EVENT_SCREEN: 'EVENT_SCREEN',
  GROUP: 'GROUP',
  GROUP_DETAIL: 'GROUP_DETAIL',
  GROUP_NOTIFICATION: 'GROUP_NOTIFICATION',
  GROUP_MEMBER: 'GROUP_MEMBER',
  GROUP_MEMBER_FILTER: 'GROUP_MEMBER_FILTER',
  CREATE_GROUP: 'CREATE_GROUP',
  EVENT_DETAIL: 'EVENT_DETAIL',
  CREATE_EVENT: 'CREATE_EVENT',
  MY_EVENT: 'MY_EVENT',
  MY_GROUP_EVENTS_SCREEN: 'MY_GROUP_EVENTS_SCREEN',
  USER_MENU_SETTING: 'USER_MENU_SETTING',
  EDIT_PROFILE_SCREEN: 'EDIT_PROFILE_SCREEN',
  GENERAL_INFO_SCREEN: 'GENERAL_INFO_SCREEN',
  GENERAL_OPTION_SCREEN: 'GENERAL_OPTION_SCREEN',
  INTIMATE_INFO_SCREEN: 'INTIMATE_INFO_SCREEN',
  INTIMATE_OPTION_SCREEN: 'INTIMATE_OPTION_SCREEN',
  INTERESTS_INFO_SCREEN: 'INTERESTS_INFO_SCREEN',
  INTERESTS_OPTION_SCREEN: 'INTERESTS_OPTION_SCREEN',
  DESCRIPTION_INFO_SCREEN: 'DESCRIPTION_INFO_SCREEN',
  PARTNER_DESCRIPTION_INFO_SCREEN: 'PARTNER_DESCRIPTION_INFO_SCREEN',
  VERIFICATION_INFO_SCREEN: 'VERIFICATION_INFO_SCREEN',
  FACE_DETECTION_SCREEN: 'FACE_DETECTION_SCREEN',
  INTENTIONS_INFO_SCREEN: 'INTENTIONS_INFO_SCREEN',
  PARTICIPATION_LEVEL_SCREEN: 'PARTICIPATION_LEVEL_SCREEN',
  IDEAL_PARTNER_DETAIL_SCREEN: 'IDEAL_PARTNER_DETAIL_SCREEN',
  ACCOUNT_SETTING_SCREEN: 'ACCOUNT_SETTING_SCREEN',
  UPDATE_EMAIL_SCREEN: 'UPDATE_EMAIL_SCREEN',
  UPDATE_USERNAME_SCREEN: 'UPDATE_USERNAME_SCREEN',
  UPDATE_PASSWORD_SCREEN: 'UPDATE_PASSWORD_SCREEN',
  UPDATE_PHONE_NUMBER: 'UPDATE_PHONE_NUMBER',
  VERIFICATION_MOBILE_NUMBER: 'VERIFICATION_MOBILE_NUMBER',
  ADD_PHONE_NUMBER: 'ADD_PHONE_NUMBER',
  SELECT_COUNTRY: 'SELECT_COUNTRY',
  MY_LIST_SCREEN: 'MY_LIST_SCREEN',
  VALIDATION_SCREEN: 'VALIDATION_SCREEN',
  BLOCKED_LIST_SCREEN: 'BLOCKED_LIST_SCREEN',
  HIDDEN_LIST_SCREEN: 'HIDDEN_LIST_SCREEN',
  PRIVATE_ALBUM_ACCESS_SCREEN: 'PRIVATE_ALBUM_ACCESS_SCREEN',
  PRIVACY_SETTINGS_SCREEN: 'PRIVACY_SETTINGS_SCREEN',
  PROFILE_VIEW_SETTING_SCREEN: 'PROFILE_VIEW_SETTING_SCREEN',
  NOTIFICATION_SETTINGS_SCREEN: 'NOTIFICATION_SETTINGS_SCREEN',
  LEGAL_SCREEN: 'LEGAL_SCREEN',
  ADD_YOUR_PHOTOS: 'ADD_YOUR_PHOTOS',
  DATE_FINDER_SCREEN: 'DATE_FINDER_SCREEN',
  ADD_MY_DATE_FINDER_SCREEN: 'ADD_MY_DATE_FINDER_SCREEN',
  MY_DATE_FINDER_SCREEN: 'MY_DATE_FINDER_SCREEN',
  MY_TRAVEL_PLAN_SCREEN: 'MY_TRAVEL_PLAN_SCREEN',
  TRAVEL_PLAN_SCREEN: 'TRAVEL_PLAN_SCREEN',
  CREATE_TRAVEL_PLAN_SCREEN: 'CREATE_TRAVEL_PLAN_SCREEN',
  TRAVEL_DESTINATION_SCREEN: 'TRAVEL_DESTINATION_SCREEN',
  USER_SETTING_NAV: 'USER_SETTING_NAV',
  TOPIC_DETAIL: 'TOPIC_DETAIL',
  MY_FORUMS: 'MY_FORUMS',
  FORUM_SCREEN: 'FORUM_SCREEN',
  TOPIC_SEARCH_SCREEN: 'TOPIC_SEARCH_SCREEN',
  BOARDS_SCREEN: 'BOARDS_SCREEN',
  TOPIC_SCREEN: 'TOPIC_SCREEN',
  TOPIC_SUB_SCREEN: 'TOPIC_SUB_SCREEN',
  MY_TOPIC_SCREEN: 'MY_TOPIC_SCREEN',
  COMMUNITY_SCREEN: 'COMMUNITY_SCREEN',
  BLOG_DETAILS_SCREEN: 'BLOG_DETAILS_SCREEN',
  COMMUNITY_COMMENT_SCREEN: 'COMMUNITY_COMMENT_SCREEN',
  DELETE_ACCOUNT: 'DELETE_ACCOUNT',
  HOME_SCREEN: 'HOME_SCREEN',
  PAYMENT_METHOD: 'PAYMENT_METHOD',
  TOPIC_SEARCH_RESULT: 'TOPIC_SEARCH_RESULT',
  MANAGE_SUBSCRIPTIONS: 'MANAGE_SUBSCRIPTIONS',
  OTG_DETAILS_SCREEN: 'OTG_DETAILS_SCREEN',
  ACTIVE_SUBS: 'ACTIVE_SUBS',
  HELP_SUPPORT: 'HELP_SUPPORT',
  EVENT_INTEREST_SCREEN: 'EVENT_INTEREST_SCREEN',
  MAINTENANCE: 'MAINTENANCE',
  ACTIVE_NOW_SCREEN: 'ACTIVE_NOW_SCREEN',
  SUPPORT_SCREEN: 'SUPPORT_SCREEN',
  TICKET_LIST_SCREEN: 'TICKET_LIST_SCREEN',
  TECHNICAL_SUPPORT_SCREEN: 'TECHNICAL_SUPPORT_SCREEN',
  SUPPORT_CONTACT_SCREEN: 'SUPPORT_CONTACT_SCREEN',
  USER_LIKES_SCREEN: 'UserLikeScreen',
  MODAL_PROFILE: 'MemberProfile',
  MODAL_PROFILE_CONTAINER: 'ModalProfileContainer',
  COMMUNITY_SEARCH_RESULT: 'COMMUNITY_SEARCH_RESULT',
  PUSH_NOTIFICATION_SCREEN: 'PUSH_NOTIFICATION_SCREEN',
  PREMIUM_BENEFITS: 'PREMIUM_BENEFITS',
  COMPARE_MEMBERSHIPS: 'COMPARE_MEMBERSHIPS',
  SETTINGS_SCREEN: 'SETTINGS_SCREEN',
  SUBSCRIPTION_SCREEN: 'SUBSCRIPTION_SCREEN',
  PUSH_SETTINGS_OPTIONS: 'PUSH_SETTINGS_OPTIONS',
  ABOUT_RHP: 'ABOUT_RHP',
  LIVE_CHAT: 'LIVE_CHAT',
  MEMBER_SEARCH_FILERS: 'MEMBER_SEARCH_FILERS',
  MESSENGER_FILTER_SCREEN: 'MESSENGER_FILTER_SCREEN',
  LOCATION_SEARCH_SCREEN: 'LOCATION_SEARCH_SCREEN',
  PROSPECTS_FILTER_SCREEN: 'PROSPECTS_FILTER_SCREEN',
  DATE_FINDER_FILTER_SCREEN: 'DATE_FINDER_FILTER_SCREEN',
  EVENT_FILTER_SCREEN: 'EVENT_FILTER_SCREEN',
  GROUP_FILTER_SCREEN: 'GROUP_FILTER_SCREEN',
  TRAVEL_FILTER_SCREEN: 'TRAVEL_FILTER_SCREEN',
  ACTIVE_NOW_FILTER_SCREEN: 'ACTIVE_NOW_FILTER_SCREEN',
  CONVERSATION_MODAL: 'CONVERSATION_MODAL',
  MY_STORIES: 'MY_STORIES',
  ADD_EVENT_IMAGE: 'ADD_EVENT_IMAGE',
  COMPETITION: 'COMPETITION',
  DEMO_ANIMATION: 'DEMO_ANIMATION',
  PAYMENT_CREDIT: 'PAYMENT_CREDIT',
  UPDATE_CARD_DETAILS: 'UPDATE_CARD_DETAILS',
  RHP_STORE: 'RHP_STORE',
  RHP_PRODUCT_DETAILS: 'RHP_PRODUCT_DETAILS',
  RHP_STORE_CART: 'RHP_STORE_CART',
  RHP_STORE_CHECK_OUT: 'RHP_STORE_CHECK_OUT',
  RHP_ORDER_DETAILS: 'RHP_ORDER_DETAILS',
  MANAGE_ORDER: 'MANAGE_ORDER',
  SELECT_ACCOUNT_FORGOT: 'SELECT_ACCOUNT_FORGOT',
  EVENT_CLUB_PROFILE: 'EVENT_CLUB_PROFILE',
  EVENT_PARTICIPANTS: 'EVENT_PARTICIPANTS',
  EVENT_GROUP_CHAT: 'EVENT_GROUP_CHAT',
  MORE_STORIES_SCREEN: 'MORE_STORIES_SCREEN',
  VIEW_ALL_DATA: 'VIEW_ALL_DATA',
  MANAGE_DIAMONDS: 'MANAGE_DIAMONDS',
  EVENT_INTEREST_FILTER_SCREEN: 'EVENT_INTEREST_FILTER_SCREEN',
  AUTHOR_DETAILS: 'AUTHOR_DETAILS',
  POPULAR_AUTHORS: 'POPULAR_AUTHORS',
  QUICK_MESSAGE: 'QUICK_MESSAGE',
  PRIVACY_POLICY: 'PRIVACY_POLICY',
  TERMS_OF_USE: 'TERMS_OF_USE',
  COMMUNITY_GUIDELINES: 'COMMUNITY_GUIDELINES',
  SHARED_MEDIA: 'SHARED_MEDIA',
  RECENTLY_VALIDATED: 'RECENTLY_VALIDATED',
  RECENTLY_REVIEWS: 'RECENTLY_REVIEWS',
  RECENTLY_VALIDATED_FILTER: 'RECENTLY_VALIDATED_FILTER',
  LOGIN_SELECT_ACCOUNT: 'LOGIN_SELECT_ACCOUNT',
  EDIT_GROUP_CHAT: 'EDIT_GROUP_CHAT',
  MY_GROUP_CHATS: 'MY_GROUP_CHATS',
  SPOTLIGHT: 'SPOTLIGHT',
  SPOTLIGHT_PICK_DAILY: 'SPOTLIGHT_PICK_DAILY',
  MANAGE_ALBUMS_PHOTOS: 'MANAGE_ALBUMS_PHOTOS',
  IMAGE_LIGHT_BOX: 'IMAGE_LIGHT_BOX',
  IMAGE_DETAILS: 'IMAGE_DETAILS',
  SEND_GROUP_MESSAGE: 'SEND_GROUP_MESSAGE',
  HOME_SCREEN_FILTER: 'HOME_SCREEN_FILTER',
  WHO_CAN_JOIN_MY_GROUP: 'WHO_CAN_JOIN_MY_GROUP',
  CREATE_GROUP_POST: 'CREATE_GROUP_POST',
  MY_GROUPS: 'MY_GROUPS',
  CREATE_GROUP_ALBUM: 'CREATE_GROUP_ALBUM',
  GROUP_FILTER_BY_CATEGORIES: 'GROUP_FILTER_BY_CATEGORIES',
  GROUP_ALBUM_DETAILS: 'GROUP_ALBUM_DETAILS',
  GROUP_POST_DETAILS: 'GROUP_POST_DETAILS',
  GROUP_ACTIVITIES: 'GROUP_ACTIVITIES',
  GROUP_JOIN_REQUEST: 'GROUP_JOIN_REQUEST',
  GROUP_INVITATION: 'GROUP_INVITATION',
  EVENT_INVITATION: 'EVENT_INVITATION',
  MY_GROUP: 'MY_GROUP',
  GROUP_SUGGESTED_MEMBER: 'GROUP_SUGGESTED_MEMBER',
  GROUP_SUGGESTED_MEMBER_FILTER: 'GROUP_SUGGESTED_MEMBER_FILTER',
  SUGGESTED_GROUPS: 'SUGGESTED_GROUPS',
  JOINED_GROUPS: 'JOINED_GROUPS',
  PREVIEW_SCREEN: 'PREVIEW_SCREEN',
};

export const COMPONENT_NAME = {
  CONVERSATION_TOOLBAR: 'ConversationToolbar',
};

export const PAGING_DEFAULT = {
  PAGE_SIZE_CONVERSATION: 25,
  PAGE_SIZE_MESSAGE: 25,
  PAGE_SIZE_FRIEND: 10,
  PAGE_SIZE_MEMBER_SEARCH: 24,
  PAGE_SIZE_MEMBER_SEARCH_MOBILE: 10,
  PAGE_NUMBER: 1,
  PAGE_SIZE_SEARCH_USER_NAME: 200,
  PAGE_SIZE_LOAD_ORIGINAL: 100,
  PAGE_SIZE_NOW: -1,
  PAGE_SIZE_DATE_FINDER: 50,
};

export const UI_ACTION_NAME = {
  // Modal Conversation Menu: Prefix MCM
  EDIT_GROUP: 'EDIT_GROUP',
  VIEW_SHARED_MEDIA: 'VIEW_SHARED_MEDIA',
  MCM_ADD_OR_REMOVE_TO_FOLDER: 'MCM_ADD_OR_REMOVE_TO_FOLDER',
  MCM_PIN: 'MCM_PIN',
  MCM_UNPIN: 'MCM_UNPIN',
  MCM_DELETE: 'MCM_DELETE',
  MCM_IGNORE: 'MCM_IGNORE',
  MCM_UN_IGNORE: 'MCM_UN_IGNORE',
  MCM_REPORT: 'MCM_REPORT',
  MCM_BLOCK: 'MCM_BLOCK',

  // Modal Profile: Prefix MP
  MP_FAVORITE: 'MP_FAVORITE',
  MP_UNFAVORITE: 'MP_UNFAVORITE',
  MP_BLOCK: 'MP_BLOCK',
  MP_REPORT: 'MP_REPORT',
  MP_SEND_MESSAGE: 'MP_SEND_MESSAGE',
  MP_CANCEL: 'MP_CANCEL',

  // Filter Friends & Favorite: Prefix FFF
  FFF_FRIENDS_FAVORITES: 'FFF_FRIENDS_FAVORITES',
  FFF_ACTIVE_NOW: 'FFF_ACTIVE_NOW',
};

export const PAGE_NAMES = {
  MESSENGERS_INBOX: 'inbox',
  CONVERSATION: 'conversation',
  INBOX_DETAIL: 'inbox',
  LOGIN: 'login',
  HOME: 'home',
  COURSES: 'courses',
};

export const MSG_TEMPLATE = {
  base: {
    error: false,
    errorCode: '',
    errorText: '',
    // status default as sent if leave empty
    status: 'sending', // [sending, sent ,fail, read]
    id: '',
    // from cannot be deleted, it determines group id
    from: '',
    to: '',
    toJid: '',
    time: '',
    type: '', // chat / groupchat
    body: {},
    ext: {},
    bySelf: false,
    delay: '', // using for groupchat
    user: {},
    expts: 0,
    refMsgId: '',
    refMsgShortDesc: '',
    refMsgType: '',
    refMsgTitle: '',
    refUserId: '',
    refMsgIsDeleted: false,
    refDisplayName: '',
    refMsgExpTs: 0,
    reactions: {},
    opened: false,
    giftOpened: false,
    isHiddenByError: false,
    notificationType: '',
    profilePhotoComment: null,
    read: false,
    isDelete: false,
    edited: false,
  },
  reactions: {
    type: messageTypes.TYPE_REACTIONS,
    data: '', // old is msg
  },
  quote: {
    type: messageTypes.TYPE_QUOTE_MESSAGE,
    data: '', // old is msg
  },
  txt: {
    type: messageTypes.TYPE_TEXT,
    data: '', // old is msg
  },
  gift: {
    type: messageTypes.TYPE_GIFT,
    data: '', // old is msg
  },
  shareLocation: {
    type: messageTypes.TYPE_SHARE_LOCATION,
    data: null,
  },
  shareDate: {
    type: messageTypes.TYPE_SHARE_DATE,
    data: null,
  },
  shareEvent: {
    type: messageTypes.TYPE_SHARE_EVENT,
    data: null,
  },
  shareEventTicket: {
    type: messageTypes.TYPE_SHARE_EVENT_TICKET,
    data: null,
  },
  screenshot: {
    type: messageTypes.TYPE_TOOK_SCREEN_SHOT,
    data: null,
  },
  removedFromGroup: {
    type: messageTypes.TYPE_REMOVED_FROM_GROUP,
    data: null,
  },
  inviteGroupChat: {
    type: messageTypes.TYPE_INVITE_GROUP_CHAT,
    data: null,
  },
  gif: {
    type: messageTypes.TYPE_GIF,
    data: '', // old is msg
  },
  gallery: {
    // add new
    type: messageTypes.TYPE_GALLERY,
    data: '',
  },
  img: {
    type: messageTypes.TYPE_IMAGE,
    file_length: 0,
    filename: '',
    filetype: '',
    length: 0,
    secret: '',
    width: 0,
    height: 0,
    data: '', // old is url
    thumb: '',
    thumb_secret: '',
  },
  videoFile: {
    type: messageTypes.TYPE_VIDEO_FILE,
    file_length: 0,
    filename: '',
    filetype: '',
    length: 0,
    secret: '',
    width: 0,
    height: 0,
    data: '', // old is url
    thumb: '',
    thumb_secret: '',
    videoId: 0,
    videoUrl: '',
    thumbUrl: '',
    duration: 0,
    contentType: '',
  },
  audioFile: {
    type: messageTypes.TYPE_AUDIO_FILE,
    file_length: 0,
    fileName: '',
    ownerUserId: 0,
    filetype: '',
    length: 0,
    secret: '',
    width: 0,
    height: 0,
    data: '',
    thumb: '',
    thumb_secret: '',
    audioId: 0,
    duration: 0,
    contentType: '',
  },
  video: {
    type: messageTypes.TYPE_VIDEO,
    data: '',
  },
  liveStream: {
    type: messageTypes.TYPE_LIVE_STREAM,
    data: '',
  },
  heartMsg: {
    type: messageTypes.TYPE_HEART_MSG,
    data: '',
  },
  notification: {
    type: messageTypes.TYPE_NOTIFICATION,
    data: '',
  },
  leaveGroupChat: {
    type: messageTypes.TYPE_LEAVE_GROUP_CHAT,
    data: {
      userId: null,
      value: '',
    },
  },
  joinGroupChat: {
    type: messageTypes.TYPE_JOINED_GROUP_CHAT,
    data: {
      userId: null,
      value: '',
    },
  },
  fastenTxtEdit: {
    type: messageTypes.TYPE_FASTEN_EDIT,
    data: '',
  },
  inviteGroup: {
    type: messageTypes.TYPE_INVITE_GROUP,
    data: null,
  },
};

export const AVATAR_COLOR_RANGE = ['#1ABC9C', '#2ECC71', '#9B59B6', '#34495E', '#F1C40F', '#E67E22', '#E74C3C', '#95A5A6'];

export const FILTER_SEARCH_OPTIONS = [
  {
    name: 'AllConversations',
    id: 'all',
    active: true,
    nameDekstop: 'All',
    des: 'DesAllConversations',
  },
  // {name: 'Messages from my friends & favorites', id: 'friend_favorites'},
  {
    name: 'MessagesIHaveNotRead',
    id: 'not_read',
    nameDekstop: 'Unread',
    des: 'DesMessagesIHaveNotRead',
  },
  {
    name: 'MessagesIHaveNotRepliedTo',
    id: 'be_not_replied',
    nameDekstop: 'Unreplied',
    des: 'DesMessagesIHaveNotRepliedTo',
  },
  {
    name: 'MessagesWhichNotReplied',
    id: 'sent',
    nameDekstop: 'Sent',
    des: 'DesMessagesWhichNotReplied',
  },
];

export const FILTER_FRIEND_AND_FAVOURITE_OPTIONS = [
  { name: 'Friends & Favourites', active: true, value: 'Favourites', index: 0 },
  { name: 'Mutual matches', value: 'MutualMatch', index: 1 },
  { name: 'Active now', value: 'Active', index: 2 },
];

export const PROFILE_SEARCH_TYPE = {
  MutualMatch: 'MutualMatch',
  Favourites: 'Favourites',
  Active: 'Active',
};

export const PROFILE_SEARCH_TYPE_INDEX = {
  MutualMatch: 1,
  Favourites: 0,
  Active: 2,
};

export const SETTING_MESSENGER = [{ name: 'Friends & Favourites' }, { name: 'Mutual matches' }, { name: 'Active now' }];

export const FILTER_FRIEND_AND_FAVOURITE = {
  MOBILE_TOOLTIP_ID: 'MOBILE_TOOLTIP_ID',
  MOBILE_ICON_TRIANGLE_ID: 'MOBILE_ICON_TRIANGLE_ID',
};

export const FILTER_CONVERSATION_OPTIONS_TYPE = {
  ALL: 'all_conversation',
  MATCHING: 'matching_member',
  NON_MATCHING: 'non_matching_member',
  UNREAD_MATCHING: 'unread_matching',
  UN_REPLIED_MATCHING: 'un_replied_matching',
  SENT_MATCHING: 'sent_matching',
  UNREAD: 'unread',
  UN_REPLIED: 'unreplied',
};

export const FILTER_CONVERSATION_OPTIONS_MOBILE = [
  {
    name: 'AllConversations',
    des: 'DesAllConversations',
    id: FILTER_CONVERSATION_OPTIONS_TYPE.ALL,
    title: 'All',
    nameDekstop: 'All',
    // active: true,
  },
  {
    name: 'AllMatchingConversations',
    des: 'DesAllMatchingConversations',
    // name: 'AllMatchingConversations',
    id: FILTER_CONVERSATION_OPTIONS_TYPE.MATCHING,
    title: 'Matching',
    active: true,
    nameDekstop: 'All',
  },
  {
    name: 'MessagesIHaveNotRead',
    des: 'DesMessagesIHaveNotRead',
    // name: 'MatchingMessagesIHaveNotRead',
    id: FILTER_CONVERSATION_OPTIONS_TYPE.UNREAD_MATCHING,
    title: 'Unread matching',
    nameDekstop: 'Unread',
  },
  {
    name: 'MessagesIHaveNotRepliedTo',
    des: 'DesMessagesIHaveNotRepliedTo',
    // name: 'MatchingMessagesIHaveNotRepliedTo',
    id: FILTER_CONVERSATION_OPTIONS_TYPE.UN_REPLIED_MATCHING,
    title: 'Unreplied matching',
    nameDekstop: 'Unreplied',
  },
  {
    name: 'AllMessagesWhichNotReplied',
    // name: 'MessagesWhichNotReplied',
    des: 'DesMessagesWhichNotReplied',
    id: FILTER_CONVERSATION_OPTIONS_TYPE.SENT_MATCHING,
    title: 'Sent but not received reply',
    nameDekstop: 'Sent',
  },
  {
    name: 'ConversationNonMatching',
    des: 'DesConversationNonMatching',
    id: FILTER_CONVERSATION_OPTIONS_TYPE.NON_MATCHING,
    title: 'Non-matching',
  },
];

export const FILTER_ICON_ID = {
  IC_ID_FF: 'IC_ID_FF',
  IC_ID_CONVERSATION: 'IC_ID_CONVERSATION',
  IC_ID_FILTER_OPTION: 'IC_ID_FILTER_OPTION',
};

export const TOOLTIP_ID = {
  TOOLTIP_CONVERSATION_ID: 'TOOLTIP_CONVERSATION_ID',
  MOBILE_TOOLTIP_CONVERSATION_ID: 'MOBILE_TOOLTIP_CONVERSATION_ID',
  ICON_CONVERSATION_TRIANGLE_ID: 'ICON_CONVERSATION_TRIANGLE_ID',
  MOBILE_ICON_CONVERSATION_TRIANGLE_ID: 'MOBILE_ICON_CONVERSATION_TRIANGLE_ID',
  TOOLTIP_OPTIONS_ID: 'TOOLTIP_OPTIONS_ID',
  ICON_OPTIONS_TRIANGLE_ID: 'ICON_OPTIONS_TRIANGLE_ID',
};

export const FILTER_CONVERSATION_OPTIONS_DESKTOP = [
  {
    name: 'All',
    id: FILTER_CONVERSATION_OPTIONS_TYPE.ALL,
    title: 'All',
    active: true,
  },
  {
    name: 'Matching',
    id: FILTER_CONVERSATION_OPTIONS_TYPE.MATCHING,
    title: 'Matching',
    active: false,
  },
  // {name: 'Non matching', id: FILTER_CONVERSATION_OPTIONS_TYPE.NON_MATCHING, title: 'Non matching', active: false}
];

export const PRIMARY_FILTER = {
  ALL: 0,
  MATCHING: 1,
  UNREAD_MATCHING: 2,
  UNREPLIED_MATCHING: 3,
  MESSAGE_SENT: 4,
  IN_GROUP_CHAT: 5,
  NOT_IN_GROUP_CHAT: 6,
};

export type PrimaryFilterType = (typeof PRIMARY_FILTER)[keyof typeof PRIMARY_FILTER];

export const SECONDARY_FILTER = {
  ALL_MESSAGES: 0,
  // MESSAGES_FRIEND_AND_FAVOURITE: 1,
  MESSAGES_NOT_READ: 1,
  MESSAGE_NOT_REPLIED: 2,
  MESSAGE_SENT: 3,
  MESSAGE_NON_MATCHING: 4,
  MESSAGES_READ: 5,
  MESSAGES_IGNORED: 6,
};

export type SecondaryFilterType = (typeof SECONDARY_FILTER)[keyof typeof SECONDARY_FILTER];

export const CHAT_TYPES = {
  CHAT: 'chat',
  GROUP_CHAT: 'groupchat',
} as const;

export type ChatType = (typeof CHAT_TYPES)[keyof typeof CHAT_TYPES];

export const VIDEO_FILE_TYPES = ['video/mp4', 'video/mov', 'video/quicktime', 'mp4', 'mov'] as string[];
export const AUDIO_FILE_TYPES = ['audio/mp3', 'audio/mpeg', 'audio/wav', 'mp3', 'wav', 'audioFile'] as string[];

export const MEDIA_TYPES = {
  gif: 1,
  bmp: 1,
  jpg: 1,
  png: 1,
  jpeg: 1,
  mp4: 1,
  mov: 1,
};

export const CONVERSATION_STATUS = {
  NORMAL: 1,
  GET_ACCESS: 2,
  GET_ACCESS_MORE: 3,
  MESSAGE_RESET_24H: 4,
  CAN_NOT_SEND: 5,
  ERROR_OCCUR: 6,
  UNAUTHORIZE_AUS: 7,
  INBOX_LOCKED: 8,
  WAITINGAPPROVAL: 9,
  USERNAME_REJECT: 10,
  ACCOUNT_VERIFICATION_REQUIRED: 11,
  UNAUTHORIZED: 12,
  REQUIRE_VERIFICATION: 14,
  RECEIVER_REQUIRE_VERIFICATION: 15,
  SENDER_REQUIRES_RECEIVER_VERIFICATION: 16,
  SENDER_BANNED: 17,
};

export type ConversationStatusType = (typeof CONVERSATION_STATUS)[keyof typeof CONVERSATION_STATUS];

export const STORY_STATUS = {
  Draft: 'Draft',
  Rejected: 'Rejected',
  Finished: 'Finished',
};

export const CONVERSATION_PARAMS = ['d', 'userName', 'curNode', 'isEmpty'];

export const MESSAGE_WIDTH_MOBILE = 286;
export const DISABLE_OOLBAR = 'disable_conversation_toolbar';

export const MEMBER_TYPES = {
  DIAMOND: 99,
  PLATINUM_DIAMOND: 9,
  PLATINUM: 4,
  PREMIUM_PLUS: 3,
  PREMIUM: 2,
  GUEST: 1,
  PLUS: 101,
  EXTRAS: 102,
};

export type MemberShipType = (typeof MEMBER_TYPES)[keyof typeof MEMBER_TYPES];

export type MemberType = (typeof MEMBER_TYPES)[keyof typeof MEMBER_TYPES];

export const CLUB_MEMBER_TYPE = {
  1: 'Member',
  2: 'Admin',
  3: 'NA',
};

export const MEMBER_TYPE_TITLES = {
  Man: 'M{old}',
  Woman: 'F{old}',
  'Couple MF': 'M{old} F{old}',
  Group: 'G{old}',
  'Couple FF': 'F{old} F{old}',
  'Couple MM': 'M{old} M{old}',
  Transvestite: 'T{old}',
  TW: 'TW{old}',
  TM: 'TM{old}',
};

export const HISTORY_DIRECTION_TYPE = {
  BACKWARD: 1,
  FORWARD: 2,
};

// ID OF ELEMENT

export const ELEMENT_ID = {
  FILTER_FRIEND_AND_FAVOURITE: 'FILTER_FRIEND_AND_FAVOURITE',
  MOBILE_FILTER_CONVERSATION: 'MOBILE_FILTER_CONVERSATION',
  MOBILE_FF_TEXT: 'MOBILE_FF_TEXT',
  MOBILE_CONVERSATION_TEXT: 'MOBILE_CONVERSATION_TEXT',
  APP: 'app',
  MAIN_APP: 'rhpAppMain',
};

export const MESSAGE_GET_ACCESS = {
  GET_ACCESS_TO_CHAT: 'GET ACCESS TO CHAT',
  MESSAGE_COUNT_RESET_24H: 'MESSAGE COUNT RESET IN 24 HRS',
  GET_ACCESS_TO_MORE_CHAT: 'GET ACCESS TO MORE CHAT',
};

export const DEVICE_TYPE = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
  TABLET: 'tablet',
};

export const IMAGE_DIMENSION = {
  LANDSCAPE: 'landscape',
  PORTRAIT: 'portrait',
};

export const MESSAGE_POSITION = {
  LEFT: 'left',
  RIGHT: 'right',
};

export const SPECIAL_MESSAGE_TEXT = {
  DELETE: 'This message has been removed',
  DELETE_GALLERY: 'Private album unavailable',
  DECLINED_GALLERY: 'Private album unavailable',
  DELETE_IMAGE: 'This photo has been removed',
  DELETE_VIDEO_FILE: 'This video has been removed',
  DELETE_AUDIO_FILE: 'This message has been removed',
  EXPIRED_IMAGE: 'This photo has expired',
  EXPIRED_VIDEO: 'This video has expired',
  EXPIRED_AUDIO: 'This message has expired',
  DELETE_GIF: 'This GIF has been removed',
  DELETE_GIFT: 'This GIFT has been removed',
  TYPING: 'Typing...',
};

export const MESSAGE_STATUS = {
  READ: 'Read',
  RECEIVER: 'Read',
};

export const DATE_FORMAT = {
  HOURS: 'H:MM',
  HOURS_12: 'h:mm a',
  CHAT_TIME: 'MMM DD',
  CHAT_TIME_2: 'DD MMM',
  CHAT_TIME_3: 'MMM DD, YYYY',
  TODAY: 'Today',
  YESTERDAY: 'Yesterday',
  CHAT_TIME_4: 'DD MMM YYYY', // 24 May 2020,
  CHAT_TIME_5: 'MMM DD YYYY', // May 24 2020
  COMMUNITY_CREATED_DATE_FORMAT: 'MMMM DD, YYYY',
  CHAT_TIME_6: 'ddd MMM DD YYYY', // Tue Apr 20 2021
  CHAT_TIME_7: 'MMMM Do YYYY',
  CHAT_TIME_8: 'ddd MMM DD',
  TYPE_1: 'DD/MM/YYYY',
  TYPE_2: 'MM/DD/YYYY',
  TYPE_3: 'yyyy-MM-DD',
  TYPE_4: 'YYYY-MM-DD',
  TYPE_5: 'DD/MM/YY',
  TYPE_6: 'YYYY/MM/DD',
};

export const PUSHY = {
  PUSHY_TOKEN: 'pushyToken',
  PUSHY_TOKEN_AUTH: 'pushyTokenAuth',
  PUSHY_TOKEN_APP_ID: 'pushyTokenAppId',
};

export const PERSIST_KEY = 'persist:rhp-root';

export const SESSIONS = {
  RHP_TOKEN: 'apiToken',
  RHP_REFRESH_TOKEN: 'apiTokenRefresh',
  MESSENGER_TOKEN: 'XMPPToken',
  JID_RESOURCE: 'JidResource',
  IS_REMEMBER_ME: 'isRememberMe',
  VISA: 'visa',
  NO_INTERNET: 'noInternet',
  DEVICE_TOKEN_PUSHY: 'pushyToken',
  MESSENGER_BUFFER_STORAGE: 'messengerBufferStorage',
  TOOLTIP_GIFT: 'isDisableTooltipGift',
  TOOLTIP_BOOST_GIFT: 'isDisableTooltipBoostGift',
  BOOST_DATA_TOOLTIP: 'boostDataTooltip',
  PERSIST: 'persist:rhp-root',
  AUTO_SHOW_VERIFIED_TOOLTIP: 'autoShowVerifiedTooltip',
  JOIN_TOKEN: 'joinToken',
  BIOMETRIC_DATA: 'biometricData',
  SECURITY_BIOMETRIC_LEVEL: 'securityBiometricLevel',
  LASTED_LOGGED_USER_NAME: 'lastedLoggedUsername',
  ASK_ENABLE_BIOMETRIC_OBJECT: 'askEnableBiometricObject',
  DO_NOT_ASK_ENABLE_BIOMETRIC_OBJECT: 'doNotAskEnableBiometricObject',
};

export const CHAT_STATUS_TIME = {
  WAIT: 10000,
  COMPOSING: 3000,
  PAUSED: 10000,
};

export const FRIENDS_FAVOURITES_FILTER_OPTION = {
  ALL: 0,
  MATCH: 1,
  ACTIVE: 2,
};

export const CATEGORY_ITEM_FILTER_STATUS = {
  NORMAL: 0,
  SELECTING: 1,
  SELECTED: 2,
  SKIPPED: 3,
};

export const PROPERTY_ITEM_FILTER_STATUS = {
  NORMAL: 0,
  SELECTED: 1,
};

export const SEARCH_PLACE = {
  DELAY: 500,
};

export const ITEM_INTEREST_STATUS = {
  NORMAL: 0,
  SELECTED: 1,
};

export const LOOKING_TO_MEET = {
  FILTER_CATEGORY: {
    LOOKING_FOR_ID: 'LOOKING_FOR_ID',
    AGE_RANGE_ID: 'AGE_RANGE_ID',
    INTENTIONS: 'INTENTIONS',
  },
};

export const SUB_CONTENT_TYPE = {
  TEXT: 'TEXT',
  ROUND_BORDER_TAB: 'ROUND_BORDER_TAB',
};

export const FILTER_CONTENT_TYPE = {
  FILTER_PROPERTY_GRID: 'FILTER_PROPERTY_GRID',
  AGE_SLIDER: 'AGE_SLIDER',
};

export const FILTER_PROPERTY_TYPE = {
  FILTER_PROPERTY_ITEM: 'FILTER_PROPERTY_ITEM',
  FILTER_PROPERTY_ITEM_CHECKBOX: 'FILTER_PROPERTY_ITEM_CHECKBOX',
};

export const OS_PLATFORM = {
  IOS: 'iOS',
  ANDROID: 'Android',
  WINDOWS_PHONE: 'Windows Phone',
  UNKNOW: 'unknown',
};

export const INPUT_TYPE = {
  PASSWORD: 'password',
  TEXT: 'text',
};

export const SCREENS_AVOID_BACK_SCREEN = {
  [SCREENS_NAME.LOOKING_TO_MEET]: true,
  [SCREENS_NAME.TELL_US_ABOUT_YOURSELF_1]: true,
  [SCREENS_NAME.TELL_US_ABOUT_YOURSELF_2]: true,
  [SCREENS_NAME.WHAT_ARE_YOUR_INTERESTS]: true,
  [SCREENS_NAME.INTRODUCE_YOURSELF]: true,
  [SCREENS_NAME.VIDEO_FULL_SCREEN]: true,
  [SCREENS_NAME.NOTIFICATION]: true,
  [SCREENS_NAME.CONVERSATION]: true,
  [SCREENS_NAME.CHAT_ROOMS]: true,
  [SCREENS_NAME.EDIT_PROFILE_SCREEN]: true,
  [SCREENS_NAME.GENERAL_INFO_SCREEN]: true,
  [SCREENS_NAME.GENERAL_OPTION_SCREEN]: true,
  [SCREENS_NAME.INTIMATE_INFO_SCREEN]: true,

  [SCREENS_NAME.INTIMATE_OPTION_SCREEN]: true,
  [SCREENS_NAME.PARTICIPATION_LEVEL_SCREEN]: true,
  [SCREENS_NAME.INTERESTS_INFO_SCREEN]: true,
  [SCREENS_NAME.INTERESTS_OPTION_SCREEN]: true,

  [SCREENS_NAME.DESCRIPTION_INFO_SCREEN]: true,
  [SCREENS_NAME.IDEAL_PARTNER_DETAIL_SCREEN]: true,

  [SCREENS_NAME.PARTNER_DESCRIPTION_INFO_SCREEN]: true,
  [SCREENS_NAME.INTENTIONS_INFO_SCREEN]: true,
  [SCREENS_NAME.UPDATE_EMAIL_SCREEN]: true,
  [SCREENS_NAME.UPDATE_PASSWORD_SCREEN]: true,
  [SCREENS_NAME.UPDATE_PHONE_NUMBER]: true,
  [SCREENS_NAME.UPDATE_USERNAME_SCREEN]: true,
  [SCREENS_NAME.ADD_PHONE_NUMBER]: true,
  [SCREENS_NAME.VERIFICATION_MOBILE_NUMBER]: true,
  [SCREENS_NAME.NOTIFICATION]: true,
  [SCREENS_NAME.FRIENDS_SCREEN]: true,
  [SCREENS_NAME.VALIDATION_SCREEN]: true,
  [SCREENS_NAME.PRIVATE_ALBUM_ACCESS_SCREEN]: true,
  [SCREENS_NAME.BLOCKED_LIST_SCREEN]: true,
  [SCREENS_NAME.HIDDEN_LIST_SCREEN]: true,
  [SCREENS_NAME.MESSENGERS_SETTINGS]: true,
  [SCREENS_NAME.VERIFICATION_INFO_SCREEN]: true,
  [SCREENS_NAME.USER_INFO_SETTING]: true,
};

export const ITEM_TYPE = {
  SEXUAL_INTEREST1: 71,
  SEXUAL_INTEREST2: 72,
  SEXUAL_PREFERENCES: 70,
};

export const DEFAULT_AGE = 18;
export const MAX_AGE = 100;

export const SCREEN_PARAMS = {
  NAVIGATION_HEIGHT: 30,
  CUSTOM_BUTTON_BOTTOM_HEIGHT: 45,
};

export const PROSPECTS_DATAKEY = {
  USER_PROFILE_VIEW_TYPE_VIEW_ME: 'userProfileViewTypeViewMe',
  USER_PROFILE_VIEW_TYPE_VIEWED: 'userProfileViewTypeViewed',
  // FAV
  USER_LIKES_TYPE_LIKED_ME: 'userUserLikesTypeLikedMe',
  USER_LIKES_TYPE_HAVE_LIKED: 'userUserLikesTypeHaveLiked',
  // LIKE
  LIKES_TYPE_LIKED_ME: 'likesTypeLikedMe',
  LIKES_TYPE_HAVE_LIKED: 'likesTypeHaveLiked',
  // MATCH
  USER_MATCH: 'userUserMatch',
};
export type ProspectsDataKeyType = (typeof PROSPECTS_DATAKEY)[keyof typeof PROSPECTS_DATAKEY];

export const PROFILE_OPTION_DROPDOWN_PAGE = {
  PROSPECT: 'prospect',
  PROFILE: 'profile',
};

export const FRIENDS_DATAKEY = {
  FRIENDS: 'FRIENDS',
  FRIENDS_REQUEST: 'FRIENDS_REQUEST',
};
export const PRIVATE_ALBUM_TAB = {
  SENT: 'SENT',
  RECEIVED: 'RECEIVED',
};

export const FORUM_DATAKEY = {
  FOLLOWING: 'followingTopic',
  MY_TOPIC: 'myTopic',
  NEWEST_TOPIC: 'newestTopic',
  TRENDING_TOPIC: 'trendingTopic',
  FORUM_TOPIC: 'forumTopic',
  SUB_FORUM_TOPIC: 'subForumTopic',
};

export const VALIDATIONS_DATAKEY = {
  MY_VALIDATIONS: 'MY_VALIDATIONS',
  VALIDATION_SENT: 'VALIDATION_SENT',
};

export const PRIVATE_ALBUM_DATAKEY = {
  SENT: 'SENT',
  RECEIVED: 'RECEIVED',
};

export const DATE_FINDER_DATAKEY = {
  ANY_DATES: 'AnyDates',
  THIS_WEEK: 'ThisWeek',
  NEXT_WEEK: 'NextWeek',
  CUSTOM_DATE: 'CustomDate',
};
export const COMMUNITY_DATAKEY = {
  BLOGS: 'BLOG',
  STORIES: 'STORIES',
  OTG: 'OTG',
  TESTIMONIALS: 'TESTIMONIALS',
  OTG_PHOTO: 'OTG_PHOTO',
  OTG_GALLERY: 'OTG_GALLERY',
  ASK_SAMANTHA: 'ASK_SAMANTHA',
  GROUP_ALBUM: 'GROUP_ALBUM',
};
export const PROSPECT_TYPE_PARAMS = {
  ON: 'on',
  OFF: 'off',
  NEW_PWD: 'new-password',
};
export const TYPE_OPEN_URL = {
  OPEN_NEW_WINDOW: '_blank',
  CURRENT_TAB: '_self',
};
export const MEMBER_LEVEL = {
  GUEST: 'Guest',
  PLUS: 'Plus',
  EXTRAS: 'Extras',
  PLUS_EXTRAS: 'PlusExtras',
  PREMIUM: 'Premium',
  PREMIUM_PLUS: 'PremiumPLUS',
  PLATINUM: 'Platinum',
  DIAMOND: 'PlatinumDiamond',
};

export type MemberLevelType = (typeof MEMBER_LEVEL)[keyof typeof MEMBER_LEVEL];

export const GROUP_ALERT_TYPE = {
  ALBUM_APPROVED: 'GroupAlbumApproved',
  ALBUM_REJECTED: 'GroupAlbumRejected',
  CLUB_POST_APPROVED: 'ClubPostApproved',
  CLUB_POST_REJECTED: 'ClubPostRejected',
  // CLUB_PHOTO_APPROVED: 'ClubPhotoApproved',
  CLUB_PHOTO_APPROVED: 'ClubPostPhotoApproved',
  CLUB_PHOTO_REJECTED: 'ClubPostPhotoRejected',
  CLUB_EVENT_APPROVED: 'ClubEventApproved',
  CLUB_EVENT_REJECTED: 'ClubEventRejected',
  // CLUB_VIDEO_APPROVED: 'ClubVideoApproved',
  // CLUB_VIDEO_REJECTED: 'ClubVideoRejected',
  CLUB_VIDEO_APPROVED: 'ClubPostVideoApproved',
  CLUB_VIDEO_REJECTED: 'ClubPostVideoRejected',
  GROUP_APPROVED: 'GroupApproved',
  GROUP_REJECTED: 'GroupRejected',
  CLUB_NAME_REJECT: 'ClubNameRejected',
  CLUB_DES_REJECT: 'ClubDescriptionRejected',
  CLUB_RULE_REJECT: 'ClubRulesRejected',
};

export const GROUP_TAB_ID = {
  ABOUT: 1,
  POSTS: 2,
  PHOTOS: 3,
  VIDEOS: 4,
  ALBUMS: 5,
  EVENTS: 6,
  REVIEWS: 7,
  CHATS: 8,
};

export const GROUP_TAB_MEMBER = {
  MEMBERS: 1,
  REQUEST: 2,
};

export const TABS_MENU = {
  MOBILE: [
    { id: 1, name: 'Featured', url: '/member' },
    { id: 2, name: 'Matching', url: '/' },
    { id: 3, name: 'Newest', url: '/' },
    { id: 4, name: 'Active', url: '/' },
  ],
  DESKTOP: [
    { id: 1, name: 'Featured', url: '/member' },
    { id: 2, name: 'Matching', url: '/' },
    { id: 3, name: 'Newest', url: '/' },
    { id: 4, name: 'Recently active', url: '/' },
    { id: 5, name: 'Traveling', url: '/' },
  ],
  REFINE_MODAL: [
    { id: 1, name: 'Show' },
    { id: 2, name: 'Sort' },
    { id: 3, name: 'More' },
    { id: 4, name: 'Saved' },
  ],
  PROSPECTS_MOBILE: [
    {
      id: 1,
      key: 'Views',
      tabKey: 'VIEWS',
      name: 'Views',
      title: 'Views',
      isSelected: true,
      isExpand: true,
      countNum: 0,
      subTabs: [
        {
          id: 1,
          label: 'Viewed me',
          isSelected: true,
          dataKey: PROSPECTS_DATAKEY.USER_PROFILE_VIEW_TYPE_VIEW_ME,
          type: PROSPECT_TYPE_PARAMS.ON,
        },
        {
          id: 2,
          label: 'I have viewed',
          isSelected: false,
          dataKey: PROSPECTS_DATAKEY.USER_PROFILE_VIEW_TYPE_VIEWED,
          type: PROSPECT_TYPE_PARAMS.OFF,
        },
      ],
    },
    {
      id: 4,
      key: 'Likes',
      tabKey: 'LIKES',
      name: `Likes`,
      title: 'Likes',
      isSelected: false,
      isExpand: true,
      countNum: 3,
      subTabs: [
        {
          id: 1,
          label: `Liked me`,
          isSelected: true,
          dataKey: PROSPECTS_DATAKEY.LIKES_TYPE_LIKED_ME,
          type: PROSPECT_TYPE_PARAMS.ON,
        },
        {
          id: 2,
          label: `I have Liked`,
          isSelected: false,
          dataKey: PROSPECTS_DATAKEY.LIKES_TYPE_HAVE_LIKED,
          type: PROSPECT_TYPE_PARAMS.OFF,
        },
      ],
    },
    {
      id: 2,
      tabKey: 'FAVOURITES',
      name: `Fav's`,
      key: `Fav's`,
      title: `Fav's`,
      isSelected: false,
      isExpand: true,
      countNum: 3,
      subTabs: [
        {
          id: 1,
          label: `Fav'ed me`,
          isSelected: true,
          dataKey: PROSPECTS_DATAKEY.USER_LIKES_TYPE_LIKED_ME,
          type: PROSPECT_TYPE_PARAMS.ON,
        },
        {
          id: 2,
          label: `I have Fav'ed`,
          isSelected: false,
          dataKey: PROSPECTS_DATAKEY.USER_LIKES_TYPE_HAVE_LIKED,
          type: PROSPECT_TYPE_PARAMS.OFF,
        },
      ],
    },
    {
      id: 3,
      tabKey: 'MATCHES',
      name: 'Matches',
      title: 'Matches',
      key: 'Matches',
      isSelected: false,
      isExpand: false,
      countNum: 0,
      subTabs: [
        {
          id: 1,
          label: '',
          isSelected: true,
          dataKey: PROSPECTS_DATAKEY.USER_MATCH,
          type: PROSPECT_TYPE_PARAMS.OFF,
        },
      ],
    },
  ],
  TAB_BAR_BOTTOM: [
    {
      id: 1,
      icTab: images.icFooterHome,
      icTabActive: images.icFooterHomeActive,
      badge: 0,
    },
    {
      id: 2,
      icTab: images.icFooterMsg,
      icTabActive: images.icFooterMsgActive,
      badge: 0,
    },
    {
      id: 3,
      icTab: images.icFooterDiscover,
      icTabActive: images.icFooterDiscoverActive,
      badge: 0,
    },
    {
      id: 4,
      icTab: images.icFooterProspect,
      icTabActive: images.icFooterProspectActive,
      badge: 0,
    },
    {
      id: 5,
      icTab: images.icFooterSetting,
      icTabActive: images.icFooterSettingActive,
      badge: 0,
    },
  ],
  FRIENDS_MOBILE: [
    {
      id: 1,
      name: FRIENDS_DATAKEY.FRIENDS,
      label: 'Friends',
      isSelected: false,
    },
    {
      id: 2,
      name: FRIENDS_DATAKEY.FRIENDS_REQUEST,
      label: 'Friend Requests',
      isSelected: true,
    },
  ],
  PRIVATE_ALBUM_MOBILE: [
    {
      id: 1,
      name: PRIVATE_ALBUM_TAB.SENT,
      label: 'Sent',
      isSelected: true,
    },
    {
      id: 2,
      name: PRIVATE_ALBUM_TAB.RECEIVED,
      label: 'Received',
      isSelected: false,
    },
  ],
  VALIDATIONS_MOBILE: [
    {
      id: 1,
      name: VALIDATIONS_DATAKEY.MY_VALIDATIONS,
      label: 'My validations',
      isSelected: true,
    },
    {
      id: 2,
      name: VALIDATIONS_DATAKEY.VALIDATION_SENT,
      label: 'Validations sent',
      isSelected: false,
    },
  ],
  PRIVATE_ALBUM_ACCESS: [
    {
      id: 1,
      name: PRIVATE_ALBUM_DATAKEY.SENT,
      label: 'Sent',
      isSelected: true,
    },
    {
      id: 2,
      name: PRIVATE_ALBUM_DATAKEY.RECEIVED,
      label: 'Received',
      isSelected: false,
    },
  ],
  CHATROOMS: [
    {
      id: 1,
      name: 'Chatrooms',
      isExpand: false,
      countNum: 0,
      subTabs: [
        {
          id: 1,
          label: '',
          isSelected: true,
          dataKey: '',
        },
      ],
    },
    {
      id: 2,
      name: 'Live streams',
      isExpand: false,
      countNum: 0,
      subTabs: [
        {
          id: 1,
          label: '',
          isSelected: true,
          dataKey: '',
        },
      ],
    },
  ],
  EVENT_DETAIL: [
    {
      id: 1,
      name: 'Information',
    },
    {
      id: 2,
      name: 'Comments',
    },
  ],
  SHARED_MEDIA_TAB: [
    { id: 1, label: 'SharedMediaModal.PhotosVideos', isSelected: false },
    { id: 2, label: 'SharedMediaModal.PrivateAlbum', isSelected: false },
  ],
  UPGRADE_MEMBER_SHIP: [
    {
      id: UPGRADE_MEMBER_SHIP_ID.PLUS,
      name: 'Plus',
      description: 'FeedHome.PlusDes',
      upgradeButtonLabel: 'GetPlus',
      color: '#46A5F7',
      color2: '#46A5F7',
      textColor: '#FFFFFF',
      textColor2: '#FFFFFF',
      classicColor: '#46A5F7',
      classicTextColor: '#FFFFFF',
      cost: [
        { id: 1, month: 6, price: '258,166' },
        { id: 2, month: 3, price: '359,666' },
        {
          id: 3,
          month: 1,
          price: '739,000',
        },
      ],
      memberLevelValue: MEMBER_TYPES.PLUS,
      memberLevel: MEMBER_LEVEL.PLUS,
    },
    {
      id: UPGRADE_MEMBER_SHIP_ID.PREMIUM,
      name: 'Premium',
      description: 'FeedHome.PremiumDes',
      upgradeButtonLabel: 'GetPremium',
      color: '#F4AF01',
      color2: '#F4AF01',
      textColor: '#333333',
      textColor2: '#FFFFFF',
      classicColor: '#F4AF01',
      classicTextColor: '#333333',
      cost: [
        { id: 1, month: 6, price: '258,166' },
        { id: 2, month: 3, price: '359,666' },
        {
          id: 3,
          month: 1,
          price: '739,000',
        },
      ],
      memberLevelValue: MEMBER_TYPES.PREMIUM,
      memberLevel: MEMBER_LEVEL.PREMIUM,
    },
    {
      id: UPGRADE_MEMBER_SHIP_ID.PREMIUM_PLUS,
      name: `Premium`,
      description: 'FeedHome.PremiumPlusDes',
      upgradeButtonLabel: 'GetPremium',
      upgradeButtonAddLabel: '+',
      addName: '+',
      color: '#F76B46',
      color2: '#F76B46',
      textColor: '#FFFFFF',
      textColor2: '#FFFFFF',
      classicColor: '#F76B46',
      classicTextColor: '#FFFFFF',
      cost: [
        { id: 1, month: 6, price: '349,833' },
        { id: 2, month: 3, price: '516,333' },
        {
          id: 3,
          month: 1,
          price: '1,059,000',
        },
      ],
      memberLevelValue: MEMBER_TYPES.PREMIUM_PLUS,
      memberLevel: MEMBER_LEVEL.PREMIUM_PLUS,
    },
    {
      id: UPGRADE_MEMBER_SHIP_ID.PLATINUM,
      name: 'Platinum',
      description: 'FeedHome.PlatinumDes',
      upgradeButtonLabel: 'GetPlatinum',
      color: '#333333',
      color2: '#FFFFFF',
      textColor: '#333333',
      textColor2: '#FFFFFF',
      classicColor: '#333333',
      classicTextColor: '#FFFFFF',
      cost: [
        { id: 1, month: 6, price: '516,500' },
        { id: 2, month: 3, price: '733,000' },
        {
          id: 3,
          month: 1,
          price: '1,549,000',
        },
      ],
      memberLevelValue: MEMBER_TYPES.PLATINUM,
      memberLevel: MEMBER_LEVEL.PLATINUM,
    },
    {
      id: UPGRADE_MEMBER_SHIP_ID.DIAMOND,
      name: 'Diamond',
      description: 'FeedHome.DiamondDes',
      upgradeButtonLabel: 'GetDiamond',
      color: '#333333',
      color2: '#FFFFFF',
      textColor: '#333333',
      textColor2: '#FFFFFF',
      classicColor: '#333333',
      classicTextColor: '#FFFFFF',
      cost: [
        { id: 1, month: 6, price: '516,500' },
        { id: 2, month: 3, price: '733,000' },
        {
          id: 3,
          month: 1,
          price: '1,549,000',
        },
      ],
      memberLevelValue: MEMBER_TYPES.PLATINUM_DIAMOND,
      memberLevel: MEMBER_LEVEL.DIAMOND,
    },
  ],
  UPGRADE_MEMBER_SHIP_EXTRAS: {
    id: UPGRADE_MEMBER_SHIP_ID.EXTRAS,
    name: 'Extras',
    description: 'FeedHome.ExtraDes',
    upgradeButtonLabel: 'GetExtras',
    color: '#FA3754',
    color2: '#FA3754',
    textColor: '#FFFFFF',
    textColor2: '#FFFFFF',
    classicColor: '#FA3754',
    classicTextColor: '#FFFFFF',
    cost: [
      { id: 1, month: 6, price: '258,166' },
      { id: 2, month: 3, price: '359,666' },
      {
        id: 3,
        month: 1,
        price: '739,000',
      },
    ],
    memberLevelValue: MEMBER_TYPES.EXTRAS,
    memberLevel: MEMBER_LEVEL.EXTRAS,
  },
  EDIT_INFO_DESCRIPTION: [
    { id: 1, name: 'Personality' },
    { id: 2, name: 'Looks' },
    { id: 3, name: 'Interests' },
  ],
  DATE_FINDER_DESKTOP: [
    {
      id: 1,
      tabName: DATE_FINDER_DATAKEY.ANY_DATES,
      label: 'DateFinder.AnyDates',
      isSelected: true,
    },
    {
      id: 2,
      tabName: DATE_FINDER_DATAKEY.THIS_WEEK,
      label: 'DateFinder.ThisWeek',
      isSelected: false,
    },
    {
      id: 3,
      tabName: DATE_FINDER_DATAKEY.NEXT_WEEK,
      label: 'DateFinder.NextWeek',
      isSelected: false,
    },
    {
      id: 4,
      tabName: DATE_FINDER_DATAKEY.CUSTOM_DATE,
      label: 'DateFinder.CustomDate',
      isSelected: false,
    },
  ],
  FORUMS_MOBILE: [
    {
      id: 1,
      name: FORUM_DATAKEY.FOLLOWING,
      label: 'Following',
      isSelected: true,
    },
    {
      id: 2,
      name: FORUM_DATAKEY.MY_TOPIC,
      label: 'My topics',
      isSelected: false,
    },
  ],
  COMMUNITY_MOBILE: [
    {
      id: 1,
      label: COMMUNITY_DATAKEY.BLOGS,
      name: 'Blog', // COMMUNITY_DATAKEY.BLOGS,
      isSelected: true,
    },
    {
      id: 2,
      label: COMMUNITY_DATAKEY.STORIES,
      name: 'Stories', // COMMUNITY_DATAKEY.STORIES,
      isSelected: false,
    },
    {
      id: 3,
      label: COMMUNITY_DATAKEY.OTG,
      name: 'Galleries', // COMMUNITY_DATAKEY.OTG,
      isSelected: false,
    },
    {
      id: 4,
      label: COMMUNITY_DATAKEY.TESTIMONIALS,
      name: 'Testimonials', // COMMUNITY_DATAKEY.TESTIMONIALS,
      isSelected: false,
    },
  ],
  FORUMS_TOPIC_MOBILE: [
    {
      id: 1,
      name: 'Comments',
    },
    {
      id: 2,
      name: 'Likes',
    },
  ],
  GROUP_POST_DETAIL_TAB: [
    {
      id: 1,
      name: 'Comments',
      additionName: '',
    },
    {
      id: 2,
      name: 'Likes',
      additionName: '',
    },
  ],
  COMMUNITY_GALLERY_DESKTOP_TABS: [
    {
      id: 1,
      name: 'Comments',
      additionName: '',
      additionalNumber: 0,
    },
    {
      id: 2,
      name: 'Likes',
      additionName: '',
      additionalNumber: 0,
    },
  ],
  MY_EVENTS: [
    {
      id: 1,
      name: 'Upcoming',
      label: 'Upcoming',
      isSelected: true,
    },
    {
      id: 2,
      name: 'Past events',
      label: 'Past events',
      isSelected: false,
    },
  ],
  INTENTIONS: [
    {
      id: 1,
      name: 'Looking for',
      label: 'Looking for',
      isSelected: true,
    },
    {
      id: 2,
      name: 'Deal Breakers',
      label: 'Deal Breakers',
      isSelected: false,
    },
  ],
  QUICK_MESSAGE: [
    {
      id: 1,
      name: 'Ice breakers',
      label: 'Ice breakers',
      isSelected: false,
    },
    {
      id: 2,
      name: 'Quick messages',
      label: 'Quick messages',
      isSelected: true,
    },
  ],
  GROUP_DETAIL: [
    {
      id: GROUP_TAB_ID.ABOUT,
      name: 'About',
      label: 'About',
      isSelected: true,
    },
    {
      id: GROUP_TAB_ID.POSTS,
      name: 'Posts',
      label: 'Posts',
      isSelected: false,
    },
    {
      id: GROUP_TAB_ID.PHOTOS,
      name: 'Photos',
      label: 'Photos',
      isSelected: false,
    },
    {
      id: GROUP_TAB_ID.VIDEOS,
      name: 'Videos',
      label: 'Videos',
      isSelected: false,
    },
    {
      id: GROUP_TAB_ID.ALBUMS,
      name: 'Albums',
      label: 'Albums',
      isSelected: false,
    },
    {
      id: GROUP_TAB_ID.EVENTS,
      name: 'Events',
      label: 'Events',
      isSelected: false,
    },
    {
      id: GROUP_TAB_ID.CHATS,
      name: 'Chats',
      label: 'Chats',
      isSelected: false,
    },
    {
      id: GROUP_TAB_ID.REVIEWS,
      name: 'Validations',
      label: 'Validations',
      isSelected: false,
    },
  ],
  MEMBER_TYPE: [
    {
      id: GROUP_TAB_MEMBER.MEMBERS,
      name: 'Members',
      label: 'Members',
      isSelected: true,
    },
    {
      id: GROUP_TAB_MEMBER.REQUEST,
      name: 'Join requests',
      label: 'Join requests',
      isSelected: false,
    },
  ],
};

export const GROUP_POST_DETAIL_OPTIONS = [
  {
    id: 1,
    text: 'GroupDetail.SharePost',
    icon: icShare,
  },
  {
    id: 2,
    text: 'GroupDetail.ReportPost',
    icon: icReportMess,
  },
  {
    id: 3,
    text: 'GroupDetail.BlockGroup',
    icon: icBlockUserOption,
  },
  {
    id: 4,
    text: 'GroupDetail.LeaveGroup',
    icon: icLeaveGroup,
  },
];

export const GROUP_ALBUM_DETAIL_OPTIONS = [
  {
    id: 1,
    text: 'GroupDetail.ShareAlbum',
    icon: icShare,
  },
  {
    id: 2,
    text: 'GroupDetail.ReportAlbum',
    icon: icReportMess,
  },
  {
    id: 3,
    text: 'GroupDetail.BlockGroup',
    icon: icBlockUserOption,
  },
  {
    id: 4,
    text: 'GroupDetail.LeaveGroup',
    icon: icLeaveGroup,
  },
];

export const GROUP_POST_DETAIL_ACTION_OPTIONS = [
  {
    id: 1,
    text: 'GroupDetail.EditPost',
    icon: icEditReport,
  },
  {
    id: 2,
    text: 'GroupDetail.RemovePostBtn',
    icon: icDeleteTrash,
  },
];

export const GROUP_ALBUM_DETAIL_ACTION_OPTIONS = [
  {
    id: 1,
    text: 'GroupDetail.EditAlbum',
    icon: icEditReport,
  },
  {
    id: 2,
    text: 'GroupDetail.RemoveAlbum',
    icon: icDeleteTrash,
  },
];

export const GROUP_ALBUM_DETAIL_DESKTOP_ACTION_OPTIONS = [
  {
    id: 1,
    text: 'Btn.Edit',
    subText: 'GroupDetail.EditAlbum',
    icon: icEditReport,
  },
  {
    id: 2,
    text: 'Btn.Delete',
    subText: 'GroupDetail.RemoveAlbumBtn',
    icon: icDeleteTrash,
  },
];

export const GROUP_ALBUM_DETAIL_DESKTOP_ACTION_OPTIONS_MEMBER = [
  {
    id: 1,
    text: 'Btn.Share',
    subText: 'GroupDetail.ShareAlbum',
    icon: icShare,
  },
  {
    id: 2,
    text: 'Btn.Report',
    subText: 'GroupDetail.ReportAlbum',
    icon: icReportMess,
  },
];

export const PROFILE_MODAL = {
  SHOW_MODAL: 'MEMBER_PROFILE_SHOW_MODAL',
  SHOW_ADD_MODAL: 'MEMBER_PROFILE_SHOW_ADD_MODAL',
  SHOW_SUCCESS_MODAL: 'MEMBER_PROFILE_SHOW_SUCCESS_MODAL',
  CLOSE_MODAL: 'MEMBER_PROFILE_CLOSE_MODAL',
  LOAD_MORE_FRIENDS: 'MEMBER_PROFILE_LOAD_MORE_FRIENDS',
  LOAD_MORE_VALIDATIONS: 'MEMBER_PROFILE_LOAD_MORE_VALIDATIONS',
};

export const BROWSER_CLICK = {
  RIGHT_IE: 'button',
  RIGHT_IE_CODE_MOUSE_RIGHT: 2,
  RIGHT_OTH: 'which',
  RIGHT_OTH_CODE_MOUSE_RIGHT: 3,
};

export const REFINE_MODAL = {
  LOCATION_DEFAULT: 'Australia',
  PROXIMITY_DEFAULT: 501,
  PROXIMITY_DEFAULT_SHOW: 500,
};
export const ROUND_BUTTON_TYPE = {
  BIG: 'big',
  SMALL: 'small',
  DEFAULT: 'default',
  DISABLED: 'disabled',
  GRAY: 'gray',
  GREEN: 'green',
  RED: 'red',
};

export type RoundButtonType = (typeof ROUND_BUTTON_TYPE)[keyof typeof ROUND_BUTTON_TYPE];

export const AVATAR_SIZE = {
  S_SMALL: 's-small',
  SMALL: 'small',
  LARGE: 'large',
  NORMAL: 'normal',
  X_NORMAL: 'x-normal',
  MEDIUM: 'medium',
  w35: 'w35',
  w60: 'w60',
  w70: 'w70',
  W100: 'w100',
  W140: 'w140',
  W245: 'w245',
  READ_INBOX: 'readInbox',
};
export const MESSAGE = {
  ICON_X: 'iconX',
  POSITION_RIGHT: 'right',
  POSITION_LEFT: 'left',
};

export const CONVERSATION_FILTER_TAB = [
  { id: 1, value: 0, name: 'All members' },
  { id: 2, value: 1, name: 'Matching' },
  { id: 3, value: 2, name: 'Username' },
];
export const PROSPECTS = {
  VIEWS: 'views',
  MATCHES: 'matches',
  LIKES: 'likes',
  FAVOURITES: 'favourites',
  TYPE_VIEWED_ME: 'On',
  TYPE_I_VIEWED: 'Off',
  USERS_LIKES: 'Like',
  USERS_MATCH: 'Match',
  LIST_TYPE_ON: 'On',
  LIST_TYPE_OFF: 'Off',
  LOAD_MORE: 'loadmore',
  TYPE_ON: 'on',
  TYPE_OFF: 'off',
};

export const LIMIT_PIN_NUMBER = 5;

export const QUICK_MESSAGE = {
  LIMIT_LENGTH_TITLE: 200,
};

export const FACING_MODE = {
  USER: 'user',
  REAR: 'environment',
};

export const VIDEO_CARD_VIEW_SMALL = {
  WIDTH: 86,
  HEIGHT: 98,
};

export const ZOOM_VALUE = {
  USER: 0,
  REAR: 0,
};

export const GOOGLE_API_ERROR_MESSAGE = {
  UNKNOW: 'Unknown error',
  PERMISSION: 'Permission denied',
  POSITION: 'Position unavailable (error response from location provider)',
  TIMEOUT: 'Request time out',
  NOSUPPORTGEOLOCATION: 'No support geo location',
};

export const LIMIT_INDEX_VALIDATION_FRIEND = 10;

export const TIME_TOGGLE_COMPONENTS_VIDEO = 3;

export const PROFILE_OPTION_MODAL = {
  CANCEL_DELETE_FRIEND: 'Delete',
  APPROVE_FRIEND: 'Approve',
};

export const REF_ID = {
  HEADER_MEMBER_SEARCH_WRAPPER: 'header-member-search-wrapper',
  HEADER_MEMBER_WRAPPER: 'header-member-wrapper',
  FOOTER_MEMBER_SEARCH_WRAPPER: 'bottom-member-search-wrapper',
  TAB_ITEMS: 'tab-items',
  LIST_CAROUSEL_VIEW: 'list-carousel-view',
  BUTTON_GROUP: 'button-group',
  MEMBER_SEARCH_WRAPPER_DESKTOP: 'member-search-wrapper-desktop',
  FEED_HOME_WRAPPER_MOBILE: 'feed-home-wrapper-mobile',
  FRIENDS_HEADER: 'friends-header',
  EVENTS_HEADER: 'events-header',
  EVENTS_SPONSORED_SECTION: 'events-sponsored-section',
  DIVIDER: 'divider',
  SUMMARY_PROFILE: 'summary-profile',
  POPULAR_EVENTS: 'popular-events',
  INPUT_SEARCH_USER_NAME: 'input-search-username',
  LIST_SEARCH_USER_NAME: 'list-search-username',
  MEMBER_SEARCH_LEFT_MENU: 'member-search-left-menu',
  HEADER_DESKTOP: 'header-desktop',
  HEADER_POPULAR_EVENT: 'header-popular-event',
  EVENTS_COMPONENT_RIGHT: 'events-component-right',
  EVENTS_POPULAR_BODY: 'events-popular-body',
  EVENTS_BANNER_COVID: 'events-banner-covid',
  STREAM_CENTER: 'stream-center',
  STREAM_FILTER_BUTTON: 'stream-filter-button',
  STREAM_LEFT: 'stream-left',
  STREAM_RIGHT: 'stream-right',
  STREAM_RIGHT_RIGHT: 'stream-right-right',
  STREAM_CENTER_SKELETON: 'stream-center-skeleton',
  STREAM_LEFT_SKELETON: 'stream-left-skeleton',
  STREAM_RIGHT_SKELETON: 'stream-right-skeleton',
  STREAM_RIGHT_RIGHT_SKELETON: 'stream-right-right-skeleton',
  EVENT_COMPONENT_LEFT: 'events-component-left',
  FOOTER_DESKTOP: 'footer-desktop',
  TAB_SHOW: 'tab-show',
  TAB_MORE: 'tab-more',
  FORUM_PAGGING: 'forum-pagging',
  FORUM_COMMENT_WRAPPER: 'forum-comment-wrapper',
  GROUP_USER_SEARCH: 'group-user-search',
  GROUP_MY_LIST_BODY: 'group-my-list-body',
  SWIPE_ITEM: 'swp-itm',
  RES_SEARCH: 'result-search',
  BUTTON_1: 'button_1',
  BUTTON_2: 'button_2',
  BUTTON_3: 'button_3',
  US_PRIVATE_ALBUM_BODY: 'us-prv-alb-body',
  US_BL_LS: 'user-block-list',
  MEMBER_SEARCH_WRAPPER_MOBILE: 'member-search-wrapper-mobile',
  COMMENT_WRAPPER: 'comment-wrapper',
};

export const ID = {
  STREAM_CENTER: 'stream-center',
  STREAM_FILTER_BUTTON: 'stream-filter-button',
  LEFT_WRAPPER: 'left-wrapper',
  RIGHT_WRAPPER: 'right-wrapper',
  RIGHT_WRAPPER_WITH_FOOTER: 'right-wrapper-footer',
  LEFT_WRAPPER_WITH_FOOTER: 'left-wrapper-footer',
  RIGHT_OTHER_WRAPPER_1: 'right-other-wrapper-1',
  RIGHT_OTHER_WRAPPER_2: 'right-other-wrapper-2',
  PROSPECTS_EMPTY: 'prospects-empty',
};

export const OPTION_REPORT_ID = {
  ABUSIVE_INAPPROPRIATE: 'AbusiveInappropriate',
  FEELS_LIKE_SPAM_FAKE: 'FeelsLikeSpamFake',
  OTHER: 'Other',
};

export const OPTION_REPORT_TYPE_ID = {
  SYSTEM: 'System',
  MESSAGE: 'Message',
  USER_PHOTO: 'UserPhoto',
  FORUM_TOPIC: 'ForumTopic',
  PROFILE: 'Profile',
  COMMENT: 'Comments',
  FORUM_MESSAGE: 'ForumMessage',
  STORY: 'Story',
  GROUP_CHAT: 'GroupChat',
  UN_DEFINED: 'Undefined',
  CHAT_ROOMS: 'Chatrooms',
  POST: 'Post',
  CLUB: 'Club',
  GROUP: 'Group',
  GROUP_POST: 'GroupPost',
  GROUP_ALBUM: 'GroupAlbum',
  GROUP_MEDIA: 'GroupMedia',
  GROUP_VALIDATION: 'GroupValidation',
  OTG_GALLERY: 'OnTheGroundGallery',
  EVENT: 'Event',
} as const;

export type REPORT_TYPE = (typeof OPTION_REPORT_TYPE_ID)[keyof typeof OPTION_REPORT_TYPE_ID];

export const LOCATION_SEARCH_FROM = {
  MEMBERSEARCH_FILTERS: 'membersearchFilters',
  PROSPECTS_FILTERS: 'prospectsFilters',
  EVENT_FILTER: 'eventFilters',
  GROUP_FILTER: 'groupFilters',
  CREATE_EVENT: 'createEvent',
  EDIT_PROFILE: 'editProfile',
  TRAVEL_PLAN: 'TravelPlan',
  DATE_FINDER_SCREEN: 'DATE_FINDER_SCREEN',
  CREATE_DATE_FINDER_SCREEN: 'CREATE_DATE_FINDER_SCREEN',
  CREATE_TRAVEL_PLAN: 'CREATE_TRAVEL_PLAN',
  ACTIVE_NOW: 'ACTIVE_NOW',
  RHP_STORE_CHECK_OUT: 'rhpStoreCheckout',
  RECENTLY_VALIDATED: 'recentlyValidated',
  CREATE_GROUP: 'createGroup',
  EDIT_GROUP: 'editGroup',
};

export const SUBSCRIBE_LIVE_STREAM_PORTABLE = (config.isProduction ? urls.PROD_RHPURL : urls.DEV_RHPURL) + urls.LIVESTREAM_VIEW_URL_PROD;

export const LIVESTREAM_IN_WEBPAGE = config.isProduction ? urls.PROD_RHPURL : urls.DEV_RHPURL;

export const MENU_PROFILE_SUMMARY_MODAL = [
  {
    id: 1,
    label: 'Whisper',
    icon: images.icW,
    eventTypes: eventTypes.SHOW_WHISPER_VIEW,
  },
  {
    id: 2,
    label: 'Private conversation',
    icon: images.icPrivateConversation,
    eventTypes: eventTypes.SHOW_CONVERSATION_MODAL,
  },
  {
    id: 3,
    label: 'Report',
    icon: images.icReportChatRoom,
    eventTypes: eventTypes.SHOW_REPORT_MODAL,
  },
  {
    id: 4,
    label: 'Block',
    icon: images.icBlock,
    eventTypes: eventTypes.PRESS_BLOCK_USER,
  },
  {
    id: 5,
    label: 'Moderate',
    icon: images.icModerate,
    eventTypes: 'MODERATE',
  },
];

export const MENU_MODERATOR = [
  {
    id: 0,
    icon: images.icW,
    label: 'Whisper',
    hideRight: true,
    hasCount: false,
  },
  {
    id: 1,
    icon: images.icBlock,
    label: 'Ban from chat',
    hideRight: true,
    hasCount: false,
  },
  {
    id: 2,
    icon: images.icTimeOut,
    label: 'Set time out',
    hideRight: false,
    hasCount: false,
  },
  {
    id: 3,
    icon: images.icAddNoteOption,
    label: 'Add / View comments',
    hideRight: false,
    hasCount: true,
  },
];

export const MENU_SET_TIMEOUT = [
  { id: 0, label: '30 minutes', selected: true },
  { id: 1, label: '6 hours', selected: false },
  { id: 2, label: '3 days', selected: false },
  { id: 3, label: '1 week', selected: false },
];

export const MENU_OPTION_SETTING_TYPES = {
  ACCOUNT_SETTINGS: 'AccountSettings',
  PRIVACY_SETTINGS: 'PrivacySettings',
  NOTIFICATION_SETTINGS: 'NotificationSettings',
  MY_LIST: 'MyList',
  SUBSCRIPTION: 'Subscription',
  HELP_AND_SUPPORT: 'HelpAndSupport',
  LOG_OUT: 'LogOut',
  LEGAL: 'Legal',
  MANAGE_PHOTOS: 'ManagePhotos',
  EDIT_PROFILE: 'EditProfile',
  VERIFY_YOUR_PROFILE: 'VerifyYourProfile',
  RHP_STORE: 'RHPStore',
};

export const MENU_OPTION_SETTING_MODAL = [
  {
    id: 1,
    name: MENU_OPTION_SETTING_TYPES.ACCOUNT_SETTINGS,
    // url: urls.URL_ACCOUNT_SETTING,
    url: `${ROOT_FOLDER}/${MAIN_SETTING}/${EDIT_SETTING_INFO}/${ACCOUNT_SETTING}`,
    // url: ROOT_FOLDER + "/" + ACCOUNT_SETTING,
    urlMobile: urls.URL_ACCOUNT_SETTING_MOBILE_APP,
    label: 'MenuUserSetting.AccountSettings',
    subLabel: 'MenuUserSetting.SubAccountSettings',
    icon: images.icAccountSettings,
    iconSVG: icAccountSettings,
    isScreen: true,
  },
  {
    id: 2,
    name: MENU_OPTION_SETTING_TYPES.PRIVACY_SETTINGS,
    // url: urls.URL_PRIVACY_SETTING,
    url: `${ROOT_FOLDER}/${MAIN_SETTING}/${EDIT_SETTING_INFO}/${PRIVACY}`,
    urlMobile: urls.URL_PRIVACY_SETTING_MOBILE_APP,
    label: 'MenuUserSetting.PrivacySettings',
    subLabel: 'MenuUserSetting.SubPrivacySettings',
    icon: images.icPrivacySettings,
    iconSVG: icPrivacySettings,
    isScreen: true,
  },
  {
    id: 3,
    name: MENU_OPTION_SETTING_TYPES.NOTIFICATION_SETTINGS,
    // url: urls.URL_NOTIFICATION_SETTING,
    url: `${ROOT_FOLDER}/${MAIN_SETTING}/${EDIT_SETTING_INFO}/${NOTIFICATION}`,
    // url: ROOT_FOLDER + "/" + MAIN_SETTING + "/" + NOTIFICATION,
    urlMobile: urls.URL_NOTIFICATION_SETTING_MOBILE_APP,
    label: 'MenuUserSetting.NotificationSettings',
    subLabel: 'MenuUserSetting.SubNotificationSettings',
    icon: images.icNotificationSettings,
    iconSVG: icNotificationSettings,
    isScreen: true,
  },
  {
    id: 4,
    name: MENU_OPTION_SETTING_TYPES.MY_LIST,
    url: `${ROOT_FOLDER}/${USER}/${LIST}`,
    // url: urls.URL_MYLIST,
    urlMobile: urls.URL_MYLIST_MOBILE_APP,
    label: 'MenuUserSetting.MyList',
    subLabel: 'MenuUserSetting.SubMyList',
    icon: images.icMyLists,
    iconSVG: icMyLists,
    isScreen: true,
  },
  {
    id: 5,
    name: MENU_OPTION_SETTING_TYPES.SUBSCRIPTION,
    url: urls.URL_SUBSCRIPTIONS,
    urlMobile: urls.URL_SUBSCRIPTIONS_MOBILE_APP,
    label: 'MenuUserSetting.SubscriptionAndCredit',
    subLabel: 'MenuUserSetting.SubSubscription',
    icon: images.icSubscriptions,
    iconSVG: icSubscriptions,
  },
  // {
  //     id: 6,
  //     name: MENU_OPTION_SETTING_TYPES.HELP_AND_SUPPORT,
  //     url: urls.URL_HELP_SUPPORT,
  //     urlMobile: urls.URL_HELP_SUPPORT_MOBILE_APP,
  //     label: 'MenuUserSetting.HelpSupport',
  //     subLabel: 'MenuUserSetting.SubHelpSupport',
  //     icon: images.icHelpSupport,
  //     iconSVG: 'icHelpSupport',
  // },
  // {
  //     id: 8,
  //     name: MENU_OPTION_SETTING_TYPES.LEGAL,
  //     url: ROOT_FOLDER + "/" + LEGAL,
  //     urlMobile: "",
  //     label: 'MenuUserSetting.Legal',
  //     subLabel: 'MenuUserSetting.SubLegal',
  //     icon: images.icLegal,
  //     iconSVG: 'icLegal',
  //     isScreen: true,
  // },
  {
    id: 7,
    name: MENU_OPTION_SETTING_TYPES.LOG_OUT,
    url: '',
    urlMobile: '',
    label: 'MenuUserSetting.Logout',
    subLabel: 'MenuUserSetting.SubLogout',
    icon: images.icLogOut,
    iconSVG: icLogOut,
  },
];

export const USER_SETTING_OPTION_DESKTOP = [
  {
    id: 0,
    name: MENU_OPTION_SETTING_TYPES.VERIFY_YOUR_PROFILE,
    label: 'MenuUserSetting.VerifyYourProfile',
    route: `${ROOT_FOLDER}/${MAIN_SETTING}`,
    subRoute: [''],
    url: '',
    icon: icVerifyPendingOutline,
    iconActive: icVerifyPendingOutline,
    isSelected: false,
    isDividerBottom: false,
  },
  {
    id: 1,
    name: MENU_OPTION_SETTING_TYPES.MANAGE_PHOTOS,
    label: 'MenuUserSetting.ManagePhotos',
    route: `${ROOT_FOLDER}/${MAIN_SETTING}/${PHOTO}`,
    subRoute: [PHOTO],
    url: '',
    icon: icProfileManagePhotos,
    iconActive: icProfileManagePhotosActive,
    isSelected: false,
    isDividerBottom: true,
  },
  {
    id: 2,
    name: MENU_OPTION_SETTING_TYPES.EDIT_PROFILE,
    label: 'MenuUserSetting.EditProfile',
    route: `${ROOT_FOLDER}/${MAIN_SETTING}/${EDIT_PROFILE_DK}`,
    subRoute: [EDIT_PROFILE_DK, EDIT_GENERAL_INFO, INTIMATE_INFO, DESCRIPTION, INTERESTS, IDEAL_PARTNER_MENU, PARTNER_DESCRIPTION],
    url: '',
    icon: icProfileEdit,
    iconActive: icProfileEditActive,
    isSelected: false,
    isDividerBottom: true,
  },
  {
    id: 3,
    name: MENU_OPTION_SETTING_TYPES.ACCOUNT_SETTINGS,
    label: 'MenuUserSetting.AccountSettings',
    route: `${ROOT_FOLDER}/${MAIN_SETTING}/${ACCOUNT}`,
    subRoute: [ACCOUNT],
    url: '',
    icon: icProfileAccount,
    iconActive: icProfileAccountActive,
    isSelected: false,
    isDividerBottom: true,
  },
  {
    id: 4,
    name: MENU_OPTION_SETTING_TYPES.PRIVACY_SETTINGS,
    label: 'MenuUserSetting.PrivacySettings',
    route: `${ROOT_FOLDER}/${MAIN_SETTING}/${PRIVACY}`,
    subRoute: [PRIVACY],
    url: '',
    icon: icProfilePrivacy,
    iconActive: icProfilePrivacyActive,
    isSelected: false,
    isDividerBottom: true,
  },
  {
    id: 5,
    name: MENU_OPTION_SETTING_TYPES.NOTIFICATION_SETTINGS,
    label: 'MenuUserSetting.NotificationSettings',
    route: `${ROOT_FOLDER}/${MAIN_SETTING}/${NOTIFICATION}`,
    subRoute: [NOTIFICATION, EMAIL_NOTIFICATION, PUSH_NOTIFICATION],
    url: '',
    icon: icProfileNotification,
    iconActive: icProfileNotificationActive,
    isSelected: false,
    isDividerBottom: true,
  },
  {
    id: 6,
    name: MENU_OPTION_SETTING_TYPES.MY_LIST,
    label: 'MenuUserSetting.MyList',
    route: `${ROOT_FOLDER}/${MAIN_SETTING}/${USER_LIST}`,
    subRoute: [USER_LIST],
    url: '',
    icon: icProfileMyList,
    iconActive: icProfileMyListActive,
    isSelected: false,
    isDividerBottom: true,
  },
  {
    id: 7,
    name: MENU_OPTION_SETTING_TYPES.SUBSCRIPTION,
    label: 'MenuUserSetting.SubscriptionAndCredit',
    route: `${ROOT_FOLDER}/${MAIN_SETTING}/${SUBSCRIPTION}`,
    subRoute: [SUBSCRIPTION, MANAGE_SUBSCRIPTION, MANAGER_CONVERSATION_CREDITS],
    url: '',
    icon: icProfileSubscriptions,
    iconActive: icProfileSubscriptionsActive,
    isSelected: false,
    isDividerBottom: true,
  },
  {
    id: 8,
    name: MENU_OPTION_SETTING_TYPES.LEGAL,
    label: 'MenuUserSetting.Legal',
    route: `${ROOT_FOLDER}/${MAIN_SETTING}/${LEGAL}`,
    subRoute: [LEGAL],
    url: '',
    icon: icLegalEProfile,
    iconActive: icLegalEProfileActive,
    isSelected: false,
    isDividerBottom: true,
  },
  {
    id: 9,
    name: MENU_OPTION_SETTING_TYPES.HELP_AND_SUPPORT,
    label: 'MenuUserSetting.HelpSupport',
    route: `${ROOT_FOLDER}/${MAIN_SETTING}/${HELP_AND_SUPPORT}`,
    subRoute: [HELP_AND_SUPPORT],
    // url: urls.URL_HELP_SUPPORT_DESKTOP,
    url: '',
    icon: icProfileHelp,
    iconActive: icProfileHelpActive,
    isSelected: false,
    isDividerBottom: true,
  },
  {
    id: 10,
    name: MENU_OPTION_SETTING_TYPES.RHP_STORE,
    label: 'MenuUserSetting.RHPStore',
    route: `${ROOT_FOLDER}/${MAIN_SETTING}/${RHP_STORE}`,
    subRoute: [RHP_STORE],
    // url: urls.URL_HELP_SUPPORT_DESKTOP,
    url: '',
    icon: icRHPStore,
    iconActive: icRHPStoreActive,
    isSelected: false,
    isDividerBottom: false,
  },
];

// CHAT ROOM MESSAGE

export const CHAT_STATUS = {
  LIVE: 5,
  ACTIVE: 1,
  BUSY: 2,
  AWAY: 3,
  AVAILABLE: 4,
};
export const CHAT_STATUS_TEXT = {
  LIVE: 'Live',
  ACTIVE: 'Active',
  BUSY: ' Busy',
  AWAY: 'Away',
  AVAILABLE: 'Available',
};
export const AGE_TITTLE = {
  WOMEN: 'F',
  MEN: 'M',
  COUPLE: 'C',
  ALL: 'A',
  DEFAULT: 'D',
};

export const CHAT_ROOM_FILTER_LABELS = {
  ALL: 'ALL',
  WOMEN: 'WOMEN',
  MEN: 'MEN',
  COUPLE: 'COUPLES',
};
export const CHAT_ROOM_FILTER_INDEX = {
  ALL: 0,
  WOMEN: 1,
  MEN: 2,
  COUPLE: 3,
};
export const CHAT_ROOM_VIEW = {
  CHAT_ROOMS: 'CHATROOMS',
  LIVE_STREAMS: 'LIVE STREAMS',
};

export const ACTIVE_NOW_KEYS = {
  FRIENDS: 'friends',
  FAVORITES: 'favorites',
};

export const USER_NAME_MAPPING = Object.freeze({
  [AGE_TITTLE.COUPLE]: 'text-couple',
  [AGE_TITTLE.MEN]: 'text-male',
  [AGE_TITTLE.WOMEN]: 'text-female',
  [AGE_TITTLE.DEFAULT]: 'text-default',
});

export const BG_AVATAR_MAPPING = Object.freeze({
  [AGE_TITTLE.COUPLE]: '__bg_couple',
  [AGE_TITTLE.MEN]: '__bg_male',
  [AGE_TITTLE.WOMEN]: '__bg_female',
  [AGE_TITTLE.DEFAULT]: '__bg_default',
});

export const MOMENT_RELATIVE_TIME = {
  future: 'in %s',
  past: '%s ',
  s: '%d s',
  ss: '%d s',
  m: '1 m',
  mm: '%d m',
  h: '1 h',
  hh: '%d h',
  d: '1 d',
  dd: '%d d',
  M: '1 mo',
  MM: '%d mo',
  y: '1 y',
  yy: '%d y',
};

export const MOMENT_RELATIVE_TIME_DEFAULT = {
  future: 'in %s',
  past: '%s ago',
  s: 'a few seconds',
  ss: '%d seconds',
  m: 'a minute',
  mm: '%d minutes',
  h: 'an hour',
  hh: '%d hours',
  d: 'a day',
  dd: '%d days',
  w: 'a week',
  ww: '%d weeks',
  M: 'a month',
  MM: '%d months',
  y: 'a year',
  yy: '%d years',
};

export const USER_INFO_OPTION = [
  {
    id: 1,
    label: 'PARTY LIKE A ROCKSTAR',
    subLabel: 'VIP invites to exclusive parties',
  },
  {
    id: 2,
    label: 'PREMIUM SEARCH FILTERS',
    subLabel: 'Search by interests, sexuality & more',
  },
  {
    id: 3,
    label: 'VIEW LISTED PHONE NUMBERS',
    subLabel: 'Call or text hotties direct',
  },
  {
    id: 4,
    label: 'VIEW RESTRICTED PHOTOS',
    subLabel: 'Check out exclusive member pics',
  },
  {
    id: 5,
    label: 'VIEW LISTED PHONE NUMBERS',
    subLabel: 'Call or text hotties direct',
  },
];

export const SIZE_OF_CARD = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  BIG: 'big',
};

export const NOTIFICATIONS = {
  TYPE_OF_USER_ALERT: {
    SUPPORT_TICKET_REPLY: 'SupportTicketReply',
    SUPPORT_TICKET_CREATED: 'SupportTicketCreated',
    PHOTO_REJECTED: 'PhotoRejected',
    PROFILE_REJECTED: 'ProfileRejected',
    USER_NAME_REJECTED: 'UsernameRejected',
    PROFILE_SEEKING_REJECTED: 'ProfileSeekingRejected',
    COMMENT_REJECTED: 'CommentRejected',
    COMMENT_REPLY_REJECTED: 'CommentReplyRejected',
  },
  TYPE_OF_USER_NOTIFICATION: {
    FRIEND_REQUEST_ACCEPTED: 'FriendRequestAccepted',
    VALIDATION_ACCEPTED: 'ValidationAccepted',
    SENT_A_FRIEND_REQUEST: 'SentAFriendRequest',
    SENT_A_FRIEND_REQUEST_FRIENDS: 'SentAFriendRequestFriends',
    SEND_A_GROUP_REQUEST: 'SendAGroupRequest',
  },
  TYPE_OF_GROUP_NOTIFICATION: {
    CLUB_ALBUM_LIKE: 'ClubAlbumLike',
    CLUB_ALBUM_COMMENT: 'ClubAlbumComment',
    CLUB_MEDIA_LIKE: 'ClubMediaLike',
    CLUB_MEDIA_COMMENT: 'ClubMediaComment',
    CLUB_POST_LIKE: 'ClubPostLike',
    CLUB_POST_COMMENT: 'ClubPostComment',
    CLUB_EVENT_INTEREST: 'ClubEventInterest',
    CLUB_REQUEST: 'ClubRequest',
    CLUB_VIDEO_LIKE: 'ClubVideoLike',
    CLUB_VIDEO_COMMENT: 'ClubVideoComment',
    CLUB_PHOTO_LIKE: 'ClubPhotoLike',
    CLUB_PHOTO_COMMENT: 'ClubPhotoComment',
    CLUB_VALIDATION_COMMENT: 'ClubValidationComment',
    CLUB_VALIDATION: 'ClubValidation',
    CLUB_INVITATION: 'ClubInvitation',
    EVENT_INVITATION: 'EventInvitation',
    CLUB_JOINS: 'ClubJoins',
    CLUB_ALBUM_POST: 'ClubAlbumAlbum',
    CLUB_POST_POST: 'ClubPostPost',
  },
};

export const FRIENDS_API = {
  FRIENDS: 'Friends',
  PENDING: 'Pending',
};

export const IN_APP_NOTIFICATION = {
  TIMEOUT: 2500, // 1000 timeout + 500 animated
  TIMEOUT_DESKTOP: 10000,
  TYPE: {
    LIKE: 'like',
    FAV: 'favorite',
    SENDMESSAGE: 'sendMessage',
    INTEREST: 'interest',
    CHECK: 'viewProfile',
    MATCH: 'match',
    NAVIGATION: 'navigation',
    SEND_MESSAGE: 'sendMessage',
    SEND_GROUP_MESSAGE: 'sendGroupMessage',
    USER_NAME_APPROVAL: 'usernameApproval',
    MAIN_PHOTO_APPROVAL: 'mainPhotoApproved',
    PROFILE_VERIFIED: 'profileVerified',
    SCREEN_SHOT: 'screenShot',
    JOIN_GROUP_CHAT: 'joinGroupChat',
    LEAVE_GROUP_CHAT: 'leaveGroupChat',
    REMOVED_GROUP_CHAT: 'removedFromGroup',
    INVITED_GROUP_CHAT: 'inviteGroupChat',
    SPOTLIGHT_PICK_DAILY: 'todaysPics',
  },
  ACTION_NAME: {
    STORY_COMMENT: 'storyComment',
    EVENT_COMMENT: 'eventComment',
    TOPIC_COMMENT: 'forumTopicReply',
    PROFILE_VERIFICATION_REJECTED: 'profileVerificationRejected',
    PROFILE_VERIFIED_REJECTED: 'profileVerifiedRejected',
    PROFILE_VERIFICATION_APPROVED: 'profileVerificationApproved',
    EVENT_APPROVED: 'eventApproved',
    EVENT_REJECTED: 'eventRejected',
    PROFILE_PHOTO_LIKE: 'profilePhotoLike',
    EVENT_INTERESTS: 'eventInterest',
    GROUP_JOIN_APPROVED: 'groupJoinApproved',
    GROUP_JOIN_REJECTED: 'groupJoinRejected',
    GROUP_REJECTED: 'groupRejected',
    GROUP_APPROVED: 'groupApproved',
    GROUP_MEMBER_REQUEST: 'groupMemberRequest',
    GROUP_ALBUM_REJECTED: 'groupAlbumRejected',
    GROUP_ALBUM_APPROVED: 'groupAlbumApproved',
    GROUP_POST_REJECTED: 'groupPostRejected',
    GROUP_POST_APPROVED: 'groupPostApproved',
    GROUP_EVENT_APPROVED: 'groupEventApproved',
    GROUP_EVENT_REJECTED: 'groupEventRejected',
    GROUP_PHOTO_APPROVED: 'groupPhotoApproved',
    GROUP_PHOTO_REJECTED: 'groupPhotoRejected',
    STREAM_STARTING: 'streamStarting',
    STREAM_STARTED: 'streamStarted',
    GROUP_INVITE: 'groupInvite',
    EVENT_INVITE: 'eventInvite',
    GROUP_VALIDATION: 'groupValidation',
    GROUP_POST_APPROVED_USER_POST: 'groupPostApprovedUserPost',
    GROUP_JOIN: 'groupJoin',
    GROUP_NAME_REJECTED: 'groupNameRejected',
    GROUP_DES_REJECTED: 'groupDescriptionRejected',
    GROUP_RULES_REJECTED: 'groupRulesRejected',
  },
};

export const EVENTS = {
  CREATE_PUBLIC: '1',
  CREATE_PRIVATE: '2',
};

export const HORIZONTAL_SWIPE_COMPONENT_PROP_NAME = {
  USER: 'user',
  EVENT: 'event',
};
export const TIME_OUT_SEND_HEART = 3000;
export const NUMBER_HEART = 4;
export const LIVE_STREAM_LIST_PAGE_SIZE = 10;

export const TIME_REQUESTING_CALL = 15;

export const CODE_OWNER_MESSAGE = '110';
export const SELECT_CONVERSATION_PRE = 'select-conversation-pre';

export const TOAST_INFOR = {
  ERROR: 'ERROR',
  FOLDER: 'FOLDER',
  MESSAGE: 'MESSAGE',
  MESSAGE_DELETE: 'MESSAGE_DELETE',
  QUICKMESSAGE: 'QUICKMESSAGE',
  CONVERSATION: 'CONVERSATION',
  CONVERSATIONS: 'CONVERSATIONS',
  CANCEL_FRIEND_REQUEST: 'CANCEL_FRIEND_REQUEST',
  UN_FRIEND_REQUEST: 'UN_FRIEND_REQUEST',
  SEND_FRIEND_REQUEST: 'SEND_FRIEND_REQUEST',
  SEND_VALIDATE: 'SEND_VALIDATE',
  SEND_REPORT: 'SEND_REPORT',
  UPDATE_NOTE: 'UPDATE_NOTE',
  ADD_NOTE: 'ADD_NOTE',
  PHOTO_UPLOAD: 'PHOTO_UPLOAD',
  PHOTO_DELETE: 'PHOTO_DELETE',
  MAKE_MAIN_PHOTO: 'MAKE_MAIN_PHOTO',
  MAKE_MAIN_PHOTO_FAILED: 'MAKE_MAIN_PHOTO_FAILED',
  PHOTO_MOVED: 'PHOTO_MOVED',
  SHOW_PROFILE: 'SHOW_PROFILE',
  CAN_NOT_GET_LOCATION: 'CAN_NOT_GET_LOCATION',
  UPDATE_EMAIL: 'UPDATE_EMAIL',
  UPDATE_PASSWORD: 'UPDATE_PASSWORD',
  UPDATE_USER_NAME: 'UPDATE_USER_NAME',
  UPLOAD_IMAGE_ERROR_4001: 'UPLOAD_IMAGE_ERROR_4001',
  UPLOAD_IMAGE_ERROR_4002: 'UPLOAD_IMAGE_ERROR_4002',
  UPLOAD_IMAGE_ERROR_4003: 'UPLOAD_IMAGE_ERROR_4003',
  UPLOAD_IMAGE_ERROR_4004: 'UPLOAD_IMAGE_ERROR_4004',
  UPLOAD_IMAGE_ERROR_4005: 'UPLOAD_IMAGE_ERROR_4005',
  UPLOAD_IMAGE_ERROR_4006: 'UPLOAD_IMAGE_ERROR_4006',
  SEND_BlOCK_REQUEST_SUCCESS: 'SEND_BlOCK_REQUEST_SUCCESS',
  SEND_UN_BlOCK_REQUEST_SUCCESS: 'SEND_UN_BlOCK_REQUEST_SUCCESS',
  SEND_HIDE_REQUEST_SUCCESS: 'SEND_HIDE_REQUEST_SUCCESS',
  SEND_UN_HIDE_REQUEST_SUCCESS: 'SEND_UN_HIDE_REQUEST_SUCCESS',
  SEND_DELETE_DATE_REQUEST_SUCCESS: 'SEND_DELETE_DATE_REQUEST_SUCCESS',
  SEND_DELETE_TRAVEL_REQUEST_SUCCESS: 'SEND_DELETE_TRAVEL_REQUEST_SUCCESS',
  SEND_ADD_TRAVEL_REQUEST_SUCCESS: 'SEND_ADD_TRAVEL_REQUEST_SUCCESS',
  SEND_UPDATE_TRAVEL_REQUEST_SUCCESS: 'SEND_UPDATE_TRAVEL_REQUEST_SUCCESS',
  CREATE_FORUM_SUCCESS: 'CREATE_FORUM_SUCCESS',
  CREATE_STORY_SUCCESS: 'CREATE_STORY_SUCCESS',
  EDIT_STORY_SUCCESS: 'EDIT_STORY_SUCCESS',
  FOLLOW_TOPIC: 'FOLLOW_TOPIC',
  UN_FOLLOW_TOPIC: 'UN_FOLLOW_TOPIC',
  CREATE_TESTIMONIAL_SUCCESS: 'CREATE_TESTIMONIAL_SUCCESS',
  CREATE_SUPPORT_TICKET_SUCCESS: 'CREATE_SUPPORT_TICKET_SUCCESS',
  SENT_COMMENT_SUCCESS: 'SENT_COMMENT_SUCCESS',
  DELETE_COMMENT_SUCCESS: 'DELETE_COMMENT_SUCCESS',
  DELETE_USER_COMMENT_SUCCESS: 'DELETE_USER_COMMENT_SUCCESS',
  LINK_ACCOUNT_SUCCESS: 'LINK_ACCOUNT_SUCCESS',
  UN_LINK_ACCOUNT_SUCCESS: 'UN_LINK_ACCOUNT_SUCCESS',
  COMPETITION_SUBMIT_SUCCESS: 'COMPETITION_SUBMIT_SUCCESS',
  UPDATE_EVENT_SUCCESS: 'UPDATE_EVENT_SUCCESS',
  CREATE_EVENT_SUCCESS: 'CREATE_EVENT_SUCCESS',
  DELETE_EVENT_SUCCESS: 'DELETE_EVENT_SUCCESS',
  FRIEND_REQUEST_ACCEPTED: 'FRIEND_REQUEST_ACCEPTED',
  FRIEND_REQUEST_DECLINED: 'FRIEND_REQUEST_DECLINED',
  CC_UPDATED_SUCCESS: 'CC_UPDATED_SUCCESS',
  CC_REMOVE_SUCCESS: 'CC_REMOVE_SUCCESS',
  PROFILE_VISIBLE: 'PROFILE_VISIBLE',
  ADD_PRODUCT_SUCCESS: 'ADD_PRODUCT_SUCCESS',
  RE_SEND_CODE_SUCCESS: 'RE_SEND_CODE_SUCCESS',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  JOIN_GROUP_SUCCESS: 'JOIN_GROUP_SUCCESS',
  JOIN_PRIVATE_GROUP_SUCCESS: 'JOIN_PRIVATE_GROUP_SUCCESS',
  ACCEPT_INVITATION_JOIN_GROUP_SUCCESS: 'ACCEPT_INVITATION_JOIN_GROUP_SUCCESS',
  JOIN_GROUP_FAILED: 'JOIN_GROUP_FAILED',
  LEAVE_GROUP_SUCCESS: 'LEAVE_GROUP_SUCCESS',
  CANCEL_JOIN_GROUP_SUCCESS: 'CANCEL_JOIN_GROUP_SUCCESS',
  CANCEL_JOIN_GROUP_FAILED: 'CANCEL_JOIN_GROUP_FAILED',
  BLOCK_GROUP_SUCCESS: 'BLOCK_GROUP_SUCCESS',
  LEAVE_GROUP_FAILED: 'LEAVE_GROUP_FAILED',
  ADD_GROUP_REVIEW_SUCCESS: 'ADD_GROUP_REVIEW_SUCCESS',
  ADD_EVENT_REVIEW_SUCCESS: 'ADD_EVENT_REVIEW_SUCCESS',
  ADD_EVENT_RATING_SUCCESS: 'ADD_EVENT_RATING_SUCCESS',
  DELETE_EVENT_REVIEW_SUCCESS: 'DELETE_EVENT_REVIEW_SUCCESS',
  UPDATE_EVENT_GROUP_CHAT_MEMBER_SUCCESS: 'UPDATE_EVENT_GROUP_CHAT_MEMBER_SUCCESS',
  DELETE_EVENT_GROUP_CHAT_SUCCESS: 'DELETE_EVENT_GROUP_CHAT_SUCCESS',
  LEAVE_EVENT_GROUP_CHAT_SUCCESS: 'LEAVE_EVENT_GROUP_CHAT_SUCCESS',
  REMOVE_GROUP_CHAT_MEMBER_SUCCESS: 'REMOVE_GROUP_CHAT_MEMBER_SUCCESS',
  LEAVE_GROUP_TOAST: 'LEAVE_GROUP_TOAST',
  HIDE_TICKET_LINK_SUCCESS: 'HIDE_TICKET_LINK_SUCCESS',
  SHOW_TICKET_LINK_SUCCESS: 'SHOW_TICKET_LINK_SUCCESS',
  UPDATE_EVENT_GROUP_CHAT_SUCCESS: 'UPDATE_EVENT_GROUP_CHAT_SUCCESS',
  UPDATE_EVENT_GROUP_CHAT_REMOVE_USER_SUCCESS: 'UPDATE_EVENT_GROUP_CHAT_REMOVE_USER_SUCCESS',
  DELETE_STORIES_SUCCESS: 'DELETE_STORIES_SUCCESS',
  SEND_UPDATE_DATE_REQUEST_SUCCESS: 'SEND_UPDATE_DATE_REQUEST_SUCCESS',
  SEND_VERIFICATION_CODE_SUCCESS: 'SEND_VERIFICATION_CODE_SUCCESS',
  SEND_EVENT_GROUP_CHAT_INVITE_SUCCESS: 'SEND_EVENT_GROUP_CHAT_INVITE_SUCCESS',
  SEND_EVENT_GROUP_CHAT_INVITE_FAILED: 'SEND_EVENT_GROUP_CHAT_INVITE_FAILED',
  SEND_EVENT_GROUP_INVITE_SUCCESS: 'SEND_EVENT_GROUP_INVITE_SUCCESS',
  SEND_EVENT_GROUP_INVITE_FAILED: 'SEND_EVENT_GROUP_INVITE_FAILED',
  SEND_EVENT_EVENT_INVITE_FAILED: 'SEND_EVENT_EVENT_INVITE_FAILED',
  GROUP_CHAT_REVOKE_SHARE_CODE_SUCCESS: 'GROUP_CHAT_REVOKE_SHARE_CODE_SUCCESS',
  GROUP_CHAT_REVOKE_SHARE_CODE_FAILED: 'GROUP_CHAT_REVOKE_SHARE_CODE_FAILED',
  GET_MORE_INVITES_CREDITS_SUCCESS: 'GET_MORE_INVITES_CREDITS_SUCCESS',
  BOOST_PROFILE_SUCCESS: 'BOOST_PROFILE_SUCCESS',
  BOOST_CONVERSATIONS_SUCCESS: 'BOOST_CONVERSATIONS_SUCCESS',
  VIDEO_UPLOAD_ERROR: 'VIDEO_UPLOAD_ERROR',
  CANCEL_VIDEO_UPLOAD: 'CANCEL_VIDEO_UPLOAD',
  MASS_MESSAGES_SENT: 'MASS_MESSAGES_SENT',
  GET_MORE_LIKES_SUCCESS: 'GET_MORE_LIKES_SUCCESS',
  GET_MORE_FAVS_SUCCESS: 'GET_MORE_FAVS_SUCCESS',
  APPROVE_USER_JOIN_GROUP_SUCCESS: 'APPROVE_USER_JOIN_GROUP_SUCCESS',
  REJECT_USER_JOIN_GROUP_SUCCESS: 'REJECT_USER_JOIN_GROUP_SUCCESS',
  REMOVE_USER_FROM_GROUP_SUCCESS: 'REMOVE_USER_FROM_GROUP_SUCCESS',
  CREATE_GROUP_SUCCESS: 'CREATE_GROUP_SUCCESS',
  REMOVE_GROUP_SUCCESS: 'REMOVE_GROUP_SUCCESS',
  CREATE_CLUB_POST_SUCCESS: 'CREATE_CLUB_POST_SUCCESS',
  CREATE_CLUB_ALBUM_SUCCESS: 'CREATE_CLUB_ALBUM_SUCCESS',
  CREATE_CLUB_POST_ERROR: 'CREATE_CLUB_POST_ERROR',
  UPDATE_CLUB_POST_SUCCESS: 'UPDATE_CLUB_POST_SUCCESS',
  UPDATE_CLUB_ALBUM_SUCCESS: 'UPDATE_CLUB_ALBUM_SUCCESS',
  UPDATE_CLUB_POST_ERROR: 'UPDATE_CLUB_POST_ERROR',
  UPDATE_GROUP_SUCCESS: 'UPDATE_GROUP_SUCCESS',
  REMOVE_POST: 'REMOVE_POST',
  REMOVE_ALBUM: 'REMOVE_ALBUM',
  INVITE_LIMIT_REACHED: 'INVITE_LIMIT_REACHED',
  DELETE_TOPIC_SUCCESS: 'DELETE_TOPIC_SUCCESS',
  PATCH_CLUB_USER_MEMBER_LEVEL_TO_ADMIN_SUCCESS: 'PATCH_CLUB_USER_MEMBER_LEVEL_TO_ADMIN_SUCCESS',
  PATCH_CLUB_USER_MEMBER_LEVEL_REMOVED_ADMIN_SUCCESS: 'PATCH_CLUB_USER_MEMBER_LEVEL_REMOVED_ADMIN_SUCCESS',
  PATCH_CLUB_USER_BAN_POSTING_SUCCESS: 'PATCH_CLUB_USER_BAN_POSTING_SUCCESS',
  PATCH_CLUB_USER_UN_BAN_POSTING_SUCCESS: 'PATCH_CLUB_USER_UN_BAN_POSTING_SUCCESS',
};

export const FOLDER_CONST = {
  MAX_RANGE_TITLE_FOLDER: 200,
};

export const NOTIFICATION_COUNT_TYPE = {
  LIKE_HIDDEN: 'likeHidden',
  FAVORITE_HIDDEN: 'favoriteHidden',
  VIEW_PROFILE_HIDDEN: 'viewProfileHidden',
  FRIEND_REQUEST_HIDDEN: 'friendRequestHidden',
  VALIDATION_HIDDEN: 'validationHidden',
  NOTIFICATION_ALERT_HIDDEN: 'notificationAlertHidden',
  NOTIFICATION_HIDDEN: 'notificationHidden',
  INTEREST_HIDDEN: 'interestHidden',
  LIKE: 'like',
  FAVORITE: 'favorite',
  VIEW_PROFILE: 'viewProfile',
  INTEREST: 'interest',
  SENDMESSAGE: 'sendMessage',
  MATCH: 'match',
  DO_ACTION: 'doAction',
  LOG_OUT: 'logout',
  PATCH_DATA: 'patchData',
  PROFILE_UPGRADE_SUCCESS: 'profileUpgraded',
  NAVIGATION: 'navigation',
  BOOSTING: 'Boosting',
};

export const IST_TYPE_IN_APP_SHOW_CUSTOM = [NOTIFICATION_COUNT_TYPE.PROFILE_UPGRADE_SUCCESS];

export const PROFILE_PROPERTY_TYPES = {
  LOCATION: 'location',
  RELATIONSHIP_STATUS: 'RelationshipStatus',
  AGE: 'Age',
  SEXUAL_ORIENTATION: 'SexualOrientation',
  RACE_ETHNICITY: 'RaceEthnicity',
  PERSONALITY: 'Personality',
  MY_LOOKS: 'MyLooks',
  BODY_TYPE: 'BodyType',
  HEIGHT: 'Height',
  EYE_COLOR: 'EyeColor',
  HAIR_COLOR: 'HairColor',
  HAIR_LENGTH: 'HairLength',
  DRINKING: 'Drinking',
  SMOKING: 'Smoking',
  SAFE_SEX: 'SafeSex',
  BODY_HAIR: 'BodyHair',
  PUBIC_HAIR: 'PubicHair',
  ENDOWMENT_THICKNESS: 'EndowmentThickness',
  ENDOWMENT_LENGTH: 'EndowmentLength',
  INTIMATE_PIERCINGS: 'IntimatePiercings',
  SEXUAL_PERSONALITY: 'SexualPersonality',
  GENERAL_INTEREST: 'GeneralInterest',
  FETISH_INTEREST: 'FetishInterest',
  SEXUAL_INTEREST: 'SexualInterest',
  CUP_SIZE: 'CupSize',
  MEMBER_TYPE: 'MemberType',
  GENDER: 'Gender',
};
export const ALBUM = [
  {
    id: 1,
    title: 'EditProfile.PublicAlbum',
    data: [],
    icon: images.icPublicAlbum,
    iconSVG: icPublicAlbum,
  },
  {
    id: 2,
    title: 'EditProfile.PrivateAlbum1',
    data: null,
    icon: images.icPrivateAlbum,
    iconSVG: icPublicAlbum,
  },
  {
    id: 3,
    title: 'EditProfile.PrivateAlbum2',
    data: null,
    icon: images.icPrivateAlbum,
    iconSVG: icPrivateAlbum,
  },
];

export const SUB_MENU = {
  DATE_FINDER: 'dateFinder',
  DATE_FINDER_HOME: 'DateFinderHome',
  DATE_FINDER_SEARCH: 'DateFinderSearch',
  TRAVEL_PLAN: 'travel-plan',
  ADD_TRAVEL_PLAN: 'add-travel-plan',
  MY_TRAVEL_PLAN: 'my-travel-plan',
  TRAVEL_PLAN_EVENTS: 'travel-events',
  ADD_EVENT: 'add-event',
  MY_EVENTS: 'my-events',
  INTERESTED_IN: 'interested-in',
  REGIONAL_FORUMS: 'regional-forums',
  GLOBAL_FORUMS: 'global-forums',
  ADD_TOPIC: 'add-topic',
  MY_TOPICS: 'my-topics',
  ADD_GROUP: 'add-group',
  MY_GROUPS: 'my-group',
  JOINED_GROUP: 'joined-group',
};

export const DATA_HEADER_DESKTOP = [
  {
    id: 1,
    name: 'HeaderDesktop.Home',
    url: FEED_HOME,
  },
  {
    id: 2,
    name: 'HeaderDesktop.Messenger',
    url: HOME,
    unReadCount: 'unreadConversations',
    unReadMatchingCount: 'unreadMatchingConversations',
  },
  {
    id: 3,
    name: 'HeaderDesktop.Discover',
    url: MEMBER,
  },
  {
    id: 11,
    name: 'HeaderDesktop.Prospects',
    url: PROSPECT,
  },
  {
    id: 4,
    name: 'HeaderDesktop.DateFinder',
    url: SUB_MENU.DATE_FINDER,
    pageRHP: false,
    subMenu: [
      {
        id: 1,
        name: 'HeaderDesktop.DateFinderHome',
        url: DATE_FINDER_PAGE,
      },
      {
        id: 2,
        name: 'HeaderDesktop.DateFinderSearch',
        url: SUB_MENU.DATE_FINDER_SEARCH,
      },
      {
        id: 3,
        name: 'HeaderDesktop.DateFinderMyDates',
        name2: 'HeaderDesktop.DateFinderMyDatesNumber',
        url: DATE_FINDER_MY_DATE,
      },
      {
        id: 4,
        name: 'HeaderDesktop.DateFinderAddDate',
        url: DATE_FINDER_ADD_DATE,
      },
    ],
  },
  {
    id: 5,
    name: 'HeaderDesktop.ChatRooms',
    // subName: 'Beta',
    url: CHAT_ROOMS,
  },
  {
    id: 6,
    name: 'HeaderDesktop.Groups',
    url: routes.GROUPS_VIEW,
    pageRHP: false,
    subMenu: [
      {
        id: 1,
        name: 'HeaderDesktop.Groups',
        url: routes.GROUPS_VIEW,
        isAllowOverlapClick: true,
      },
      {
        id: 2,
        name: 'HeaderDesktop.AddAGroup',
        url: SUB_MENU.ADD_GROUP,
      },
      {
        id: 3,
        name: 'HeaderDesktop.MyGroupsNumber',
        // name2: 'HeaderDesktop.EventMyEventsNumber',
        url: SUB_MENU.MY_GROUPS,
      },
      // {
      //   id: 4,
      //   name: 'HeaderDesktop.JoinedGroups',
      //   url: SUB_MENU.JOINED_GROUP,
      // },
    ],
  },
  {
    id: 7,
    name: 'HeaderDesktop.Events',
    url: routes.EVENTS,
    pageRHP: false,
    subMenu: [
      {
        id: 1,
        name: 'HeaderDesktop.EventListings',
        url: routes.EVENTS,
        isAllowOverlapClick: true,
      },
      // {
      //   id: 2,
      //   name: 'HeaderDesktop.EventClub',
      //   url: `${routes.EVENTS}/${routes.CLUB_ORGANISERS}`,
      // },
      {
        id: 3,
        name: 'HeaderDesktop.EventAdd',
        url: SUB_MENU.ADD_EVENT,
      },
      {
        id: 4,
        name: 'HeaderDesktop.EventMyEvents',
        name2: 'HeaderDesktop.EventMyEventsNumber',
        url: SUB_MENU.MY_EVENTS,
        stateValue: 1,
      },
      {
        id: 5,
        name: 'HeaderDesktop.InterestedIn',
        name2: 'HeaderDesktop.InterestedInNumber',
        url: SUB_MENU.INTERESTED_IN,
        stateValue: 2,
      },
    ],
  },
  {
    id: 8,
    name: 'HeaderDesktop.Travel',
    url: TRAVEL_PLAN,
    pageRHP: false,
    subMenu: [
      {
        id: 1,
        name: 'HeaderDesktop.Travel',
        url: TRAVEL_PLAN,
      },
      {
        id: 2,
        name: 'HeaderDesktop.AddATravel',
        url: SUB_MENU.ADD_TRAVEL_PLAN,
      },
      {
        id: 3,
        name: 'HeaderDesktop.MyTravelPlans',
        name2: 'HeaderDesktop.MyTravelPlansNumber',
        url: SUB_MENU.MY_TRAVEL_PLAN,
      },
      {
        id: 4,
        name: 'HeaderDesktop.TravelEvents',
        url: SUB_MENU.TRAVEL_PLAN_EVENTS,
      },
    ],
  },
  {
    id: 9,
    name: 'HeaderDesktop.AmateurPics',
    url: urls.URL_AMATEURS_DESKTOP,
    pageRHP: true,
    subMenu: [
      {
        id: 1,
        name: 'HeaderDesktop.AmateurPics',
        url: '#',
      },
      {
        id: 2,
        name: 'HeaderDesktop.AmateurPicsHOTY',
        url: '#',
      },
      {
        id: 3,
        name: 'HeaderDesktop.AmateurPicsHotPics',
        url: '#',
      },
      {
        id: 4,
        name: 'HeaderDesktop.AmateurPicsRHP',
        url: '#',
      },
      {
        id: 5,
        name: 'HeaderDesktop.AmateurPicsSubmitPics',
        url: '#',
      },
    ],
  },
  {
    id: 10,
    name: 'HeaderDesktop.AdultForums',
    // url: urls.URL_FORUM_DESKTOP,
    url: routes.FORUMS,
    pageRHP: false,
    subMenu: [
      {
        id: 1,
        name: 'HeaderDesktop.GlobalForums',
        url: routes.FORUMS,
      },
      {
        id: 2,
        name: 'HeaderDesktop.RegionalForums',
        url: `${routes.FORUMS}/${routes.REGIONAL_FORUMS}`,
        isAllowOverlapClick: true,
      },
      {
        id: 3,
        name: 'HeaderDesktop.PostYourTopic',
        url: `${routes.FORUMS}/${routes.ADD_TOPIC}`,
        // url: SUB_MENU.ADD_TOPIC
      },
      {
        id: 4,
        name: 'HeaderDesktop.MyTopics',
        name2: 'HeaderDesktop.MyTopicsNumber',
        url: `${routes.FORUMS}/${routes.MY_FORUMS}`,
        // url: SUB_MENU.MY_TOPICS
      },
    ],
  },
  {
    id: 11,
    name: 'HeaderDesktop.Community',
    url: `${routes.COMMUNITY}`,
    pageRHP: false,
    // url: urls.URL_COMMUNITY_DESKTOP,
    // pageRHP: true,
    subMenu: [
      {
        id: 1,
        name: 'HeaderDesktop.Community',
        url: `${routes.COMMUNITY}/${HOME}`,
      },
      {
        id: 2,
        name: 'HeaderDesktop.CommunityArticles',
        url: `${routes.COMMUNITY}/${ARTICLES}`,
      },
      {
        id: 3,
        name: 'HeaderDesktop.CommunityStories',
        url: `${routes.COMMUNITY}/${STORIES}`,
      },
      // {
      //   id: 4,
      //   name: 'HeaderDesktop.CommunityAsk',
      //   url: `${routes.COMMUNITY}/${ASK_SAMANTHA}`,
      // },
      // {
      //     id: 5,
      //     name: "HeaderDesktop.CommunityCompetitions",
      //     url: "#"
      // },
      // {
      //     id: 6,
      //     name: "HeaderDesktop.CommunitySexSecrets",
      //     url: "#"
      // },
      {
        id: 7,
        name: 'HeaderDesktop.CommunityOTG',
        url: `${routes.COMMUNITY}/${ON_THE_GROUND}`,
      },
      // {
      //     id: 8,
      //     name: "HeaderDesktop.CommunitySlice",
      //     url: "#"
      // },
      {
        id: 9,
        name: 'HeaderDesktop.CommunityTestimonials',
        url: `${routes.COMMUNITY}/${TESTIMONIALS}`,
      },
    ],
  },
];

export const LEGAL_POLICY_TYPES = {
  ABOUT_RHP: 'AboutRedHotPie',
  TERMS_OF_USE: 'TermsOfUse',
  PRIVACY_POLICY: 'PrivacyPolicy',
  PHOTO_GUIDELINES: 'PhotoGuidelines',
  DATING_SAFETY: 'DatingSafety',
  COMMUNITY_GUIDELINES: 'CommunityGuidelines',
};

export const SETTING_LEGAL_POLICIES = [
  {
    id: 6,
    name: LEGAL_POLICY_TYPES.ABOUT_RHP,
    label: 'Legal.AboutRHP',
    isNotRHPLink: true,
    url: `${ROOT_FOLDER}/${MAIN_SETTING}/${LEGAL}/${ABOUT_RHP}`,
  },
  {
    id: 1,
    name: LEGAL_POLICY_TYPES.TERMS_OF_USE,
    label: 'Legal.TermsOfUse',
    url: urls.TERMS_OF_USE,
  },
  {
    id: 2,
    name: LEGAL_POLICY_TYPES.PRIVACY_POLICY,
    label: 'Legal.PrivacyPolicy',
    url: urls.PRIVACY_POLICY,
  },
  {
    id: 3,
    name: LEGAL_POLICY_TYPES.PHOTO_GUIDELINES,
    label: 'Legal.PhotoGuideLines',
    url: urls.PHOTO_GUIDELINES,
  },
  {
    id: 4,
    name: LEGAL_POLICY_TYPES.DATING_SAFETY,
    label: 'Legal.DatingSafety',
    url: urls.DATING_SAFETY,
  },
  {
    id: 5,
    name: LEGAL_POLICY_TYPES.COMMUNITY_GUIDELINES,
    label: 'Legal.CommunityGuideLines',
    url: urls.COMMUNITY_GUIDELINES,
  },
  // {
  //   id: 7,
  //   label: "HelpSupport.RedHotPieVersion",
  //   url: "",
  // },
];

export const SETTING_LEGAL_POLICY_TYPES = {
  TERMS_OF_USE: 'TermsOfUse',
  PRIVACY_POLICY: 'PrivacyPolicy',
  PHOT_GUIDELINES: 'PhotoGuidelines',
  DATING_SAFETY: 'DatingSafety',
  COMMUNITY_GUIDELINES: 'CommunityGuidelines',
};

export const FOOTER_NAVIGATIONS = {
  CONTACT_US: 'ContactUS',
  SITE_MAP: 'Sitemap',
  TERMS_OF_USE: 'TermsOfUse',
  PRIVACY_POLICY: 'PrivacyPolicy',
  DATING_SAFETY: 'DatingSafety',
  REPORT_ABUSE: 'ReportAbuse',
  COMMUNITY_GUIDELINES: 'CommunityGuidelines',
  CORPORATE: 'Corporate',
  MEDIA_CENTRE: 'MediaCentre',
  TESTIMONIALS: 'Testimonials',
  ADVERTISE: 'Advertise',
  MOBILE_DATING: 'MobileDating',
  AFFILIATES: 'Affiliates',
};

export const DATA_FOOTER_DESKTOP = {
  LEFT_NAVIGATIONS: [
    // {
    //     id: 1,
    //     name: FOOTER_NAVIGATIONS.SITE_MAP,
    //     label: 'FooterDesktop.Sitemap',
    //     url: '/SiteMap.aspx',
    // },
    {
      id: 2,
      name: FOOTER_NAVIGATIONS.TERMS_OF_USE,
      label: 'FooterDesktop.TermsOfUse',
      url: urls.TERMS_OF_USE,
    },
    {
      id: 3,
      name: FOOTER_NAVIGATIONS.PRIVACY_POLICY,
      label: 'FooterDesktop.PrivacyPolicy',
      url: urls.PRIVACY_POLICY,
    },
    {
      id: 4,
      name: FOOTER_NAVIGATIONS.DATING_SAFETY,
      label: 'FooterDesktop.DatingSafety',
      url: urls.DATING_SAFETY,
    },
    {
      id: 5,
      name: FOOTER_NAVIGATIONS.REPORT_ABUSE,
      label: 'FooterDesktop.ReportAbuse',
      url: 'https://help.redhotpie.com',
    },
    {
      id: 6,
      name: FOOTER_NAVIGATIONS.COMMUNITY_GUIDELINES,
      label: 'FooterDesktop.CommunityGuidelines',
      url: urls.COMMUNITY_GUIDELINES,
    },
  ],
  RIGHT_NAVIGATIONS: [
    {
      id: 7,
      name: FOOTER_NAVIGATIONS.CORPORATE,
      label: 'FooterDesktop.Corporate',
      url: '/CorporateInformation.aspx',
    },
    {
      id: 8,
      name: FOOTER_NAVIGATIONS.MEDIA_CENTRE,
      label: 'FooterDesktop.MediaCentre',
      url: '/MediaCenter',
    },
    {
      id: 9,
      name: FOOTER_NAVIGATIONS.TESTIMONIALS,
      label: 'FooterDesktop.Testimonials',
      url: '/Testimonial/',
    },
    {
      id: 10,
      name: FOOTER_NAVIGATIONS.ADVERTISE,
      label: 'FooterDesktop.Advertise',
      url: '/contacts/Advertise.aspx',
    },
    {
      id: 11,
      name: FOOTER_NAVIGATIONS.MOBILE_DATING,
      label: 'FooterDesktop.MobileDating',
      url: 'http://rhpmobile.com/',
    },
    {
      id: 12,
      name: FOOTER_NAVIGATIONS.AFFILIATES,
      label: 'FooterDesktop.Affiliates',
      url: 'http://affiliates.redhotpie.com.au/',
    },
  ],
};

export const RHP_URL_PATH = {
  SEX_SECRET: '/SexSecret/',
  POLL: '/Poll/',
  ON_THE_GROUND: '/OnTheGround/',
  TESTIMONIAL: '/Testimonial/',
  ARTICLE: '/Article/',
  ADULT_FORUMS: '/Adult-Forums/',
  SEX_STORIES: '/SexStories/',
  DATE_FINDER: '/DateFinder/',
};

export const TOOLTIP_SHOW_TIME = {
  DISCOVER_FAVED: 2000,
};

// the minimize number of user in discover to load more
export const DISCOVER_USERS_MIN = 5;
export const DISCOVER_USERS_MIN_DESKTOP = 24;

export const DEFAULT_FOLDER_OPTION = {
  ALL: 'All',
  MATCHING: 'Matching',
};

export const LOG_TYPE = {
  DEBUG: 'DEBUG',
  INFO: 'INFO',
  ERROR: 'ERROR',
};

export const LOG_CATEGORY = {
  TRACKING_REFRESH_TOKEN: 'TRACKING_REFRESH_TOKEN',
  TRACKING_WEBSOCKET: 'TRACKING_WEBSOCKET',
  CHAT: 'CHAT',
  NOTIFY_MESSAGE_SENT: 'NOTIFY_MESSAGE_SENT',
  NOTIFY_MESSAGE_SENT_NO_RESPONSE: 'NOTIFY_MESSAGE_SENT_NO_RESPONSE',
  RESPONSE_CONVERSATION_EMPTY: 'RESPONSE_CONVERSATION_EMPTY',
  ON_MESSAGE_DELIVERY_SUCCESS_NOT_VALID: 'ON_MESSAGE_DELIVERY_SUCCESS_NOT_VALID',
  AFTER_WEBSOCKET_MESSAGE_SENT: 'AFTER_WEBSOCKET_MESSAGE_SENT',
  GLOBAL: 'GLOBAL',
  GLOBAL_TEST: 'GLOBAL_DEV_SETVER',
  VIDEO_CALL: 'VIDEO_CALL',
  CHAT_ROOM_LIVE_STREAM: 'CHAT_ROOM_LIVE_STREAM',
  PURCHASE_INFO: 'PURCHASE_INFO',
  PURCHASE_ERROR: 'PURCHASE_ERROR',
  PURCHASE_ERROR_API: 'PURCHASE_ERROR_API',
  RESTORE_PURCHASE: 'RESTORE_PURCHASE',
  IAP_APPLE_API_EXCEPTION: 'IAP_APPLE_API_EXCEPTION',
  IAP_GOOGLE_API_EXCEPTION: 'IAP_GOOGLE_API_EXCEPTION',
  IAP_APPLE_API_RES_ERROR: 'IAP_APPLE_API_RES_ERROR',
  IAP_GOOGLE_API_RES_ERROR: 'IAP_GOOGLE_API_RES_ERROR',
};

export const NOTIFICATION_URBAN_TYPE = {
  PROFILE: 'Profile', // Open profile
  CONVERSATION: 'Conversation', // Open conversation modal
  LIKE: 'Like', // open prospect => open profile
  MATCH: 'Match', // open prospect => open profile
  FAVORITE: 'Favorite', // open prospect => open profile
  FORUM_TOPIC: 'ForumTopic', // open topic details
  STORY_COMMENTS: 'StoryComments', // open blog details
  EVENT_COMMENTS: 'EventComments', // open event details
  GROUP_CONVERSATION: 'GroupConversation', // open conversations
  PROFILE_VERIFICATION_REJECTED: 'ProfileVerificationRejected', // open verification screen
  PROFILE_VERIFICATION_APPROVED: 'ProfileVerificationApproved', // No action
  MAIN_PHOTO_APPROVED: 'MainPhotoApproved',
  SCREEN_SHOT: 'Screenshot',
  PROFILE_BOOST: 'ProfileBoost',
  SPOTLIGHT_PICK_DAILY: 'SpotlightTodaysPic',
  EVENT_APPROVED: 'EventApproved',
  EVENT_REJECTED: 'EventRejected',
  PROFILE_VERIFIED_REJECTED: 'ProfileVerifiedRejected', // open verification screen
  GROUP_DETAIL: 'GroupDetail',
  EVENT_INTEREST: 'EventInterest',
  GROUP_MEMBER_REQUEST: 'GroupMemberRequest',
  GROUP_JOIN_APPROVED: 'GroupJoinApproved',
  GROUP_REJECTED: 'GroupRejected',
  GROUP_APPROVED: 'GroupApproved',
  CHAT_ROOM_REMINDER: 'ChatRoomReminder',
  GROUP_INVITE: 'GroupInvite',
  EVENT_INVITE: 'EventInvite',
  GROUP_VALIDATION: 'GroupValidation',
  EVENT: 'Event',
};

export const APPROVAL_STATUS = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  RESTRICTED: 'Restricted',
  LOCKED: 'Locked',
  DECLINED: 'Declined',
};

export type ApprovalStatusType = (typeof APPROVAL_STATUS)[keyof typeof APPROVAL_STATUS];

export const MATCHING_DONTMATCHING = {
  MATCHING: 1,
  DONT_MATCHING: 0,
};
export const MASS_MSG_CATEGORY = {
  EVENT: 'event',
  DATE_FINDER: 'dateFinder',
  RATING: 'rating',
  ARTICLE: 'article',
  VERIFICATION: 'verification',
  DEAL_BREAKER: 'dealBreaker',
  UPGRADE_PAGE: 'upgradePage',
  RHP_COINS: 'rhpCoin',
};
export const COUNTRIES_DATA = [
  {
    name: 'Afghanistan',
    dial_code: '+93',
    code: 'AF',
    latitude: 33,
    longitude: 65,
  },
  {
    name: 'Albania',
    dial_code: '+355',
    code: 'AL',
    latitude: 41,
    longitude: 20,
  },
  {
    name: 'Algeria',
    dial_code: '+213',
    code: 'DZ',
    latitude: 28,
    longitude: 3,
  },
  {
    name: 'AmericanSamoa',
    dial_code: '+1 684',
    code: 'AS',
    latitude: -14.3333,
    longitude: -170,
  },
  {
    name: 'Andorra',
    dial_code: '+376',
    code: 'AD',
    latitude: 42.5,
    longitude: 1.6,
  },
  {
    name: 'Angola',
    dial_code: '+244',
    code: 'AO',
    latitude: -12.5,
    longitude: 18.5,
  },
  {
    name: 'Anguilla',
    dial_code: '+1 264',
    code: 'AI',
    latitude: 18.25,
    longitude: -63.1667,
  },
  {
    name: 'Antarctica',
    dial_code: '+672',
    code: 'AQ',
    latitude: -90,
    longitude: '0',
  },
  {
    name: 'Antigua and Barbuda',
    dial_code: '+1268',
    code: 'AG',
    latitude: 17.05,
    longitude: -61.8,
  },
  {
    name: 'Argentina',
    dial_code: '+54',
    code: 'AR',
    latitude: -34,
    longitude: -64,
  },
  {
    name: 'Armenia',
    dial_code: '+374',
    code: 'AM',
    latitude: 40,
    longitude: 45,
  },
  {
    name: 'Aruba',
    dial_code: '+297',
    code: 'AW',
    latitude: 12.5,
    longitude: -69.9667,
  },
  {
    name: 'Australia',
    dial_code: '+61',
    code: 'AU',
    latitude: -27,
    longitude: 133,
  },
  {
    name: 'Austria',
    dial_code: '+43',
    code: 'AT',
    latitude: 47.3333,
    longitude: 13.3333,
  },
  {
    name: 'Azerbaijan',
    dial_code: '+994',
    code: 'AZ',
    latitude: 40.5,
    longitude: 47.5,
  },
  {
    name: 'Bahamas',
    dial_code: '+1 242',
    code: 'BS',
    latitude: 24.25,
    longitude: -76,
  },
  {
    name: 'Bahrain',
    dial_code: '+973',
    code: 'BH',
    latitude: 26,
    longitude: 50.55,
  },
  {
    name: 'Bangladesh',
    dial_code: '+880',
    code: 'BD',
    latitude: 24,
    longitude: 90,
  },
  {
    name: 'Barbados',
    dial_code: '+1 246',
    code: 'BB',
    latitude: 13.1667,
    longitude: -59.5333,
  },
  {
    name: 'Belarus',
    dial_code: '+375',
    code: 'BY',
    latitude: 53,
    longitude: 28,
  },
  {
    name: 'Belgium',
    dial_code: '+32',
    code: 'BE',
    latitude: 50.8333,
    longitude: 4,
  },
  {
    name: 'Belize',
    dial_code: '+501',
    code: 'BZ',
    latitude: 17.25,
    longitude: -88.75,
  },
  {
    name: 'Benin',
    dial_code: '+229',
    code: 'BJ',
    latitude: 9.5,
    longitude: 2.25,
  },
  {
    name: 'Bermuda',
    dial_code: '+1 441',
    code: 'BM',
    latitude: 32.3333,
    longitude: -64.75,
  },
  {
    name: 'Bhutan',
    dial_code: '+975',
    code: 'BT',
    latitude: 27.5,
    longitude: 90.5,
  },
  {
    name: 'Bolivia, Plurinational State of Bolivia',
    dial_code: '+591',
    code: 'BO',
    latitude: -17,
    longitude: -65,
  },
  {
    name: 'Bosnia and Herzegovina',
    dial_code: '+387',
    code: 'BA',
    latitude: 44,
    longitude: 18,
  },
  {
    name: 'Botswana',
    dial_code: '+267',
    code: 'BW',
    latitude: -22,
    longitude: 24,
  },
  {
    name: 'Bouvet Island',
    dial_code: '+55',
    code: 'BV',
    latitude: -54.4333,
    longitude: 3.4,
  },
  {
    name: 'Brazil',
    dial_code: '+55',
    code: 'BR',
    latitude: -10,
    longitude: -55,
  },
  {
    name: 'British Indian Ocean Territory',
    dial_code: '+246',
    code: 'IO',
    latitude: -6,
    longitude: 71.5,
  },
  {
    name: 'Brunei Darussalam',
    dial_code: '+673',
    code: 'BN',
    latitude: 4.5,
    longitude: 114.6667,
  },
  {
    name: 'Bulgaria',
    dial_code: '+359',
    code: 'BG',
    latitude: 43,
    longitude: 25,
  },
  {
    name: 'Burkina Faso',
    dial_code: '+226',
    code: 'BF',
    latitude: 13,
    longitude: -2,
  },
  {
    name: 'Burundi',
    dial_code: '+257',
    code: 'BI',
    latitude: -3.5,
    longitude: 30,
  },
  {
    name: 'Cambodia',
    dial_code: '+855',
    code: 'KH',
    latitude: 13,
    longitude: 105,
  },
  {
    name: 'Cameroon',
    dial_code: '+237',
    code: 'CM',
    latitude: 6,
    longitude: 12,
  },
  {
    name: 'Canada',
    dial_code: '+1',
    code: 'CA',
    latitude: 60,
    longitude: -95,
  },
  {
    name: 'Cape Verde',
    dial_code: '+238',
    code: 'CV',
    latitude: 16,
    longitude: -24,
  },
  {
    name: 'Cayman Islands',
    dial_code: '+1345',
    code: 'KY',
    latitude: 19.5,
    longitude: -80.5,
  },
  {
    name: 'Central African Republic',
    dial_code: '+236',
    code: 'CF',
    latitude: 7,
    longitude: 21,
  },
  { name: 'Chad', dial_code: '+235', code: 'TD', latitude: 15, longitude: 19 },
  {
    name: 'Chile',
    dial_code: '+56',
    code: 'CL',
    latitude: -30,
    longitude: -71,
  },
  { name: 'China', dial_code: '+86', code: 'CN', latitude: 35, longitude: 105 },
  {
    name: 'Christmas Island',
    dial_code: '+61',
    code: 'CX',
    latitude: -10.5,
    longitude: 105.6667,
  },
  {
    name: 'Cocos (Keeling) Islands',
    dial_code: '+61',
    code: 'CC',
    latitude: -12.5,
    longitude: 96.8333,
  },
  {
    name: 'Colombia',
    dial_code: '+57',
    code: 'CO',
    latitude: 4,
    longitude: -72,
  },
  {
    name: 'Comoros',
    dial_code: '+269',
    code: 'KM',
    latitude: -12.1667,
    longitude: 44.25,
  },
  {
    name: 'Congo',
    dial_code: '+242',
    code: 'CG',
    latitude: -1,
    longitude: 15,
  },
  {
    name: 'Congo, The Democratic Republic of the',
    dial_code: '+243',
    code: 'CD',
    latitude: '0',
    longitude: 25,
  },
  {
    name: 'Cook Islands',
    dial_code: '+682',
    code: 'CK',
    latitude: -21.2333,
    longitude: -159.7667,
  },
  {
    name: 'Costa Rica',
    dial_code: '+506',
    code: 'CR',
    latitude: 10,
    longitude: -84,
  },
  {
    name: "Cote d'Ivoire",
    dial_code: '+225',
    code: 'CI',
    latitude: 8,
    longitude: -5,
  },
  {
    name: 'Croatia',
    dial_code: '+385',
    code: 'HR',
    latitude: 45.1667,
    longitude: 15.5,
  },
  {
    name: 'Cuba',
    dial_code: '+53',
    code: 'CU',
    latitude: 21.5,
    longitude: -80,
  },
  {
    name: 'Cyprus',
    dial_code: '+357',
    code: 'CY',
    latitude: 35,
    longitude: 33,
  },
  {
    name: 'Czech Republic',
    dial_code: '+420',
    code: 'CZ',
    latitude: 49.75,
    longitude: 15.5,
  },
  {
    name: 'Denmark',
    dial_code: '+45',
    code: 'DK',
    latitude: 56,
    longitude: 10,
  },
  {
    name: 'Djibouti',
    dial_code: '+253',
    code: 'DJ',
    latitude: 11.5,
    longitude: 43,
  },
  {
    name: 'Dominica',
    dial_code: '+1 767',
    code: 'DM',
    latitude: 15.4167,
    longitude: -61.3333,
  },
  {
    name: 'Dominican Republic',
    dial_code: '+1 849',
    code: 'DO',
    latitude: 19,
    longitude: -70.6667,
  },
  {
    name: 'Ecuador',
    dial_code: '+593',
    code: 'EC',
    latitude: -2,
    longitude: -77.5,
  },
  {
    name: 'Egypt',
    dial_code: '+20',
    code: 'EG',
    latitude: 27,
    longitude: 30,
  },
  {
    name: 'El Salvador',
    dial_code: '+503',
    code: 'SV',
    latitude: 13.8333,
    longitude: -88.9167,
  },
  {
    name: 'Equatorial Guinea',
    dial_code: '+240',
    code: 'GQ',
    latitude: 2,
    longitude: 10,
  },
  {
    name: 'Eritrea',
    dial_code: '+291',
    code: 'ER',
    latitude: 15,
    longitude: 39,
  },
  {
    name: 'Estonia',
    dial_code: '+372',
    code: 'EE',
    latitude: 59,
    longitude: 26,
  },
  {
    name: 'Ethiopia',
    dial_code: '+251',
    code: 'ET',
    latitude: 8,
    longitude: 38,
  },
  {
    name: 'Falkland Islands (Malvinas)',
    dial_code: '+500',
    code: 'FK',
    latitude: -51.75,
    longitude: -59,
  },
  {
    name: 'Faroe Islands',
    dial_code: '+298',
    code: 'FO',
    latitude: 62,
    longitude: -7,
  },
  {
    name: 'Fiji',
    dial_code: '+679',
    code: 'FJ',
    latitude: -18,
    longitude: 175,
  },
  {
    name: 'Finland',
    dial_code: '+358',
    code: 'FI',
    latitude: 64,
    longitude: 26,
  },
  {
    name: 'France',
    dial_code: '+33',
    code: 'FR',
    latitude: 46,
    longitude: 2,
  },
  {
    name: 'French Guiana',
    dial_code: '+594',
    code: 'GF',
    latitude: 4,
    longitude: -53,
  },
  {
    name: 'French Polynesia',
    dial_code: '+689',
    code: 'PF',
    latitude: -15,
    longitude: -140,
  },
  {
    name: 'French Southern and Antarctic Lands',
    dial_code: '+262',
    code: 'TF',
    latitude: -43,
    longitude: 67,
  },
  {
    name: 'Gabon',
    dial_code: '+241',
    code: 'GA',
    latitude: -1,
    longitude: 11.75,
  },
  {
    name: 'Gambia',
    dial_code: '+220',
    code: 'GM',
    latitude: 13.4667,
    longitude: -16.5667,
  },
  {
    name: 'Georgia',
    dial_code: '+995',
    code: 'GE',
    latitude: 42,
    longitude: 43.5,
  },
  {
    name: 'Germany',
    dial_code: '+49',
    code: 'DE',
    latitude: 51,
    longitude: 9,
  },
  { name: 'Ghana', dial_code: '+233', code: 'GH', latitude: 8, longitude: -2 },
  {
    name: 'Gibraltar',
    dial_code: '+350',
    code: 'GI',
    latitude: 36.1833,
    longitude: -5.3667,
  },
  { name: 'Greece', dial_code: '+30', code: 'GR', latitude: 39, longitude: 22 },
  {
    name: 'Greenland',
    dial_code: '+299',
    code: 'GL',
    latitude: 72,
    longitude: -40,
  },
  {
    name: 'Grenada',
    dial_code: '+1 473',
    code: 'GD',
    latitude: 12.1167,
    longitude: -61.6667,
  },
  {
    name: 'Guadeloupe',
    dial_code: '+590',
    code: 'GP',
    latitude: 16.25,
    longitude: -61.5833,
  },
  {
    name: 'Guam',
    dial_code: '+1 671',
    code: 'GU',
    latitude: 13.4667,
    longitude: 144.7833,
  },
  {
    name: 'Guatemala',
    dial_code: '+502',
    code: 'GT',
    latitude: 15.5,
    longitude: -90.25,
  },
  {
    name: 'Guernsey',
    dial_code: '+44',
    code: 'GG',
    latitude: 49.5,
    longitude: -2.56,
  },
  {
    name: 'Guinea',
    dial_code: '+224',
    code: 'GN',
    latitude: 11,
    longitude: -10,
  },
  {
    name: 'Guinea-Bissau',
    dial_code: '+245',
    code: 'GW',
    latitude: 12,
    longitude: -15,
  },
  {
    name: 'Guyana',
    dial_code: '+592',
    code: 'GY',
    latitude: 5,
    longitude: -59,
  },
  {
    name: 'Haiti',
    dial_code: '+509',
    code: 'HT',
    latitude: 19,
    longitude: -72.4167,
  },
  {
    name: 'Heard Island and McDonald Islands',
    dial_code: '+672',
    code: 'HM',
    latitude: -53.1,
    longitude: 72.5167,
  },
  {
    name: 'Holy See (Vatican City State)',
    dial_code: '+379',
    code: 'VA',
    latitude: 41.9,
    longitude: 12.45,
  },
  {
    name: 'Honduras',
    dial_code: '+504',
    code: 'HN',
    latitude: 15,
    longitude: -86.5,
  },
  {
    name: 'Hong Kong',
    dial_code: '+852',
    code: 'HK',
    latitude: 22.25,
    longitude: 114.1667,
  },
  {
    name: 'Hungary',
    dial_code: '+36',
    code: 'HU',
    latitude: 47,
    longitude: 20,
  },
  {
    name: 'Iceland',
    dial_code: '+354',
    code: 'IS',
    latitude: 65,
    longitude: -18,
  },
  { name: 'India', dial_code: '+91', code: 'IN', latitude: 20, longitude: 77 },
  {
    name: 'Indonesia',
    dial_code: '+62',
    code: 'ID',
    latitude: -5,
    longitude: 120,
  },
  {
    name: 'Iran, Islamic Republic of',
    dial_code: '+98',
    code: 'IR',
    latitude: 32,
    longitude: 53,
  },
  { name: 'Iraq', dial_code: '+964', code: 'IQ', latitude: 33, longitude: 44 },
  {
    name: 'Ireland',
    dial_code: '+353',
    code: 'IE',
    latitude: 53,
    longitude: -8,
  },
  {
    name: 'Isle of Man',
    dial_code: '+44',
    code: 'IM',
    latitude: 54.23,
    longitude: -4.55,
  },
  {
    name: 'Israel',
    dial_code: '+972',
    code: 'IL',
    latitude: 31.5,
    longitude: 34.75,
  },
  {
    name: 'Italy',
    dial_code: '+39',
    code: 'IT',
    latitude: 42.8333,
    longitude: 12.8333,
  },
  {
    name: 'Jamaica',
    dial_code: '+1 876',
    code: 'JM',
    latitude: 18.25,
    longitude: -77.5,
  },
  { name: 'Japan', dial_code: '+81', code: 'JP', latitude: 36, longitude: 138 },
  {
    name: 'Jersey',
    dial_code: '+44',
    code: 'JE',
    latitude: 49.21,
    longitude: -2.13,
  },
  {
    name: 'Jordan',
    dial_code: '+962',
    code: 'JO',
    latitude: 31,
    longitude: 36,
  },
  {
    name: 'Kazakhstan',
    dial_code: '+7',
    code: 'KZ',
    latitude: 48,
    longitude: 68,
  },
  { name: 'Kenya', dial_code: '+254', code: 'KE', latitude: 1, longitude: 38 },
  {
    name: 'Kiribati',
    dial_code: '+686',
    code: 'KI',
    latitude: 1.4167,
    longitude: 173,
  },
  {
    name: "Korea, Democratic People's Republic of",
    dial_code: '+850',
    code: 'KP',
    latitude: 40,
    longitude: 127,
  },
  {
    name: 'Korea, Republic of',
    dial_code: '+82',
    code: 'KR',
    latitude: 37,
    longitude: 127.5,
  },
  {
    name: 'Kuwait',
    dial_code: '+965',
    code: 'KW',
    latitude: 29.3375,
    longitude: 47.6581,
  },
  {
    name: 'Kyrgyzstan',
    dial_code: '+996',
    code: 'KG',
    latitude: 41,
    longitude: 75,
  },
  {
    name: "Lao People's Democratic Republic",
    dial_code: '+856',
    code: 'LA',
    latitude: 18,
    longitude: 105,
  },
  {
    name: 'Latvia',
    dial_code: '+371',
    code: 'LV',
    latitude: 57,
    longitude: 25,
  },
  {
    name: 'Lebanon',
    dial_code: '+961',
    code: 'LB',
    latitude: 33.8333,
    longitude: 35.8333,
  },
  {
    name: 'Lesotho',
    dial_code: '+266',
    code: 'LS',
    latitude: -29.5,
    longitude: 28.5,
  },
  {
    name: 'Liberia',
    dial_code: '+231',
    code: 'LR',
    latitude: 6.5,
    longitude: -9.5,
  },
  {
    name: 'Libyan Arab Jamahiriya',
    dial_code: '+218',
    code: 'LY',
    latitude: 25,
    longitude: 17,
  },
  {
    name: 'Liechtenstein',
    dial_code: '+423',
    code: 'LI',
    latitude: 47.1667,
    longitude: 9.5333,
  },
  {
    name: 'Lithuania',
    dial_code: '+370',
    code: 'LT',
    latitude: 56,
    longitude: 24,
  },
  {
    name: 'Luxembourg',
    dial_code: '+352',
    code: 'LU',
    latitude: 49.75,
    longitude: 6.1667,
  },
  {
    name: 'Macao',
    dial_code: '+853',
    code: 'MO',
    latitude: 22.1667,
    longitude: 113.55,
  },
  {
    name: 'Macedonia, The Former Yugoslav Republic of',
    dial_code: '+389',
    code: 'MK',
    latitude: 41.8333,
    longitude: 22,
  },
  {
    name: 'Madagascar',
    dial_code: '+261',
    code: 'MG',
    latitude: -20,
    longitude: 47,
  },
  {
    name: 'Malawi',
    dial_code: '+265',
    code: 'MW',
    latitude: -13.5,
    longitude: 34,
  },
  {
    name: 'Malaysia',
    dial_code: '+60',
    code: 'MY',
    latitude: 2.5,
    longitude: 112.5,
  },
  {
    name: 'Maldives',
    dial_code: '+960',
    code: 'MV',
    latitude: 3.25,
    longitude: 73,
  },
  { name: 'Mali', dial_code: '+223', code: 'ML', latitude: 17, longitude: -4 },
  {
    name: 'Malta',
    dial_code: '+356',
    code: 'MT',
    latitude: 35.8333,
    longitude: 14.5833,
  },
  {
    name: 'Marshall Islands',
    dial_code: '+692',
    code: 'MH',
    latitude: 9,
    longitude: 168,
  },
  {
    name: 'Martinique',
    dial_code: '+596',
    code: 'MQ',
    latitude: 14.6667,
    longitude: -61,
  },
  {
    name: 'Mauritania',
    dial_code: '+222',
    code: 'MR',
    latitude: 20,
    longitude: -12,
  },
  {
    name: 'Mauritius',
    dial_code: '+230',
    code: 'MU',
    latitude: -20.2833,
    longitude: 57.55,
  },
  {
    name: 'Mayotte',
    dial_code: '+262',
    code: 'YT',
    latitude: -12.8333,
    longitude: 45.1667,
  },
  {
    name: 'Mexico',
    dial_code: '+52',
    code: 'MX',
    latitude: 23,
    longitude: -102,
  },
  {
    name: 'Micronesia, Federated States of',
    dial_code: '+691',
    code: 'FM',
    latitude: 6.9167,
    longitude: 158.25,
  },
  {
    name: 'Moldova, Republic of',
    dial_code: '+373',
    code: 'MD',
    latitude: 47,
    longitude: 29,
  },
  {
    name: 'Monaco',
    dial_code: '+377',
    code: 'MC',
    latitude: 43.7333,
    longitude: 7.4,
  },
  {
    name: 'Mongolia',
    dial_code: '+976',
    code: 'MN',
    latitude: 46,
    longitude: 105,
  },
  {
    name: 'Montenegro',
    dial_code: '+382',
    code: 'ME',
    latitude: 42,
    longitude: 19,
  },
  {
    name: 'Montserrat',
    dial_code: '+1664',
    code: 'MS',
    latitude: 16.75,
    longitude: -62.2,
  },
  {
    name: 'Morocco',
    dial_code: '+212',
    code: 'MA',
    latitude: 32,
    longitude: -5,
  },
  {
    name: 'Mozambique',
    dial_code: '+258',
    code: 'MZ',
    latitude: -18.25,
    longitude: 35,
  },
  {
    name: 'Myanmar',
    dial_code: '+95',
    code: 'MM',
    latitude: 22,
    longitude: 98,
  },
  {
    name: 'Namibia',
    dial_code: '+264',
    code: 'NA',
    latitude: -22,
    longitude: 17,
  },
  {
    name: 'Nauru',
    dial_code: '+674',
    code: 'NR',
    latitude: -0.5333,
    longitude: 166.9167,
  },
  {
    name: 'Nepal',
    dial_code: '+977',
    code: 'NP',
    latitude: 28,
    longitude: 84,
  },
  {
    name: 'Netherlands',
    dial_code: '+31',
    code: 'NL',
    latitude: 52.5,
    longitude: 5.75,
  },
  {
    name: 'Netherlands Antilles',
    dial_code: '+599',
    code: 'AN',
    latitude: 12.25,
    longitude: -68.75,
  },
  {
    name: 'New Caledonia',
    dial_code: '+687',
    code: 'NC',
    latitude: -21.5,
    longitude: 165.5,
  },
  {
    name: 'New Zealand',
    dial_code: '+64',
    code: 'NZ',
    latitude: -41,
    longitude: 174,
  },
  {
    name: 'Nicaragua',
    dial_code: '+505',
    code: 'NI',
    latitude: 13,
    longitude: -85,
  },
  { name: 'Niger', dial_code: '+227', code: 'NE', latitude: 16, longitude: 8 },
  {
    name: 'Nigeria',
    dial_code: '+234',
    code: 'NG',
    latitude: 10,
    longitude: 8,
  },
  {
    name: 'Niue',
    dial_code: '+683',
    code: 'NU',
    latitude: -19.0333,
    longitude: -169.8667,
  },
  {
    name: 'Norfolk Island',
    dial_code: '+672',
    code: 'NF',
    latitude: -29.0333,
    longitude: 167.95,
  },
  {
    name: 'Northern Mariana Islands',
    dial_code: '+1 670',
    code: 'MP',
    latitude: 15.2,
    longitude: 145.75,
  },
  { name: 'Norway', dial_code: '+47', code: 'NO', latitude: 62, longitude: 10 },
  {
    name: 'Oman',
    dial_code: '+968',
    code: 'OM',
    latitude: 21,
    longitude: 57,
  },
  {
    name: 'Pakistan',
    dial_code: '+92',
    code: 'PK',
    latitude: 30,
    longitude: 70,
  },
  {
    name: 'Palau',
    dial_code: '+680',
    code: 'PW',
    latitude: 7.5,
    longitude: 134.5,
  },
  {
    name: 'Palestinian Territory, Occupied',
    dial_code: '+970',
    code: 'PS',
    latitude: 32,
    longitude: 35.25,
  },
  {
    name: 'Panama',
    dial_code: '+507',
    code: 'PA',
    latitude: 9,
    longitude: -80,
  },
  {
    name: 'Papua New Guinea',
    dial_code: '+675',
    code: 'PG',
    latitude: -6,
    longitude: 147,
  },
  {
    name: 'Paraguay',
    dial_code: '+595',
    code: 'PY',
    latitude: -23,
    longitude: -58,
  },
  {
    name: 'Peru',
    dial_code: '+51',
    code: 'PE',
    latitude: -10,
    longitude: -76,
  },
  {
    name: 'Philippines',
    dial_code: '+63',
    code: 'PH',
    latitude: 13,
    longitude: 122,
  },
  {
    name: 'Pitcairn',
    dial_code: '+870',
    code: 'PN',
    latitude: -24.7,
    longitude: -127.4,
  },
  { name: 'Poland', dial_code: '+48', code: 'PL', latitude: 52, longitude: 20 },
  {
    name: 'Portugal',
    dial_code: '+351',
    code: 'PT',
    latitude: 39.5,
    longitude: -8,
  },
  {
    name: 'Puerto Rico',
    dial_code: '+1 939',
    code: 'PR',
    latitude: 18.25,
    longitude: -66.5,
  },
  {
    name: 'Qatar',
    dial_code: '+974',
    code: 'QA',
    latitude: 25.5,
    longitude: 51.25,
  },
  {
    name: 'Réunion',
    dial_code: '+262',
    code: 'RE',
    latitude: -21.1,
    longitude: 55.6,
  },
  {
    name: 'Romania',
    dial_code: '+40',
    code: 'RO',
    latitude: 46,
    longitude: 25,
  },
  {
    name: 'Russia',
    dial_code: '+7',
    code: 'RU',
    latitude: 60,
    longitude: 100,
  },
  {
    name: 'Rwanda',
    dial_code: '+250',
    code: 'RW',
    latitude: -2,
    longitude: 30,
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    dial_code: '+290',
    code: 'SH',
    latitude: -15.9333,
    longitude: -5.7,
  },
  {
    name: 'Saint Kitts and Nevis',
    dial_code: '+1 869',
    code: 'KN',
    latitude: 17.3333,
    longitude: -62.75,
  },
  {
    name: 'Saint Lucia',
    dial_code: '+1 758',
    code: 'LC',
    latitude: 13.8833,
    longitude: -61.1333,
  },
  {
    name: 'Saint Pierre and Miquelon',
    dial_code: '+508',
    code: 'PM',
    latitude: 46.8333,
    longitude: -56.3333,
  },
  {
    name: 'Saint Vincent and the Grenadines',
    dial_code: '+1 784',
    code: 'VC',
    latitude: 13.25,
    longitude: -61.2,
  },
  {
    name: 'Samoa',
    dial_code: '+685',
    code: 'WS',
    latitude: -13.5833,
    longitude: -172.3333,
  },
  {
    name: 'San Marino',
    dial_code: '+378',
    code: 'SM',
    latitude: 43.7667,
    longitude: 12.4167,
  },
  {
    name: 'Sao Tome and Principe',
    dial_code: '+239',
    code: 'ST',
    latitude: 1,
    longitude: 7,
  },
  {
    name: 'Saudi Arabia',
    dial_code: '+966',
    code: 'SA',
    latitude: 25,
    longitude: 45,
  },
  {
    name: 'Senegal',
    dial_code: '+221',
    code: 'SN',
    latitude: 14,
    longitude: -14,
  },
  {
    name: 'Serbia',
    dial_code: '+381',
    code: 'RS',
    latitude: 44,
    longitude: 21,
  },
  {
    name: 'Seychelles',
    dial_code: '+248',
    code: 'SC',
    latitude: -4.5833,
    longitude: 55.6667,
  },
  {
    name: 'Sierra Leone',
    dial_code: '+232',
    code: 'SL',
    latitude: 8.5,
    longitude: -11.5,
  },
  {
    name: 'Singapore',
    dial_code: '+65',
    code: 'SG',
    latitude: 1.3667,
    longitude: 103.8,
  },
  {
    name: 'Slovakia',
    dial_code: '+421',
    code: 'SK',
    latitude: 48.6667,
    longitude: 19.5,
  },
  {
    name: 'Slovenia',
    dial_code: '+386',
    code: 'SI',
    latitude: 46,
    longitude: 15,
  },
  {
    name: 'Solomon Islands',
    dial_code: '+677',
    code: 'SB',
    latitude: -8,
    longitude: 159,
  },
  {
    name: 'Somalia',
    dial_code: '+252',
    code: 'SO',
    latitude: 10,
    longitude: 49,
  },
  {
    name: 'South Africa',
    dial_code: '+27',
    code: 'ZA',
    latitude: -29,
    longitude: 24,
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    dial_code: '+500',
    code: 'GS',
    latitude: -54.5,
    longitude: -37,
  },
  { name: 'Spain', dial_code: '+34', code: 'ES', latitude: 40, longitude: -4 },
  {
    name: 'Sri Lanka',
    dial_code: '+94',
    code: 'LK',
    latitude: 7,
    longitude: 81,
  },
  { name: 'Sudan', dial_code: '+249', code: 'SD', latitude: 15, longitude: 30 },
  {
    name: 'Suriname',
    dial_code: '+597',
    code: 'SR',
    latitude: 4,
    longitude: -56,
  },
  {
    name: 'Svalbard and Jan Mayen',
    dial_code: '+47',
    code: 'SJ',
    latitude: 78,
    longitude: 20,
  },
  {
    name: 'Swaziland',
    dial_code: '+268',
    code: 'SZ',
    latitude: -26.5,
    longitude: 31.5,
  },
  {
    name: 'Sweden',
    dial_code: '+46',
    code: 'SE',
    latitude: 62,
    longitude: 15,
  },
  {
    name: 'Switzerland',
    dial_code: '+41',
    code: 'CH',
    latitude: 47,
    longitude: 8,
  },
  {
    name: 'Syrian Arab Republic',
    dial_code: '+963',
    code: 'SY',
    latitude: 35,
    longitude: 38,
  },
  {
    name: 'Taiwan',
    dial_code: '+886',
    code: 'TW',
    latitude: 23.5,
    longitude: 121,
  },
  {
    name: 'Tajikistan',
    dial_code: '+992',
    code: 'TJ',
    latitude: 39,
    longitude: 71,
  },
  {
    name: 'Tanzania, United Republic of',
    dial_code: '+255',
    code: 'TZ',
    latitude: -6,
    longitude: 35,
  },
  {
    name: 'Thailand',
    dial_code: '+66',
    code: 'TH',
    latitude: 15,
    longitude: 100,
  },
  {
    name: 'Timor-Leste',
    dial_code: '+670',
    code: 'TL',
    latitude: -8.55,
    longitude: 125.5167,
  },
  {
    name: 'Togo',
    dial_code: '+228',
    code: 'TG',
    latitude: 8,
    longitude: 1.1667,
  },
  {
    name: 'Tokelau',
    dial_code: '+690',
    code: 'TK',
    latitude: -9,
    longitude: -172,
  },
  {
    name: 'Tonga',
    dial_code: '+676',
    code: 'TO',
    latitude: -20,
    longitude: -175,
  },
  {
    name: 'Trinidad and Tobago',
    dial_code: '+1 868',
    code: 'TT',
    latitude: 11,
    longitude: -61,
  },
  {
    name: 'Tunisia',
    dial_code: '+216',
    code: 'TN',
    latitude: 34,
    longitude: 9,
  },
  {
    name: 'Turkey',
    dial_code: '+90',
    code: 'TR',
    latitude: 39,
    longitude: 35,
  },
  {
    name: 'Turkmenistan',
    dial_code: '+993',
    code: 'TM',
    latitude: 40,
    longitude: 60,
  },
  {
    name: 'Turks and Caicos Islands',
    dial_code: '+1 649',
    code: 'TC',
    latitude: 21.75,
    longitude: -71.5833,
  },
  {
    name: 'Tuvalu',
    dial_code: '+688',
    code: 'TV',
    latitude: -8,
    longitude: 178,
  },
  {
    name: 'Uganda',
    dial_code: '+256',
    code: 'UG',
    latitude: 1,
    longitude: 32,
  },
  {
    name: 'Ukraine',
    dial_code: '+380',
    code: 'UA',
    latitude: 49,
    longitude: 32,
  },
  {
    name: 'United Arab Emirates',
    dial_code: '+971',
    code: 'AE',
    latitude: 24,
    longitude: 54,
  },
  {
    name: 'United Kingdom',
    dial_code: '+44',
    code: 'GB',
    latitude: 54,
    longitude: -2,
  },
  {
    name: 'United States',
    dial_code: '+1',
    code: 'US',
    latitude: 38,
    longitude: -97,
  },
  {
    name: 'United States Minor Outlying Islands',
    dial_code: '+1581',
    code: 'UM',
    latitude: 19.2833,
    longitude: 166.6,
  },
  {
    name: 'Uruguay',
    dial_code: '+598',
    code: 'UY',
    latitude: -33,
    longitude: -56,
  },
  {
    name: 'Uzbekistan',
    dial_code: '+998',
    code: 'UZ',
    latitude: 41,
    longitude: 64,
  },
  {
    name: 'Vanuatu',
    dial_code: '+678',
    code: 'VU',
    latitude: -16,
    longitude: 167,
  },
  {
    name: 'Venezuela, Bolivarian Republic of',
    dial_code: '+58',
    code: 'VE',
    latitude: 8,
    longitude: -66,
  },
  {
    name: 'Viet Nam',
    dial_code: '+84',
    code: 'VN',
    latitude: 16,
    longitude: 106,
  },
  {
    name: 'Virgin Islands, British',
    dial_code: '+1 284',
    code: 'VG',
    latitude: 18.5,
    longitude: -64.5,
  },
  {
    name: 'Virgin Islands, U.S.',
    dial_code: '+1 340',
    code: 'VI',
    latitude: 18.3333,
    longitude: -64.8333,
  },
  {
    name: 'Wallis and Futuna',
    dial_code: '+681',
    code: 'WF',
    latitude: -13.3,
    longitude: -176.2,
  },
  {
    name: 'Western Sahara',
    dial_code: '+732',
    code: 'EH',
    latitude: 24.5,
    longitude: -13,
  },
  {
    name: 'Yemen',
    dial_code: '+967',
    code: 'YE',
    latitude: 15,
    longitude: 48,
  },
  {
    name: 'Zambia',
    dial_code: '+260',
    code: 'ZM',
    latitude: -15,
    longitude: 30,
  },
  {
    name: 'Zimbabwe',
    dial_code: '+263',
    code: 'ZW',
    latitude: -20,
    longitude: 30,
  },
];

export const USER_LIST_TYPES = {
  FRIENDS: 'Friends',
  VALIDATIONS: 'Validations',
  PRIVATE_ALBUM_ACCESS: 'PrivateAlbumAccess',
  BLOCKED: 'Blocked',
  HIDDEN: 'Hidden',
};

export const MY_LIST_OPTION_TYPES = [
  {
    id: 1,
    name: USER_LIST_TYPES.FRIENDS,
    label: 'MyList.Friends',
    subLabel: 'MyList.MyFriendsList',
    route: `${ROOT_FOLDER}/${USER}/${FRIEND}?bck=usr-lst`,
  },
  {
    id: 2,
    name: USER_LIST_TYPES.VALIDATIONS,
    label: 'MyList.Validations',
    subLabel: 'MyList.MemberIHaveValidated',
    route: `${ROOT_FOLDER}/${USER}/${VALIDATION}`,
  },
  {
    id: 3,
    name: USER_LIST_TYPES.PRIVATE_ALBUM_ACCESS,
    label: 'MyList.PrivateAlbumsAccess',
    subLabel: 'MyList.MemberWithAccess',
    route: `${ROOT_FOLDER}/${USER}/${PHOTO}/${GALLERY}/${ACCESS_LIST}`,
  },
  {
    id: 4,
    name: USER_LIST_TYPES.BLOCKED,
    label: 'MyList.Blocked',
    subLabel: 'MyList.MemberIHaveBlocked',
    route: `${ROOT_FOLDER}/${USER}/${BLOCK_LIST}`,
  },
  {
    id: 5,
    name: USER_LIST_TYPES.HIDDEN,
    label: 'MyList.Hidden',
    subLabel: 'MyList.MembersIHaveHiddenFromDiscover',
    route: `${ROOT_FOLDER}/${USER}/${IGNORE}`,
  },
];

export const LOCATION_DISTANCE_TWO_POINTS = 5000; // unit: meter

export const DEEP_LINKING_APP = 'com.jetplace.rhpmobile://openApp';
export const DEEP_LINKING_APP_UPGRADE_EXTRAS = 'com.jetplace.rhpmobile://upgrade/extras';
export const DEEP_LINKING_APP_FIREBASE = 'https://rhpmobile.page.link/app-open';
export const DEEP_LINKING_APP_UPGRADE_EXTRAS_FIREBASE = 'https://rhpmobile.page.link/upgrade';

export const OnBoardingGroups = 'React.OnBoarding.Groups';
export const OnBoardingMessenger = 'React.OnBoarding.Messenger';
export const OnBoardingMessengerNews = 'React.Messenger.NewFeaturePopup';
export const OnBoardingMessengerTheme = 'React.Messenger.Themes';
export const OnBoardingMessengerVoice = 'React.Messenger.VoiceMessage';
export const OnBoardingMain = 'React.OnBoarding.Main';
export const OnBoardingHideProfile = 'React.OnBoarding.HideProfile';
export const OnBoardingChatRooms = 'React.OnBoarding.Chatroom.PrivateChatLimit';
export const OnBoardingProfile = 'React.OnBoarding.Profile.Open';
export const OnBoardingNotification = 'React.OnBoarding.Main.Notification';
export const OnBoardingEventsGroupChat = 'React.GroupChat';
export const MessengerSafety = 'React.Messenger.DatingSafety';
export const DisappearingPhoto = 'React.Messenger.DisappearingPhoto';
export const MainPhoto = 'React.Login.RestrictedMainPhoto';
export const AddPhoneNumber = 'React.Login.AddPhoneNumber';
export const MessengerDisappearingPhotos = 'React.Messenger.DisappearingPhoto';
export const TiredOfRememberingPassword = 'React.Login.ConnectAccounts';
export const MessengerThePiePledge = 'React.Messenger.ThePiePledge';
export const RestrictedPublicPhoto = 'React.Login.RestrictedPublicPhoto';
export const IntroducingMessengerGift = 'React.Messenger.Gift';
export const IntroducingBoost = 'React.OnBoarding.Boost';
export const ConversationGiftTooltip = 'React.Messenger.ConversationGiftTooltip';
export const MessengerThemes = 'React.Messenger.Themes';
export const FaceIDShow = 'React.Login.FaceIDShow'; // Using for Don't show popup again
export const FaceIDDelay = 'React.Login.FaceIDDelay'; // Using for remind me later
export const ProfileBoostFinished = 'React.Login.ProfileBoostFinished';
export const SpotlightFeature = 'React.Login.SpotlightFeatured';
export const NewVerification = 'React.OnBoarding.NewVerification';
export const ProfileBoost = 'React.OnBoarding.ProfileBoost';
export const StreamFilterTooltip = 'React.OnBoarding.StreamFilter';
export const FaceIDShowTooltip = 'React.Login.FaceIDShow';
export const FaceIDDelayTooltip = 'React.Login.FaceIDDelay';

export const UPGRADE_MEMBER_TAB_ITEMS = [
  {
    id: MEMBER_TYPES.PREMIUM,
    name: 'UpgradeMember.Premium',
    isCheck: false,
    discount: '30',
  },
  {
    id: MEMBER_TYPES.PREMIUM_PLUS,
    name: 'UpgradeMember.PremiumPlus',
    isCheck: false,
    discount: '',
  },
  {
    id: MEMBER_TYPES.PLATINUM,
    name: 'UpgradeMember.Platinum',
    isCheck: false,
    discount: '25',
  },
  {
    id: MEMBER_TYPES.PLATINUM_DIAMOND,
    name: 'UpgradeMember.Diamond',
    isCheck: false,
    discount: '99',
  },
];

export const EDIT_PROFILE = {
  PUBLIC_ID: '10007',
  MAIN_PHOTO_ID: 'mainPhoto',
};

export const PAYMENT_GATEWAY = {
  TYPE: {
    COM_WEB: 'ComWeb',
    CHEQUE: 'Cheque',
    B_PAY: 'BPay',
    BANK_TRANSFER: 'DirectDeposit',
    PAY_ID: 'PayID',
    VEROTEL: 'Verotel',
    TRANSACTION: 'transaction',
    RECEIPT: 'receipt',
    ALTERNATIVE_PAYMENT_OPTIONS: 'AlternativePaymentOptions',
    SELECT_METHOD_PAYMENT: 'SelectMethodPayment',
  },
  DISCOUNT: {
    NO_DISCOUNT: 'NoDiscount',
    FIFTY_PERCENT: 'FiftyPercent',
    THIRTY_PERCENT: 'ThirtyPercent',
    TEN_PERCENT: 'TenPercent',
    TWENTY_FIVE_PERCENT: 'TwentyFivePercent',
  },
  DURATION_TYPE: {
    MONTH: 'Month',
  },
  PHOTO_INDEX: {
    DEFAULT: 2,
    RESTRICTED_PHOTO: 2,
    PHONE_NUMBER: 4,
    EVENT: 3,
    VIDEO_CALL_LIVE: 8,
    MATCH_WITH_YOU: 7,
    PARTY_LIKE: 3,
    SEE_WHO_LIKE_USE: 6,
    CHAT_WITH_HOT: 0,
    SEARCH: 1,
  },
};

export const NO_PHOTO = 'NoPhoto';

export const HIDDEN = 'hidden';

export const SUBSCRIPTION_TYPE = {
  SUBCRIPTION: 'subcription',
  UPDATE_CARD: 'update-card-detail',
  CANCEL_MEMBERSHIP: 'cancel-membership',
  RETAIN_SUCCESS: 'retain-success',
  APPLE_IAP: 'AppleIAP',
  GOOGLE_IAP: 'GoogleIAP',
  COMM_WEB: 'ComWeb',
  VEROTEL: 'Verotel',
};

export type SubscriptionTypeValue = (typeof SUBSCRIPTION_TYPE)[keyof typeof SUBSCRIPTION_TYPE];

export const QUERY_PARAMS = {
  USER_EVENT: 'user-event',
  FRIEND: 'friend',
  VALIDATION: 'validation',
  PRIVATE_ALBUM_ACCESS: 'private-album-access',
  BLOCKED: 'blocked',
  HIDDEN: 'hidden',
  REQUEST: 'request',
  SENT: 'sent',
  MY: 'my',
};

export const LONG_PRESS_LISTENER_TIME = 500; // unit: milliseconds
export const TIMEOUT_RUN_ANIMATION = 500;

export const ERROR_UPLOAD_IMAGE = {
  4001: {
    errorCode: 4001,
    toastTitle: 'InAppNotification.PhotoIsWrongDimension',
    toastDes: 'InAppNotification.PleaseTryAnotherPhoto',
  },
  4002: {
    errorCode: 4002,
    toastTitle: 'InAppNotification.UploadUnsuccessful',
    toastDes: 'InAppNotification.PleaseTryAnotherPhoto',
  },
  4003: {
    errorCode: 4003,
    toastTitle: 'InAppNotification.PhotoIsTooBig',
    toastDes: 'InAppNotification.PleaseTryAnotherPhoto',
  },
  4004: {
    errorCode: 4004,
    toastTitle: 'InAppNotification.PhotoFormatNotSupported',
    toastDes: 'InAppNotification.PleaseTryAnotherPhoto',
  },
  4005: {
    errorCode: 4005,
    toastTitle: 'InAppNotification.UploadUnsuccessful',
    toastDes: 'InAppNotification.FolderIsFull',
  },
  4006: {
    errorCode: 4006,
    toastTitle: 'InAppNotification.GalleryNotFound',
    toastDes: 'InAppNotification.TryAgainLater',
  },
};

export const USER_TYPE = {
  USER_ADMIN: 'admin',
};

export const FORMAT_KEY_DATE_FINDER_LIST = 'YYYY-MM-DD';
export const IMAGE_ACTION_TYPE = {
  SHOW_IMAGE: 'ShowImage',
  UPGRADE_PAGE: 'UpgradePage',
  SAFE_MODE: 'SafeMode',
  OPEN_IN_BROWSER: 'OpenInBrowser',
  URL: 'URL',
  EVENT: 'Event',
  ARTICLE: 'Article',
  NO_ACTION: 'NoAction',
  SHOW_UNAVAILABLE_POPUP: 'ShowUnavailablePopup',
  UPLOAD_IMAGE: 'UploadImage',
  VERIFICATION: 'Verification',
  DEAL_BREAKER: 'Dealbreaker',
  DATE_FINDER: 'DateFinder',
  MESSENGER_SETTINGS: 'MessengerSettings',
  CHAT_ROOM: 'ChatHome',
  RHP_COINS: 'RHPCoins',
  PROFILE_BOOST: 'ProfileBoost',
  SPOTLIGHT_PICK_DAILY: 'TodaysPics',
};
export const IMAGE_TYPE = {
  RESTRICTED: 'Restricted',
  NO_PHOTO_IN_PRIVATE: 'NoPhotoImageInPrivate',
  NO_PHOTO: 'NoPhoto',
};

export const UPGRADE_PATH_TYPE = {
  NONE: 'None',
  PLATINUM: 'Platinum',
  DIAMOND: 'PlatinumDiamond',
  EXTRAS: 'Extras',
  GET_MORES_CONVERSATION_CREDIT: 'GetMoreConversationCredit', // custom type in local
  BOOST_CONVERSATIONS: 'BoostConversations', // custom type in local,
  BOOST_PROFILE: 'BoostProfile',
  BUY_COINS: 'BuyCoins',
};

export const MENU_OPTION_FORUM_TYPES = {
  FOLLOW: 'FOLLOW',
  BLOCK: 'BLOCK',
  IGNORE: 'IGNORE',
  REPORT: 'REPORT',
  UN_FOLLOW: 'UN_FOLLOW',
  DELETE: 'DELETE',
  LIKE: 'LIKE',
  UNLIKE: 'UNLIKE',
  EDIT: 'EDIT',
  REMOVE: 'REMOVE',
  SHARE: 'SHARE',
};

export const MENU_OPTION_FORUM_MODAL_DESKTOP = [
  {
    id: 7,
    name: MENU_OPTION_FORUM_TYPES.SHARE,
    label: 'MenuOptionForum.Share',
    subLabel: 'MenuOptionForum.ShareThisTopic',
    icon: images.icShare,
    iconSVG: icShare,
  },
  {
    id: 1,
    name: MENU_OPTION_FORUM_TYPES.FOLLOW,
    label: 'MenuOptionForum.FollowThis',
    subLabel: 'MenuOptionForum.SubFollow',
    icon: images.icFollowOption,
    iconSVG: icFollowOption,
  },
  {
    id: 5,
    name: MENU_OPTION_FORUM_TYPES.UN_FOLLOW,
    label: 'MenuOptionForum.UnFollowThis',
    subLabel: 'MenuOptionForum.SubUnFollow',
    icon: images.icFollowOption,
    iconSVG: icUnFollowOption,
  },
  {
    id: 2,
    name: MENU_OPTION_FORUM_TYPES.BLOCK,
    label: 'MenuOptionForum.BlockUserName',
    subLabel: 'MenuOptionForum.SubBlock',
    icon: images.icBlock,
    iconSVG: icBlockUserOption,
  },
  // {
  //   id: 3,
  //   name: MENU_OPTION_FORUM_TYPES.IGNORE,
  //   label: 'MenuOptionForum.Ignore',
  //   subLabel: 'MenuOptionForum.SubIgnore',
  //   icon: images.icIgnoreOption,
  //   iconSVG: 'icNotificationSettings',
  // },
  {
    id: 4,
    name: MENU_OPTION_FORUM_TYPES.REPORT,
    label: 'MenuOptionForum.ReportThis',
    subLabel: 'MenuOptionForum.SubReport',
    icon: images.icReportOption,
    iconSVG: icReportOption,
  },
  {
    id: 6,
    name: MENU_OPTION_FORUM_TYPES.DELETE,
    label: 'MenuOptionForum.Delete',
    subLabel: 'MenuOptionForum.DeleteTopic',
    icon: images.icDeleteTrash,
    iconSVG: icDeleteTrash,
  },
];
export const MENU_OPTION_MY_FORUM = [
  // {
  //   id: 1,
  //   name: MENU_OPTION_FORUM_TYPES.EDIT,
  //   label: 'MenuOptionForum.Edit',
  //   subLabel: '',
  //   icon: images.icEditReport,
  //   iconSVG: icEditReport,
  // },
  {
    id: 2,
    name: MENU_OPTION_FORUM_TYPES.REMOVE,
    label: 'MenuOptionForum.Remove',
    subLabel: '',
    icon: images.icTrash,
    iconSVG: icDeleteTrash,
    iconSize: { width: 18.5, height: 22 },
  },
];
export const MENU_OPTION_FORUM_MODAL = [
  {
    id: 7,
    name: MENU_OPTION_FORUM_TYPES.SHARE,
    label: 'MenuOptionForum.Share',
    subLabel: 'MenuOptionForum.ShareThisTopic',
    icon: images.icShare,
    iconSVG: icShare,
    iconSize: { width: 22, height: 22 },
  },
  {
    id: 1,
    name: MENU_OPTION_FORUM_TYPES.FOLLOW,
    label: 'MenuOptionForum.Follow',
    subLabel: 'MenuOptionForum.SubFollow',
    icon: images.icFollowOption,
    iconSVG: icFollowOption,
    iconSize: { width: 22, height: 22 },
  },
  {
    id: 5,
    name: MENU_OPTION_FORUM_TYPES.UN_FOLLOW,
    label: 'MenuOptionForum.UnFollow',
    subLabel: 'MenuOptionForum.SubUnFollow',
    icon: images.icUnFollowOption,
    iconSVG: icFollowOption,
    iconSize: { width: 22, height: 22 },
  },
  {
    id: 2,
    name: MENU_OPTION_FORUM_TYPES.BLOCK,
    label: 'MenuOptionForum.Block',
    subLabel: 'MenuOptionForum.SubBlock',
    icon: images.icBlock,
    iconSVG: icBlockUserOption,
    iconSize: { width: 22, height: 22 },
  },
  // {
  //   id: 3,
  //   name: MENU_OPTION_FORUM_TYPES.IGNORE,
  //   label: 'MenuOptionForum.Ignore',
  //   subLabel: 'MenuOptionForum.SubIgnore',
  //   icon: images.icIgnoreOption,
  //   iconSVG: 'icNotificationSettings',
  // },
  {
    id: 4,
    name: MENU_OPTION_FORUM_TYPES.REPORT,
    label: 'MenuOptionForum.Report',
    subLabel: 'MenuOptionForum.SubReport',
    icon: images.icReport,
    iconSVG: icReportOption,
    iconSize: { width: 22, height: 21.5 },
  },
  {
    id: 6,
    name: MENU_OPTION_FORUM_TYPES.DELETE,
    label: 'MenuOptionForum.Delete',
    subLabel: 'MenuOptionForum.DeleteTopic',
    icon: images.icTrash,
    iconSVG: icDeleteTrash,
    iconSize: { width: 18.5, height: 22 },
  },
];
export const MENU_OPTION_STORIES_MODAL = [
  {
    id: 2,
    name: MENU_OPTION_FORUM_TYPES.BLOCK,
    label: 'MenuOptionForum.Block',
    subLabel: 'MenuOptionForum.SubBlock',
    icon: images.icBlock,
    iconSVG: icBlockUserOption,
    iconSize: { width: 22, height: 22 },
  },
  {
    id: 4,
    name: MENU_OPTION_FORUM_TYPES.REPORT,
    label: 'MenuOptionForum.Report',
    subLabel: 'MenuOptionForum.SubReportStories',
    icon: images.icReportOption,
    iconSVG: icReportOption,
    iconSize: { width: 22, height: 21.5 },
  },
  {
    id: 6,
    name: MENU_OPTION_FORUM_TYPES.DELETE,
    label: 'MenuOptionForum.Delete',
    subLabel: 'MenuOptionForum.DeleteStories',
    icon: images.icDeleteTrash,
    iconSVG: icDeleteTrash,
    iconSize: { width: 18.5, height: 22 },
  },
];
export const MENU_OPTION_REPORT_ONLY = [
  {
    id: 4,
    name: MENU_OPTION_FORUM_TYPES.REPORT,
    label: 'MenuOptionForum.Report',
    icon: images.icReportOption,
    iconSVG: icReportOption,
    iconSize: { width: 22, height: 21.5 },
  },
];

export const PARAMS_MODAL = 'modal';

export const BAN_TYPE_CHATROOM = {
  LIMIT: 'Limit',
  TOTAL: 'Total',
};

export const AUTHORIZED_CHATROOM = {
  Authorised: 'Authorised',
  AuthorisedLimitedAccess: 'AuthorisedLimitedAccess',
  GuestUser: 'GuestUser',
  RoomNotAccessable: 'RoomNotAccessable',
  Banned: 'Banned',
  BannedLimited: 'BannedLimited',
  GuestUserUnverified: 'GuestUserUnverified',
};

export const EVENT_TYPE = {
  Club: 'Club',
  SPONSORED_TYPE: 'sponsored_type',
  EVENT_SCREEN: 'eventScreen',
  EVENT_DETAIL: 'eventDetail',
  CLUB_DETAIL: 'ClubDetail',
  MY_EVENT: 'myEvent',
  CLUB_EVENT: 'ClubEvent',
  EVENT_FILTER: 'eventFilter',
  GROUP_DETAIL_EVENT: 'groupDetailEvent',
  GROUP_POST_EVENT: 'groupPostEvent',
};

export const PAYMENT_RESPONSE = {
  TOKEN_ACQUISITION_FAILED: 'TokenAcquisitionFailed',
  INVALID_CARD: 'InvalidCard',
  SUCCESS: 'Success',
  GENERAL_ERROR: 'GeneralError',
  REJECTED_BY_BANK: 'RejectedByBank',
  INSUFFICIENT_FUNDS: 'InsufficientFunds',
  VERIFICATION_REQUIRED: 'VerificationRequired',
  VERIFICATION_PENDING: 'VerificationPending',
};

export const USER_NOT_MATCHED = 'UserNotMatched';

export const IMAGES_CHAT_ROOMS = {
  'rhp#testing_groupchat_secure1': 'hotChat',
  'rhp#testing_groupchat_secure2': 'socialChat',
  'rhp#testing_groupchat_secure3': 'singlesChat',
  'rhp#testing_groupchat_secure4': 'couplesChat',
  'rhp#testing_groupchat_secure5': 'lGBTChat',
  'rhp#testing_groupchat_secure6': 'fetishChat',
  'rhp#public_hot_chat': 'hotChat',
  'rhp#public_social_chat': 'socialChat',
  'rhp#public_singles_chat': 'singlesChat',
  'rhp#public_couples_chat': 'couplesChat',
  'rhp#public_lgbt_chat': 'lGBTChat',
  'rhp#public_fetish_chat': 'fetishChat',
};

export const PICK_A_DATE = 'Pick a date';
export const ANY_TIME = 'Any time';

export const FORUM_TYPES = {
  BOARD: -1,
  TRENDING: 1,
  NEWEST: 2,
  MY_FORUM: 3,
  ITEMS_LOCATION_MAIN: 'itemsLocationMain',
  ITEMS_LOCATION_REGIONAL: 'itemsLocationRegional',
  ITEMS_OPTION_FORUM_FOLLOWING: 'itemsMenuOptionFollowing',
  ITEMS_OPTION_FORUM_UN_FOLLOWING: 'itemsMenuOptionUnFollowing',
};

export const FORUM_CREATE_MODAL_VIEW = {
  CREATE_MAIN_VIEW: { id: 0, name: '' },
  ADD_TAGS: { id: 1, name: 'AddTags' },
};

export const COMMUNITY_CREATE_MODAL_VIEW = {
  CREATE_MAIN_VIEW: { id: 0, name: '' },
  ADD_TAGS: { id: 1, name: 'AddTags' },
};

export const MAXIMUM_CHARACTERS_MESSAGE_REPORT = 250;

export const MAXIMUM_CHARACTERS = {
  LOCATION_HEADER_EVENT_MOBILE: 26,
  BREADCRUMB_FORUM_DESKTOP: 50,
};

export const ACTION_NAME_SIGNAL_CHATROOM = {
  CHECK_STATUS: 'checkStatus',
  LEAVE_ROOM: 'leaveRoom',
  RELY_STATUS: 'relyStatus',
  DELETE_CONVERSATION: 'deleteConversation',
  RECALL_MSG: 'recallMsg',
  DELETE_MESSAGE: 'deleteMsg',
};

export const ACTION_NAME = {
  FORUM_TOPIC: 'forumTopicReply',
  STORY_COMMENTS: 'storyComment',
  EVENT_COMMENTS: 'eventComment',
  SEND_GROUP_MESSAGE: 'sendGroupMessage',
  SEND_GIFT_MESSAGE: 'sendGiftMessage',
  PROFILE_VERIFICATION_REJECTED: 'profileVerificationRejected',
  PROFILE_VERIFICATION_APPROVED: 'profileVerificationApproved',
  PROFILE_USERNAME_APPROVED: 'usernameApproval',
  PROFILE_MAIN_PHOTO_APPROVED: 'mainPhotoApproved',
  PROFILE_VERIFIED: 'profileVerified',
  TOOK_SCREEN_SHOT: 'screenshot',
  JOIN_GROUP_CHAT: 'joinGroupChat',
  EVENT_APPROVED: 'eventApproved',
  EVENT_REJECTED: 'eventRejected',
  PROFILE_VERIFIED_REJECTED: 'profileVerifiedRejected',
  PROFILE_PHOTO_LIKE: 'profilePhotoLike',
  GROUP_MEMBER_REQUEST: 'groupMemberRequest',
  BOOST_MY_SELF: 'BOOST_MY_SELF',
  STREAM_STARTING: 'streamStarting',
  STREAM_STARTED: 'streamStarted',
};

export const DATE_FINDER_DEFAULT_METTING_TYPE = 'Virtual Date';

export const KEY_CODE = {
  ENTER: 13,
};

export const TIMEOUT_SHOW_POPUP_STOP_BROADCAST_DESKTOP = 3600000;
export const TIMEOUT_STOP_LIVE_STREAM_DESKTOP = 60000;

export const KEY_PROSPECTS_IGNORE_DELETE = [
  PROSPECTS_DATAKEY.USER_PROFILE_VIEW_TYPE_VIEW_ME,
  PROSPECTS_DATAKEY.USER_PROFILE_VIEW_TYPE_VIEWED,
];

export const STABLE_FIREFOX_VERSION = 63;
export const STABLE_FIREFOX_VERSION_ANDROID = 68;
export const STABLE_FIREFOX_VERSION_IOS = 21;
export const STABLE_FIREFOX_VERSION_IPAD = 13;
export const IOS = 'iOS';
export const BROWSER_IOS = 'ios';
export const BROWSER_FIREFOX = 'firefox';
export const BROWSER_FIREFOX_IOS = 'fxios';
export const BROWSER_CHROME = 'chrome';
export const BROWSER_CHROME_IOS = 'crios';
export const BROWSER_SAFARI = 'safari';
export const BROWSER_EDGE_CHROMIUM = 'edge-chromium';
export const BROWSER_EDGE_OLD = 'edge';
export const BROWSER_EDGE_IOS = 'edge-ios';

export const LOCATION_TYPE_CITY = ['Suburb', 'locality', 'administrative_area_level_3'];

export const RECENT_ACTIVE = 'RecentlyActive';

export const MAX_WIDTH = 1200;
export const MAX_RESPONSE = 1090;

export const VALUE_FOR_ANIMATION = {
  PADDING: 20,
  HEIGHT_HEADER_DEFAULT: 115,
  PADDING_BOTTOM_OF_MAIN_PAGE: 50,
};

export const MY_EVENT_DATAKEY = {
  UP_COMING: 'up-coming',
  PAST_EVENTS: 'past-events',
};

export const SUB_TAB_MY_EVENT = [
  {
    id: 1,
    name: MY_EVENT_DATAKEY.UP_COMING,
    label: 'Upcoming',
    isSelected: true,
  },
  {
    id: 2,
    name: MY_EVENT_DATAKEY.PAST_EVENTS,
    label: 'Past events',
    isSelected: false,
  },
];

export const MAXIMUM_TAGS_USER_CAN_ADD = 3;

export const PATCH_DATE_FINDER_INTERESTS = {
  DELETE: 'Delete',
  APPROVE: 'Approve',
};

export const PAGING_TYPE = {
  START: 'start',
  END: 'end',
  NEXT: 'next',
  PREV: 'prev',
  CURRENT_PAGE: 'current_page',
};

export const MAXIMUN_SIZE_IMAGE = 4000000;
export const MAXIMUM_SIZE_VIDEO = 20000000;

export const LIMIT_SEND_MESSAGE = 10;

export const SUPPORT_VIEW_MENU = [
  { id: 1, text: 'Support.ContactSupport', isNotRHPLink: true },
  {
    id: 2,
    text: 'Support.TicketList',
    isNotRHPLink: true,
    url: `${ROOT_FOLDER}/${HELP_SUPPORT}/${SUPPORT_VIEW}/${TICKET_LIST}`,
  },
  { id: 3, text: 'Support.FAQ', url: urls.FAQ },
  {
    id: 4,
    text: 'Support.Feedback',
    isNotRHPLink: true,
    url: '',
    onlyDesktop: true,
  },
  {
    id: 5,
    text: 'HelpSupport.RedHotPieVersion',
    url: '',
    onlyDesktop: true,
  },
];

export const HELP_SUPPORT_MENU = [
  {
    id: 1,
    text: 'HelpSupport.HelpAndSupport',
    isNotRHPLink: true,
    url: `${ROOT_FOLDER}/${HELP_SUPPORT}/${SUPPORT_VIEW}`,
    // url: urls.URL_HELP_SUPPORT
  },
  {
    id: 8,
    text: 'HelpSupport.AboutRHP',
    isNotRHPLink: true,
    url: `${ROOT_FOLDER}/${HELP_SUPPORT}/${ABOUT_RHP}`,
  },
  {
    id: 2,
    text: 'HelpSupport.RedHotPieVersion',
    url: '',
  },
  {
    id: 3,
    text: 'HelpSupport.TermsOfUse',
    url: urls.TERMS_OF_USE,
  },
  {
    id: 4,
    text: 'HelpSupport.PrivacyPolicy',
    url: urls.PRIVACY_POLICY,
  },
  {
    id: 5,
    text: 'HelpSupport.DatingSafety',
    url: urls.DATING_SAFETY,
  },
  {
    id: 6,
    text: 'HelpSupport.CommunityGuidelines',
    url: urls.COMMUNITY_GUIDELINES,
  },
  {
    id: 7,
    text: 'HelpSupport.Feedback',
    isNotRHPLink: true,
    url: urls.URL_FEED_BACKS_MOBILE,
  },
];

export const COLOR_MEMBER_TYPE = {
  BLUE: 'sub-color-blue',
  PINK: 'sub-color-pink',
  GRAY: 'sub-color-gray',
};

export const DEFAULT_PAGE_SIZE_ACTIVE_USERS = 24;

export const DEFAULT_PAGE_SIZE = 24;

export const FILTER_OPTIONS_MOBILE = {
  PRIMARY_OPTION: {
    ALL_CONVERSATION: {
      name: 'AllConversations',
      des: 'DesAllConversations',
      id: PRIMARY_FILTER.ALL,
    },
    MATCHING_CONVERSATION: {
      name: 'AllMatchingConversations',
      des: 'DesAllMatchingConversations',
      id: PRIMARY_FILTER.MATCHING,
    },
  },
  SECONDARY_OPTION: {
    UNREAD_CONVERSATION: {
      name: 'MessagesIHaveNotRead',
      des: 'DesMessagesIHaveNotRead',
      id: SECONDARY_FILTER.MESSAGES_NOT_READ,
    },
    UN_REPLIED_CONVERSATION: {
      name: 'MessagesIHaveNotRepliedTo',
      des: 'DesMessagesIHaveNotRepliedTo',
      id: SECONDARY_FILTER.MESSAGE_NOT_REPLIED,
    },
    IGNORED_CONVERSATIONS: {
      name: 'MessagesIDidIgnored',
      des: 'MessagesIDidIgnoredDes',
      id: SECONDARY_FILTER.MESSAGES_IGNORED,
    },
    SENT_CONVERSATION: {
      name: 'MessagesIHaveSentMobile',
      des: 'DesMessagesWhichNotReplied',
      id: SECONDARY_FILTER.MESSAGE_SENT,
    },
    // NON_MATCHING: {} //This option is not used anymore
  },
};
export const UPGRADE_TYPE = {
  RESTRICTED: 'Restricted',
  MATCHES: 'Matches',
  MESSAGE: 'Message',
  VIDEO_CALL: 'VideoCall',
  LIKE_OR_FAV: 'LikeOrFav',
  LIKE: 'Like',
  FAV: 'Fav',
  PHONE: 'Phone',
  EVENT: 'Events',
  DEFAULT: 'Default',
  PREMIUM_SEARCH: 'PremiumSearch',
  CHAT_ROOM: 'ChatRoom',
  GET_MORES_CONVERSATION_CREDIT: 'GetMoreConversationCredit',
  TAKE_BACK_LIKE_FAV: 'TakeBackLikeFav',
  BOOST_CONVERSATIONS: 'BoostConversations', // custom type in local
  BOOST_PROFILE: 'BoostProfile', // custom type in local
  INVITE_CREDITS: 'InviteCredits', // custom type in local
};
export const HOME_ANNOUNCEMENT_BANNER = {
  UPGRADE_PAGE: 'UpgradePage',
  URL: 'URL',
  EVENT: 'Event',
  ARTICLE: 'Article',
  VERIFICATION: 'Verification',
  DEAL_BREAKER: 'Dealbreaker',
  DATE_FINDER: 'DateFinder',
  CHAT_HOME: 'ChatHome',
  MESSENGER_SETTINGS: 'MessengerSettings',
  RHP_COINS: 'RHPCoins',
  PROFILE_BOOST: 'ProfileBoost',
  SPOTLIGHT_PICK_DAILY: 'TodaysPics',
};
export const SCREEN_TRACKING = {
  SIGN_UP_SCREEN: 'Join',
  USER_MENU_SETTING: 'Menu',
  USER_INFO_SETTINGS: 'profile_menu',
  VERIFICATION_SUCCESS_MODAL: 'Verification_success',
  UPGRADE_MEMBERSHIP_MODAL: 'Upgrade_options',
  SUBSCRIPTION_MODAL: 'Settings_subscriptions',
  WEBVIEW_MODAL: 'Web_view',
  EDIT_PROFILE: 'Edit_Profile',
  //= ========
  HOME_SCREEN: 'Home',
  NOTIFICATION_SCREEN: 'Notifications',
  //= =========
  DISCOVER: 'Discover',
  DISCOVER_FILTER_MODAL: 'Discover_filter',
  //= ========
  MEMBER_PROFILE: 'profile',
  MEMBER_PROFILE_MODAL: 'profile_modal',
  IMAGE_GALLERY_FULL_MODAL: 'profile_photos',
  MODAL_PROFILE_OPTION: 'profile_options',
  //= ========
  PROSPECTS: 'Prospects_Views_Default',
  PROSPECTS_FILTER_MODAL: 'Prospects_Filter',
  //= =========
  MESSAGE_INBOX_SCREEN: 'Messenger_Inbox',
  FOLDER_MODAL: 'FolderModal',
  ADD_OR_EDIT_FOLDER_MODAL: 'AddOrEditFolderModal',
  CONVERSATION_SCREEN: 'Conversation',
  //= ==========
  VIDEO_CALL: 'Video_Incoming_View',
  // VIDEO_CALL_MODAL: 'VideoCallModal',
  ACTIVE_NOW_FILTER_MODAL: 'ActiveNow_Filter',
  ACTIVE_NOW: 'ActiveNow', // TODO
  // ===========
  CHAT_ROOMS_SCREEN: 'ChatRooms_Home',
  STREAMING_MODAL: 'ChatRooms_BoardCast',
  STREAMING_MODAL_VIEW: 'ChatRooms_ViewBoardCast', // TODO
  CHAT_ROOM_CONVERSATIONS: 'ChatRoomConversation',
  LIVE_STREAM_CONVERSATIONS: 'ChatRoom_PrivateChat',
  //= =======
  //  COMMUNITY_COMMENT_SCREEN: 'MediaDetailScreen',
  BLOG_DETAILS_SCREEN: 'Community_ArticleDetails',
  STORY_DETAILS: 'Community_StoryDetails',
  COMMUNITY_SCREEN: 'Community_Default',
  //  CREATE_COMMUNITY_MODAL: 'CreateCommunityModal',
  //= ===========
  FORUM_SCREEN: 'Forum_Default',
  // FORUM_TOPIC_DETAIL: 'TopicDetail',
  // FORUM_TOPIC_SUB_CATEGORY_LIST: 'TopicSubDataList',
  // FORUM_FILTER_MODAL: 'ForumFilterModal',
  // FORUM_CATEGORY_LIST_SCREEN: 'ForumCategoryList',
  // CREATE_FORUM_MODAL: 'CreateForumModal',
  //  FORUM_TOPIC_SEARCH_RESULT: 'ForumTopicSearchResult',
  //= ===========
  //  TRAVEL_DESTINATION_SCREEN: 'TravelDestinationScreen',
  //  TRAVEL_FILTER_MODAL: 'TravelFilterModal',
  // ADD_TRAVEL_SCREEN: 'AddTravelScreen',
  TRAVEL_SCREEN: 'Travel_Default',
  // ============
  DATE_FINDER_FILTER_MODAL: 'DF_filter',
  DATE_FINDER_SCREEN: 'DF_Default',
  ADD_MY_DATE_FINDER_SCREEN: 'DF_Add',
  EDIT_MY_DATE_FINDER_SCREEN: 'DF_Edit',
  // =============
  EVENT_SCREEN: 'Events_Defaults',
  EVENT_FILTER_MODAL: 'Events_filter',
  ADD_EVENT_SCREEN: 'Events_Add',
  EVENT_INTEREST_SCREEN: 'Event_InterestList',
  // =========
  GROUP_SCREEN: 'Group_Screen',
};
export const EVENT_TRACKING = {
  SIGN_UP: 'User_Join',
  // HOME
  HOME_SUGGESTED_OPEN: 'Home_Suggested_Open',
  HOME_SUGGESTED_ALL: 'Home_Suggested_All',
  HOME_ACTIVE_OPEN: 'Home_Active_Open',
  HOME_ACTIVE_ALL: 'Home_Active_All',
  HOME_DF_OPEN: 'Home_DF_Open',
  HOME_DF_All: 'Home_DF_All',
  HOME_TRAVEL_OPEN: 'Home_Travel_Open',
  HOME_TRAVEL_All: 'Home_Travel_All',
  HOME_EVENT_OPEN: 'Home_Event_Open',
  HOME_EVENTS_All: 'Home_Events_All',
  HOME_BLOG_OPEN: 'Home_Blog_Open',
  HOME_BLOG_All: 'Home_Blog_All',
  HOME_OTG_OPEN: 'Home_OTG_Open',
  HOME_OTG_All: 'Home_OTG_All',
  HOME_VIDEO_OPEN: 'Home_Video_Open',
  HOME_TOPIC_OPEN: 'Home_Topic_Open',
  HOME_FORUMS_ALL: 'Home_Forums_All',
  HOME_STORY_OPEN: 'Home_Story_Open',
  HOME_TESTIMONIAL: 'Home_Testimonial',
  // PROFILE
  PROFILE_LIKE: 'Profile_Like',
  PROFILE_FAV: 'Profile_FAV',
  PROFILE_HIDE: 'Profile_Hide',
  PROFILE_BLOCK: 'Profile_Block',
  PROFILE_OPEN_CONVERSATION: 'Profile_OpenConversation',
  PROFILE_PHOTO_UPGRADE: 'Profile_Photo_Upgrade',
  PROFILE_SWIPE_NEXT: 'Profile_Swipe_Next',
  // PROSPECTS
  PROSPECTS_LIKE: 'Prospects_Like',
  PROSPECTS_FAV: 'Prospects_FAV',
  PROSPECTS_HIDE: 'Prospects_Hide',
  PROSPECTS_BLOCK: 'Prospects_Block',
  PROSPECTS_LIKE_TAB: 'Prospects_Like_Tab',
  PROSPECTS_FAV_TAB: 'Prospects_FAV_Tab',
  PROSPECTS_VIEW_TAB: 'Prospects_View_Tab',
  PROSPECTS_MATCH_TAB: 'Prospects_Match_Tab',
  PROSPECTS_LIKES_UPGRADE: 'Prospects_Likes_Upgrade',
  PROSPECTS_MATCH_UPGRADE: 'Prospects_Match_Upgrade',
  // SUBSCRIPTIONS
  RESTORE_PURCHASE: 'Restore_Purchase',
  // Messenger
  INBOX_OPEN_CONVERSATION: 'Inbox_OpenConversation',
  SEND_INITIAL_MESSAGE: 'Send_Initial_Message',
  REPLY_INITIAL_MESSAGE: 'Reply_Initial_Message',
  SEND_PHOTO: 'Send_Photo',
  SEND_VIDEO: 'Send_Video',
  SEND_GIF_MESSAGE: 'Send_GIF_Message',
  SEND_GIFT_MESSAGE: 'Send_GIFT_Message',
  REDEEM_GIFT: 'REDEEM_GIFT',
  DECLINE_GIFT: 'DECLINE_GIFT',
  MESSENGER_VIEW_PHOTO: 'Messenger_View_Photo',
  MESSENGER_VIEW_VIDEO: 'Messenger_View_Video',
  VIDEO_CALL_START: 'Video_Call_Start',
  VIDEO_INCOMING_ACCEPTED_VIDEO: 'Video_Incoming_AcceptVideo',
  VIDEO_INCOMING_ACCEPTED_WATCH: 'Video_Incoming_AcceptWatch',
  VIDEO_INCOMING_DECLINE: 'Video_Incoming_Decline',
  MESSENGER_BLOCK: 'Messenger_Block',
  MESSENGER_REPORT: 'Messenger_Report',
  MESSENGER_UPGRADE: 'Messenger_Upgrade',
  MESSENGER_SEE_MORE_ACTIVE: 'Messenger_SeeMore_Active',
  // Active Now
  ACTIVE_NOW_OPEN_CONVERSATION: 'ActiveNow_OpenConversation',
  // CHAT ROOMS:
  JOIN_CHATROOM: 'Join_ChatRoom',
  CHATROOM_UPGRADE: 'ChatRoom_Upgrade',
  // Community
  COMMUNITY_ARTICLE_TAB: 'Community_Article_Tab',
  COMMUNITY_STORIES_TAB: 'Community_Stories_Tab',
  COMMUNITY_OTG_TAB: 'Community_OTG_Tab',
  COMMUNITY_TESTIMONIAL_TAB: 'Community_Testimonial_Tab',
  // DF
  DF_ADD_INTEREST: 'DF_AddInterest',
  // Event
  EVENTS_ADD_INTEREST: 'Events_AddInterest',
  // Quick registration v2
  GENDER_LOOKING_SUBMIT: 'gender-looking-submit', // For step 1 (Quick-reg v2)
  GENDER_SUBMIT: 'gender-submit',
  LOOKING_SUBMIT: 'looking-submit',
  LOCATION_SUBMIT: 'location-submit',
  AGE_SUBMIT: 'age-submit',
  USERNAME_SUBMIT: 'username-submit',
  PASSWORD_SUBMIT: 'password-submit',
  EMAIL_SUBMIT: 'email-submit',
  SIGNUP_COMPLETE: 'signup-complete',
  //
  REGISTRATION_SUCCESS: 'Registration_Success',
  REGISTRATION_UPLOAD_PHOTO: 'Registration_Upload_Photo',
  PURCHASE_SUCCESS: 'Purchase_Success',
};

export const TIMEOUT_GET_USERS_ACTIVE_API = 5;
export const PROSPECTS_ID = {
  VIEWS: {
    ID: 1,
    SUB_TAB: {
      VIEWED_ME: 1,
      HAS_VIEWED: 2,
    },
  },
  LIKES: {
    ID: 4,
    SUB_TAB: {
      LIKE_ME: 1,
      HAVE_LIKED: 2,
    },
  },
  FAVOURITES: {
    ID: 2,
    SUB_TAB: {
      FAV_ME: 1,
      HAVE_FAV: 2,
    },
  },
  MATCHES: {
    ID: 3,
  },
};
export const NOTIFICATIONS_KEY = {
  PUSH_NOTIFICATION: 'PUSH_NOTIFICATION',
  EMAIL_NOTIFICATION: 'EMAIL_NOTIFICATION',
  TEAM_RHP: 'TEAM_RHP',
};

export const PLACE_ID_DEFAULT = 999999;

export const GIPHY_API_KEY = 'kGRjfVGfJaA1S62du1IkWnZ6JtyJvbv4';
export const COMMENT_MESSAGE_CONTENT_TYPE = {
  TEXT: 'Text',
  GIFFY: 'Giphy',
  IMAGE: 'Image',
};
export const MESSAGE_RECEIVE_PERMISSION = {
  ANYONE: 'Anyone',
  MATCHING: 'Matching',
  FAV: 'Favourite',
  NO_ONE: 'NoOne',
  DIRECT_MESSAGE: 'DirectMessage',
  OWNER_ONLY: 'OwnerOnly',
};
export type MessageReceivePermissionType = (typeof MESSAGE_RECEIVE_PERMISSION)[keyof typeof MESSAGE_RECEIVE_PERMISSION];

export const ID_TYPE_PUSH_NOTIFICATION = {
  MESSAGES: 1,
  VIEWS: 2,
  LIKES: 3,
  FAV: 4,
  GROUP_CHAT: 6,
};

export const PATTERNS = {
  url: /(https?:\/\/|www\.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&\/\/=]*)/gi,
  phone: /[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,7}/,
  email: /\S+@\S+\.\S+/,
};

export const MAXIMUM_SIZE_IMAGE_UPLOAD = 1024; // in pixel
export const SIZE_IMAGE_FOR_BANNER_EVENT = 630;

export const MIMIMUN_CHARACTER_CONTENT = 100;

export const DEFAULT_FETCH_SIZE = 12;

export const FILE_TYPE_UPLOAD_ALLOWED = {
  IMAGE: ['jpg', 'jpeg', 'png'],
  VIDEO: ['mp4', 'avi', 'mov', 'webm', 'wmv', 'mkv', 'flv'],
};

export const UpgradeBenefit = {
  [UPGRADE_MEMBER_SHIP_ID.PREMIUM]: [
    {
      id: 1,
      icon: 'icChatOrange',
      icDesktop: icChatOrange,
      label: 'BenefitMoreConversation',
      des: 'BenefitMoreConversationDes',
    },
    {
      id: 2,
      icon: 'icInviteOrange',
      icDesktop: icInviteOrange,
      label: '10InvitationsPerDay',
      des: '10InvitationsPerDayDes',
      showMoreInfo: true,
    },
    {
      icon: 'icVideoOrange',
      icDesktop: icVideoOrange,
      label: 'BenefitPrivateVideoChat',
      des: 'BenefitVideoChatDes',
    },
    {
      icon: 'icCameraOrange',
      icDesktop: icCameraOrange,
      label: 'BenefitPhotoSharing',
      des: 'BenefitPhotoSharingDes',
      showMoreInfo: true,
    },
    {
      icon: 'icHeartOrange',
      icDesktop: icHeartOrange,
      label: 'BenefitSeeWhoLikeYou',
      des: 'BenefitSeeWhoLikeYouDes',
    },
    {
      icon: 'icSendHeartOrange',
      icDesktop: icSendHeartOrange,
      label: 'BenefitSendUpTo50Likes',
      des: 'BenefitSendUpToLikesDes',
    },
    {
      icon: 'icSendFavOrange',
      icDesktop: icSendFavOrange,
      label: 'BenefitAddUpTo5Fav',
      des: 'BenefitAddUpToFavDes',
    },
    {
      icon: 'icUndoOrange',
      icDesktop: icUndoOrange,
      label: 'BenefitUndoLikeFav',
      des: 'BenefitUndoLikeFavDes',
    },
    {
      icon: 'icProfileVisibilityOrange',
      icDesktop: icVisibilityOrange,
      label: 'BenefitProfileVisibility',
      des: 'BenefitProfileVisibilityDes',
    },
    {
      icon: 'icStealthOrange',
      icDesktop: icStealthOrange,
      label: 'BenefitGoStealth',
      des: 'BenefitGoStealthDes',
    },
    {
      icon: 'icCreateGroupOrange',
      icDesktop: icCreateGroupOrange,
      label: 'BenefitCreateGroup',
      des: 'BenefitCreateGroupDes',
    },
    {
      icon: 'icPostEventOrange',
      icDesktop: icPostEventOrange,
      label: 'BenefitPostEvent',
      des: 'BenefitPostEventDes',
    },
    {
      icon: 'icChatRoomOrange',
      icDesktop: icChatRoomOrange,
      label: 'BenefitAccessToChatRoom',
      des: 'BenefitAccessToChatRoomDes',
    },
  ],
  [UPGRADE_MEMBER_SHIP_ID.PREMIUM_PLUS]: [
    {
      id: 1,
      icon: 'icChatRed',
      icDesktop: icChatRed,
      label: 'Benefit25ConversationPerDay',
      des: 'Benefit25ConversationPerDayDes',
    },
    {
      id: 2,
      icon: 'icInviteRed',
      icDesktop: icInviteRed,
      label: '25InvitationsPerDay',
      des: '25InvitationsPerDayDes',
      showMoreInfo: true,
    },
    {
      icon: 'icPhoneRed',
      icDesktop: icPhoneRed,
      label: 'BenefitViewListedPhone',
      des: 'BenefitViewListedPhoneDes',
    },
    {
      icon: 'icMultiStreamRed',
      icDesktop: icMultiStreamRed,
      label: 'BenefitMultiVideoStream',
      des: 'BenefitWatchUpTo3VideoStreams',
    },
    {
      icon: 'icVideoRed',
      icDesktop: icVideoRed,
      label: 'BenefitPrivateVideoChat',
      des: 'BenefitVideoChatDes',
    },
    {
      icon: 'icCameraRed',
      icDesktop: icCameraRedBenefit,
      label: 'BenefitPhotoSharing',
      des: 'BenefitPhotoSharingDes',
      showMoreInfo: true,
    },
    {
      icon: 'icHeartRed',
      icDesktop: icHeartRed,
      label: 'BenefitSeeWhoLikeYou',
      des: 'BenefitSeeWhoLikeYouDes',
    },
    {
      icon: 'icSendHeartRed',
      icDesktop: icSendHeartRed,
      label: 'BenefitSendUpTo75Likes',
      des: 'BenefitSendUpToLikesDes',
    },
    {
      icon: 'icSendFavRed',
      icDesktop: icSendFavRed,
      label: 'BenefitAddUpTo10Fav',
      des: 'BenefitAddUpToFavDes',
    },
    {
      icon: 'icUndoRed',
      icDesktop: icUndoRed,
      label: 'BenefitUndoLikeFav',
      des: 'BenefitUndoLikeFavDes',
    },
    {
      icon: 'icProfileVisibilityRed',
      icDesktop: icVisibilityRed,
      label: 'BenefitProfileVisibility',
      des: 'BenefitProfileVisibilityDes',
    },
    {
      icon: 'icStealthRed',
      icDesktop: icStealthRed,
      label: 'BenefitGoStealth',
      des: 'BenefitGoStealthDes',
    },
    {
      icon: 'icCreateGroupRed',
      icDesktop: icCreateGroupRed,
      label: 'BenefitCreateGroup',
      des: 'BenefitCreateGroupDes',
    },
    {
      icon: 'icPostEventRed',
      icDesktop: icPostEventRed,
      label: 'BenefitPostEvent',
      des: 'BenefitPostEventDes',
    },
    {
      icon: 'icChatRoomRed',
      icDesktop: icChatRoomRed,
      label: 'BenefitAccessToChatRoom',
      des: 'BenefitAccessToChatRoomDes',
    },
  ],
  [UPGRADE_MEMBER_SHIP_ID.PLATINUM]: [
    {
      id: 1,
      icon: 'icChatBlack',
      icDesktop: icChatBlack,
      label: 'Benefit50ConversationPerDay',
      des: 'Benefit50ConversationPerDayDes',
    },
    {
      id: 2,
      icon: 'icInviteBlack',
      icDesktop: icInviteBlack,
      label: '50InvitationsPerDay',
      des: '50InvitationsPerDayDes',
      showMoreInfo: true,
    },
    {
      icon: 'icGuessBlack',
      icDesktop: icGuessBlack,
      label: 'BenefitGuessCanMessageYou',
      des: 'BenefitGuessCanMessageYouDes',
    },
    {
      icon: 'icPhoneBlack',
      icDesktop: icPhoneBlack,
      label: 'BenefitViewListedPhone',
      des: 'BenefitViewListedPhoneDes',
    },
    {
      icon: 'icMultiStreamBlack',
      icDesktop: icMultiStreamBlack,
      label: 'BenefitMultiVideoStream',
      des: 'BenefitWatchUpTo5VideoStreams',
    },
    {
      icon: 'icVideoBlack',
      icDesktop: icVideoBlack,
      label: 'BenefitPrivateVideoChat',
      des: 'BenefitVideoChatDes',
    },
    {
      icon: 'icCameraBlack',
      icDesktop: icCameraBlack,
      label: 'BenefitPhotoSharing',
      des: 'BenefitPhotoSharingDes',
      showMoreInfo: true,
    },
    {
      icon: 'icHeartBlack',
      icDesktop: icHeartBlack,
      label: 'BenefitSeeWhoLikeYou',
      des: 'BenefitSeeWhoLikeYouDes',
    },
    {
      icon: 'icSendHeartBlack',
      icDesktop: icSendHeartBlack,
      label: 'BenefitSendUpTo100Likes',
      des: 'BenefitSendUpToLikesDes',
    },
    {
      icon: 'icSendFavBlack',
      icDesktop: icSendFavBlack,
      label: 'BenefitAddUpTo20Fav',
      des: 'BenefitAddUpToFavDes',
    },
    {
      icon: 'icUndoBlack',
      icDesktop: icUndoBlack,
      label: 'BenefitUndoLikeFav',
      des: 'BenefitUndoLikeFavDes',
    },
    {
      icon: 'icProfileVisibilityBlack',
      icDesktop: icVisibilityBlack,
      label: 'BenefitProfileVisibility',
      des: 'BenefitProfileVisibilityDes',
    },
    {
      icon: 'icStealthBlack',
      icDesktop: icStealthBlack,
      label: 'BenefitGoStealth',
      des: 'BenefitGoStealthDes',
    },
    {
      icon: 'icCreateGroupBlack',
      icDesktop: icCreateGroupBlack,
      label: 'BenefitCreateGroup',
      des: 'BenefitCreateGroupDes',
    },
    {
      icon: 'icPostEventBlack',
      icDesktop: icPostEventBlack,
      label: 'BenefitPostEvent',
      des: 'BenefitPostEventDes',
    },
    {
      icon: 'icChatRoomBlack',
      icDesktop: icChatRoomBlack,
      label: 'BenefitAccessToChatRoom',
      des: 'BenefitAccessToChatRoomDes',
    },
  ],
  [UPGRADE_MEMBER_SHIP_ID.DIAMOND]: [
    {
      id: 1,
      icon: 'icUnlimitBlack',
      icDesktop: icUnlimitBlack,
      label: 'BenefitUnlimitedConversation',
      des: 'BenefitUnlimitedConversationDes',
    },
    {
      id: 2,
      icon: 'icInviteBlack',
      icDesktop: icInviteBlack,
      label: 'UnlimitedInvitationsPerDay',
      des: 'UnlimitedInvitationsPerDayDes',
      showMoreInfo: true,
    },
    {
      icon: 'icSendHeartBlack',
      icDesktop: icSendHeartBlack,
      label: 'BenefitUnlimitedLikes',
      des: 'BenefitSendUpToLikesDes',
    },
    {
      icon: 'icSendFavBlack',
      icDesktop: icSendFavBlack,
      label: 'BenefitUnlimitedFav',
      des: 'BenefitAddUpToFavDes',
    },
    {
      icon: 'icGuessBlack',
      icDesktop: icGuessBlack,
      label: 'BenefitGuessCanMessageYou',
      des: 'BenefitGuessCanMessageYouDes',
    },
    {
      icon: 'icPhoneBlack',
      icDesktop: icPhoneBlack,
      label: 'BenefitViewListedPhone',
      des: 'BenefitViewListedPhoneDes',
    },
    {
      icon: 'icMultiStreamBlack',
      icDesktop: icMultiStreamBlack,
      label: 'BenefitMultiVideoStream',
      des: 'BenefitWatchUpTo5VideoStreams',
    },
    {
      icon: 'icVideoBlack',
      icDesktop: icVideoBlack,
      label: 'BenefitPrivateVideoChat',
      des: 'BenefitVideoChatDes',
    },
    {
      icon: 'icCameraBlack',
      icDesktop: icCameraBlack,
      label: 'BenefitPhotoSharing',
      des: 'BenefitPhotoSharingDes',
      showMoreInfo: true,
    },
    {
      icon: 'icHeartBlack',
      icDesktop: icHeartBlack,
      label: 'BenefitSeeWhoLikeYou',
      des: 'BenefitSeeWhoLikeYouDes',
    },

    {
      icon: 'icUndoBlack',
      icDesktop: icUndoBlack,
      label: 'BenefitUndoLikeFav',
      des: 'BenefitUndoLikeFavDes',
    },
    {
      icon: 'icProfileVisibilityBlack',
      icDesktop: icVisibilityBlack,
      label: 'BenefitProfileVisibility',
      des: 'BenefitProfileVisibilityDes',
    },
    {
      icon: 'icStealthBlack',
      icDesktop: icStealthBlack,
      label: 'BenefitGoStealth',
      des: 'BenefitGoStealthDes',
    },
    {
      icon: 'icCreateGroupBlack',
      icDesktop: icCreateGroupBlack,
      label: 'BenefitCreateGroup',
      des: 'BenefitCreateGroupDes',
    },
    {
      icon: 'icPostEventBlack',
      icDesktop: icPostEventBlack,
      label: 'BenefitPostEvent',
      des: 'BenefitPostEventDes',
    },
    {
      icon: 'icChatRoomBlack',
      icDesktop: icChatRoomBlack,
      label: 'BenefitAccessToChatRoom',
      des: 'BenefitAccessToChatRoomDes',
    },
  ],
  [UPGRADE_MEMBER_SHIP_ID.PLUS]: [
    {
      id: 1,
      icon: 'icChatBlue',
      icDesktop: 'icChatBlue',
      label: 'plusConversationPerDay',
      des: 'BenefitPlusConversationDes',
    },
    {
      id: 2,
      icon: 'icInviteBlue',
      icDesktop: icInviteBlue,
      label: '5InvitationsPerDay',
      des: '5InvitationsPerDayDes',
      showMoreInfo: true,
    },
    {
      icon: 'icVideoBlue',
      icDesktop: 'icVideoBlue',
      label: 'BenefitPrivateVideoChat',
      des: 'BenefitVideoChatDes',
    },
    {
      icon: 'icCameraBlueBenefit',
      icDesktop: 'icCameraBlue',
      label: 'BenefitPhotoSharing',
      des: 'BenefitPhotoSharingDes',
      showMoreInfo: true,
    },
    {
      icon: 'icSendHeartBlue',
      icDesktop: 'icSendHeartBlue',
      label: 'BenefitSendUpTo30Likes',
      des: 'BenefitSendUpToLikesDes',
    },
    {
      icon: 'icSendFavBlue',
      icDesktop: 'icSendFavOrange',
      label: 'BenefitAddUpTo3Fav',
      des: 'BenefitAddUpToFavDes',
    },
    {
      icon: 'icProfileVisibilityBlue',
      icDesktop: icVisibilityBlue,
      label: 'BenefitProfileVisibility',
      des: 'BenefitProfileVisibilityDes',
    },
  ],
  [UPGRADE_MEMBER_SHIP_ID.EXTRAS]: [
    {
      id: 1,
      icon: 'icHeartRed',
      icDesktop: icHeartRed,
      label: 'BenefitSeeWhoLikeYou',
      des: 'BenefitSeeWhoLikeYouDes',
    },
    {
      icon: 'icRetristedRed',
      icDesktop: 'icRetristedRed',
      label: 'ViewRestrictedPhotos',
      des: 'ViewRestrictedPhotosDes',
    },

    {
      icon: 'icChatRoomRed',
      icDesktop: 'icChatRoomRed',
      label: 'BenefitAccessToChatRoom',
      des: 'BenefitAccessToChatRoomDes',
    },
    {
      icon: 'icPhoneRed',
      icDesktop: 'icPhoneRed',
      label: 'BenefitViewListedPhone',
      des: 'BenefitViewListedPhoneDes',
    },
    {
      icon: 'icUndoRed',
      icDesktop: 'icUndoRed',
      label: 'BenefitUndoLikeFav',
      des: 'BenefitUndoLikeFavDes',
    },
    {
      icon: 'icStealthRed',
      icDesktop: 'icStealthRed',
      label: 'BenefitGoStealth',
      des: 'BenefitGoStealthDes',
    },
    {
      icon: 'icCreateGroupRed',
      icDesktop: icCreateGroupRed,
      label: 'BenefitCreateGroup',
      des: 'BenefitCreateGroupDes',
    },
    {
      icon: 'icPostEventRed',
      icDesktop: 'icPostEventRed',
      label: 'BenefitPostEvent',
      des: 'BenefitPostEventDes',
    },
  ],
};
export const UpgradeGradient = {
  [UPGRADE_MEMBER_SHIP_ID.PREMIUM]: ['rgba(244,175,1,0.1)', 'rgba(250,217,133,0.048)', 'rgba(255,255,255,0)'],
  [UPGRADE_MEMBER_SHIP_ID.PREMIUM_PLUS]: ['rgba(247,107,70,0.1)', 'rgba(251,178,159,0.052)', 'rgba(255,255,255,0)'],
  [UPGRADE_MEMBER_SHIP_ID.PLATINUM]: ['rgba(51,51,51,0.1)', 'rgba(152,152,152,0.052)', 'rgba(255,255,255,0)'],
  [UPGRADE_MEMBER_SHIP_ID.DIAMOND]: ['rgba(51,51,51,0.1)', 'rgba(152,152,152,0.052)', 'rgba(255,255,255,0)'],
  [UPGRADE_MEMBER_SHIP_ID.EXTRAS]: ['rgba(247,107,70,0.1)', 'rgba(251,178,159,0.052)', 'rgba(255,255,255,0)'],
  [UPGRADE_MEMBER_SHIP_ID.PLUS]: ['rgba(70,165,247,0.1)', 'rgba(70,165,247,0.1)', 'rgba(255,255,255,0)'],
};
export const UpgradeInfoSlide = [
  {
    id: 7, // 6
    images: 'upgradeImg7',
    label: 'SeeWhoLikesYou',
    subLabel: 'MatchWithThemInstantly',
  },
  {
    id: 10,
    images: 'upgradeImg1',
    label: 'MessageHot',
    subLabel: 'MakeTheFirst',
  },
  // {
  //     id: 2,
  //     images: images.upgradeImg2,
  //     label: I18n.t("UpgradeMember.SearchFilters").toUpperCase(),
  //     subLabel: I18n.t("UpgradeMember.SearchBy")
  // },
  {
    id: 11,
    images: 'upgradeImg3',
    label: 'UpgradeBenefit',
    subLabel: 'UnlimitedLikeFav',
    subLabel2: 'PostYourOwnEvents',
  },
  {
    id: 8, // 6
    images: 'upgradeImg7',
    label: 'SeeWhoMatchedWithYou',
    subLabel: 'ChatNookWithThemNow',
  },
  // {
  //     id: 4,//4
  //     images: images.upgradeImg4,
  //     label: I18n.t("UpgradeMember.PartyLike").toUpperCase(),
  //     subLabel: I18n.t("UpgradeMember.VipInvites")
  // },
  // {

  // {
  //     id: 6,//6
  //     images: images.upgradeImg6,
  //     label: I18n.t("UpgradeMember.BringYour").toUpperCase(),
  //     subLabel: I18n.t("UpgradeMember.FindPeople")
  // },
  {
    id: 9,
    images: 'upgradeImg9',
    label: 'VideoChat',
    subLabel: 'ChatLive',
  },
];
export const UpgradeInfoPlus = [
  {
    id: 2,
    images: 'upgradeImg1',
    label: 'IntimateConversation',
    subLabel: 'ChatWithYourMatches',
  },
  {
    id: 3,
    images: 'upgradeImg3',
    label: 'SwapPhotos',
    subLabel: 'SendViewPhotosPrivately',
  },
  {
    id: 4,
    images: 'upgradeImg7',
    label: 'GetMoreLike',
    subLabel: 'MoreLikesMeansMoreMatches',
  },
  {
    id: 5,
    images: 'upgradeImg9',
    label: 'AddMoreFAVs',
    subLabel: 'FindOutWhenTheyReOnline',
  },
];
export const UpgradeInfoExtras = [
  {
    id: 7,
    images: 'upgradeImg7',
    label: 'BenefitSeeWhoLikeYou',
    subLabel: 'MatchWithThemInstantly',
  },
  {
    id: 6,
    images: 'upgradeImg5',
    label: 'ViewListedPhone',
    subLabel: 'CallOrText',
  },
  {
    id: 5,
    images: 'upgradeImg3',
    label: 'SeeRestrictedPhotos',
    subLabel: 'NoRestrictionsOnViewingPhotos',
  },
  {
    id: 4,
    images: 'upgradeImg9',
    label: 'GetAccessToChatrooms',
    subLabel: 'ParticipateInOurActiveChatRooms',
  },
  {
    id: 3,
    images: 'upgradeImg4',
    label: 'PartyLike',
    subLabel: 'HostYourOwn',
  },
];
export const UpgradeDiamondInfo = [
  {
    id: 1,
    label: 'UnlimitedLikes',
    subLabel: 'UnlimitedLikesDes',
  },
  {
    id: 2,
    label: 'UnlimitedFav',
    subLabel: 'UnlimitedFavDes',
  },
  {
    id: 3,
    label: 'UnlimitedConversations',
    subLabel: 'UnlimitedConversationsDes',
  },
  {
    id: 4,
    label: 'PriorityInboxPositioning',
    subLabel: 'PriorityInboxPositioningDes',
  },
  {
    id: 5,
    label: 'EliteDiamondStatus',
    subLabel: 'EliteDiamondStatusDes',
  },
  {
    id: 6,
    label: 'PriorityRHP',
    subLabel: 'PriorityRHPDes',
  },
];
export const CompareMemberShip = [
  {
    label: 'MessagePerDay',
    [UPGRADE_MEMBER_SHIP_ID.PLUS]: '5',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM]: '10',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM_PLUS]: '25',
    [UPGRADE_MEMBER_SHIP_ID.PLATINUM]: '50',
  },
  {
    label: 'InvitationsPerDay',
    [UPGRADE_MEMBER_SHIP_ID.PLUS]: '5',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM]: '10',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM_PLUS]: '25',
    [UPGRADE_MEMBER_SHIP_ID.PLATINUM]: '50',
  },
  {
    label: 'SendLikesPerDay',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM]: '50',
    [UPGRADE_MEMBER_SHIP_ID.PLUS]: '30',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM_PLUS]: '75',
    [UPGRADE_MEMBER_SHIP_ID.PLATINUM]: '100',
  },
  {
    label: 'AddFavPerDay',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM]: '5',
    [UPGRADE_MEMBER_SHIP_ID.PLUS]: '3',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM_PLUS]: '10',
    [UPGRADE_MEMBER_SHIP_ID.PLATINUM]: '20',
  },
  {
    label: 'ViewLikeMatches',
    typeIcon: true,
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM]: 'icCheckMS',
    [UPGRADE_MEMBER_SHIP_ID.PLUS]: 'icCloseMS',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM_PLUS]: 'icCheckMS',
    [UPGRADE_MEMBER_SHIP_ID.PLATINUM]: 'icCheckMS',
  },
  {
    label: 'PhotoSwap',
    typeIcon: true,
    [UPGRADE_MEMBER_SHIP_ID.PLUS]: 'icCheckMS',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM]: 'icCheckMS',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM_PLUS]: 'icCheckMS',
    [UPGRADE_MEMBER_SHIP_ID.PLATINUM]: 'icCheckMS',
  },
  {
    label: 'VideoStreams',
    typeIcon: true,
    [UPGRADE_MEMBER_SHIP_ID.PLUS]: 'icCloseMS',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM]: '1',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM_PLUS]: '3',
    [UPGRADE_MEMBER_SHIP_ID.PLATINUM]: '5',
  },
  // {
  //     label:'ContactFromGuest',
  //     typeIcon:true,
  //     platinumText:true,
  //     [UPGRADE_MEMBER_SHIP_ID.PREMIUM]:'icCloseMS',
  //     [UPGRADE_MEMBER_SHIP_ID.PREMIUM_PLUS]:'icCloseMS',
  //     [UPGRADE_MEMBER_SHIP_ID.PLATINUM]:'2/day',
  // },
  {
    label: 'ViewPhone#',
    typeIcon: true,
    [UPGRADE_MEMBER_SHIP_ID.PLUS]: 'icCloseMS',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM]: 'icCloseMS',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM_PLUS]: 'icCheckMS',
    [UPGRADE_MEMBER_SHIP_ID.PLATINUM]: 'icCheckMS',
  },
  {
    label: 'RestrictedPhotos',
    typeIcon: true,
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM]: 'icCheckMS',
    [UPGRADE_MEMBER_SHIP_ID.PLUS]: 'icCloseMS',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM_PLUS]: 'icCheckMS',
    [UPGRADE_MEMBER_SHIP_ID.PLATINUM]: 'icCheckMS',
  },
  {
    label: 'AccessToChatRooms',
    typeIcon: true,
    [UPGRADE_MEMBER_SHIP_ID.PLUS]: 'icCloseMS',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM]: 'icCheckMS',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM_PLUS]: 'icCheckMS',
    [UPGRADE_MEMBER_SHIP_ID.PLATINUM]: 'icCheckMS',
  },
  // {
  //     label: 'PrivateVideoChat',
  //     typeIcon: true,
  //     [UPGRADE_MEMBER_SHIP_ID.PLUS]: 'icCloseMS',
  //     [UPGRADE_MEMBER_SHIP_ID.PREMIUM]: 'icCheckMS',
  //     [UPGRADE_MEMBER_SHIP_ID.PREMIUM_PLUS]: 'icCheckMS',
  //     [UPGRADE_MEMBER_SHIP_ID.PLATINUM]: 'icCheckMS',
  // },

  {
    label: 'Unlike',
    typeIcon: true,
    [UPGRADE_MEMBER_SHIP_ID.PLUS]: 'icCloseMS',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM]: 'icCheckMS',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM_PLUS]: 'icCheckMS',
    [UPGRADE_MEMBER_SHIP_ID.PLATINUM]: 'icCheckMS',
  },
  {
    label: 'Incognito',
    typeIcon: true,
    [UPGRADE_MEMBER_SHIP_ID.PLUS]: 'icCloseMS',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM]: 'icCheckMS',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM_PLUS]: 'icCheckMS',
    [UPGRADE_MEMBER_SHIP_ID.PLATINUM]: 'icCheckMS',
  },
  {
    label: 'CreateGroups',
    typeIcon: true,
    [UPGRADE_MEMBER_SHIP_ID.PLUS]: 'icCloseMS',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM]: 'icCheckMS',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM_PLUS]: 'icCheckMS',
    [UPGRADE_MEMBER_SHIP_ID.PLATINUM]: 'icCheckMS',
  },
  {
    label: 'PostEvents',
    typeIcon: true,
    [UPGRADE_MEMBER_SHIP_ID.PLUS]: 'icCloseMS',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM]: 'icCheckMS',
    [UPGRADE_MEMBER_SHIP_ID.PREMIUM_PLUS]: 'icCheckMS',
    [UPGRADE_MEMBER_SHIP_ID.PLATINUM]: 'icCheckMS',
  },
];

export const TYPE_ACCOUNT = {
  APPLE: 'Apple',
  FACEBOOK: 'Facebook',
  GMAIL: 'Google',
};

export const STATUS_RESULT_TYPE = {
  SEND_ALLOWED: 'SendAllowed',
  SEND_LIMIT: 'SendLimitReached',
};
export const PUBLIC_ALBUM_ID = '10007';
export const ABOUT_ME = [
  {
    id: 1,
    title: 'EditProfile.General',
    subtitle: 'EditProfile.GeneralDes',
    status: null,
  },
  {
    id: 2,
    title: 'EditProfile.IntimateDetails',
    subtitle: 'EditProfile.IntimateDetailsDes',
    status: null,
  },
  {
    id: 6,
    title: 'EditProfile.ParticipationLevel',
    subtitle: 'EditProfile.ParticipationLevelDes',
    status: null,
  },
  {
    id: 3,
    title: 'EditProfile.Interests',
    subtitle: 'EditProfile.InterestsDes',
    status: null,
  },

  {
    id: 4,
    title: 'EditProfile.Description',
    subtitle: 'EditProfile.DescriptionDes',
    status: 'Rejected',
  },
  // {
  //     id: 5,
  //     title: 'Verification',
  //     subtitle: 'Verify your profile',
  //     status: 'Not verified'

  // }
];
export const IDEAL_PARTNER = [
  {
    id: 1,
    title: 'EditProfile.IdealPartnerDetails',
    subtitle: 'EditProfile.IdealPartnerDetailsDes',
    status: null,
  },
  {
    id: 2,
    title: 'EditProfile.IdealPartnerDescription',
    subtitle: 'EditProfile.IdealPartnerDescriptionDes',
    status: null,
  },
  {
    id: 3,
    title: 'EditProfile.Intentions',
    subtitle: 'EditProfile.IntentionsDes',
    status: null,
  },
  {
    id: 4,
    title: 'EditProfile.DealBreaker',
    subtitle: 'EditProfile.DealBreakerDes',
    status: null,
  },
];
export const IMAGE_ERROR_CODE = {
  ERROR_4001: '4001',
  ERROR_4002: '4002',
  ERROR_4003: '4003',
  ERROR_4004: '4004',
  ERROR_4005: '4005',
  ERROR_4006: '4006',
};
export const LOGIN_ERROR_CODE = {
  MULTIPLE_USER_FOUND: '0105',
};
export const LinkedAccountKey = {
  Facebook: 'Facebook',
  Apple: 'Apple',
  Google: 'Gmail',
};

// this is test account on EU server
// export const URBAN_AIRSHIP = {
//   VAR_NAME: "UA",
//   VAPID_PUBLIC_KEY: "BFtpJPKl9QzFQJtDwWxQC385vOLc-Eppbuvwg0TGJkKiIev5dwstI7TIK7xSw30dRADnoBKsY-mGLwqN9yWNjLE=",
//   APP_KEY: "5LqY6wETRCuHin0EObIdMg",
//   TOKEN: "MTo1THFZNndFVFJDdUhpbjBFT2JJZE1nOjVSc05ac1NQZEk3WTZMMENQSXBKM0VWLUU0ajltZ3ltQXo0bm9ENURObTQ",
//   DOM_ELEMENT_ID: "_uasdk"
// };

// Account on US server
// export const URBAN_AIRSHIP = {
//     VAR_NAME: "UA",
//     VAPID_PUBLIC_KEY: "BHGOTYU5yRS4CdxqjSPhiRHmAjjgv_YB3GTACoPvTgPmRo0Okj0DClDLqyxrlRycbVeyKvwfnfQMPCcpRfcS5B4=",
//     APP_KEY: "k2BxAWRYQKOqAHp40I3bhg",
//     TOKEN: "MTprMkJ4QVdSWVFLT3FBSHA0MEkzYmhnOk5PbXZpczFJQ0FuWk1qNW5reEthRVhncWlfY2MtVkZKbHRpV3R0VWJYNmM",
//     DOM_ELEMENT_ID: "_uasdk"
// };

export const PUSHY_CONFIG = {
  APP_ID: '6046db338abb33b02f6427f4',
};

export const NON_EXPLICIT_MAXIMUM_NUMBER = 2;

export const CONNECTED_ACCOUNT_FOUND_USER_ID = '17001';
export const CONNECTED_ACCOUNT_FOUND_USER_ID_GOOGLE = '5001';

export const TYPE_BLOCK_SEARCH = {
  BLOCK_SOMEONE: 'block_someone',
  SEARCH_LIST: 'search_list',
};
export const UPGRADE_PATH_VALUE = {
  Platinum: 'Platinum',
  PlatinumDiamond: 'PlatinumDiamond',
  None: 'None',
  Extras: 'Extras',
};

export const LIST_LEVEL_GUEST = [MEMBER_LEVEL.GUEST, MEMBER_LEVEL.PLUS, MEMBER_LEVEL.EXTRAS, MEMBER_LEVEL.PLUS_EXTRAS];

export const EVENT_FIRE_CALL_ACTIVE_USER = 'EVENT_FIRE_CALL_ACTIVE_USER';
export const TIMEOUT_RESET_FILTER = 30 * 60 * 1000;
export const TIMEOUT_USER_VERIFY_BIOMETRIC = 5 * 60 * 1000;

export const MAX_TAG = 5;
export const MAX_POPULAR = 5;

export const PERMISSION_PROPS = {
  EVENT: {
    NAME: 'event',
    CREATE_EVENT: 'canCreateEvent',
    VIEW_CONTACTS: 'canViewContacts',
  },
  MESSAGE: {
    NAME: 'message',
    AU_VISA_REQUIRED: 'auVisaRequired',
    SHOW_REPLY_LIMIT: 'showReplyLimit',
    CAN_MAKE_VIDEO_CALL: 'canMakeVideoCalls',
  },
  PHOTO: {
    NAME: 'photo',
    UPLOAD_REQUIRED: 'uploadRequired',
  },
  PROFILE: {
    NAME: 'profile',
    VIEW_PHONE_NUMBER: 'canViewPhoneNumbers',
    USE_ANONYMOUS_BROWSING: 'canUseAnonymousBrowsing',
  },
  PROSPECTS: {
    NAME: 'prospects',
    REMOVE_FAV: 'canRemoveFav',
    REMOVE_LIKE: 'canRemoveLike',
    VIEW_LIKES: 'canViewLikes',
    VIEW_MATCHES: 'canViewMatches',
  },
  GROUP: {
    NAME: 'group',
    CAN_CREATE_GROUPS: 'canManageGroups',
  },
};
export const extrasFeatures = [
  UPGRADE_TYPE.LIKE_OR_FAV,
  UPGRADE_TYPE.RESTRICTED,
  UPGRADE_TYPE.CHAT_ROOM,
  UPGRADE_TYPE.EVENT,
  UPGRADE_TYPE.MATCHES,
  UPGRADE_TYPE.VIDEO_CALL,
  UPGRADE_TYPE.PHONE,
];

export const OPTION_ITEM = {
  DELETE: 'delete',
  UN_FOLLOW: 'un-follow',
};
export const MessengerUpgradeAction = {
  UPGRADE: 'Upgrade',
  NONE: 'None',
  CREDITS: 'Credits',
};

export const STYLE_MODAL = {
  BLOCK_MODAL: 'block-modal',
  CONFIRM_MODAL: 'confirm-modal',
  CONFIRM_MOBILE_MODAL: 'confirm-mobile',
  SWITCH_GR_BTN: 'switch-gr-btn',
  USE_BLUE_BUTTON: 'use-blue-button',
  CONFIRM_DEFAULT_MODAL: 'confirm-default-modal',
};

export const TxtEnum = {
  OneHour: 'OneHour',
  OneDay: 'OneDay',
  OneWeek: 'OneWeek',
  OneMonth: 'OneMonth',
  ThreeMonths: 'ThreeMonth',
};

export type TxtEnumType = (typeof TxtEnum)[keyof typeof TxtEnum];

export const MESSAGE_IMAGE_DURATION_ENUM = {
  NONE: { txtEnum: 'None', text: 'None', value: -1, subText: '', abrText: '_' },
  ONE_HOUR: {
    txtEnum: TxtEnum.OneHour,
    text: 'One Hour',
    value: ONE_HOUR,
    subText: '1 hour',
    abrText: '1H',
  },
  ONE_DAY: {
    txtEnum: TxtEnum.OneDay,
    text: 'One Day',
    value: ONE_DAY,
    subText: '1 day',
    abrText: '1D',
  },
  ONE_WEEK: {
    txtEnum: TxtEnum.OneWeek,
    text: 'One Week',
    value: ONE_WEEK,
    subText: '1 week',
    abrText: '1W',
  },
  ONE_MONTH: {
    txtEnum: TxtEnum.OneMonth,
    text: 'One Month',
    value: ONE_MONTH,
    subText: '1 month',
    abrText: '1M',
  },
  THREE_MONTHS: {
    txtEnum: TxtEnum.ThreeMonths,
    text: 'Three Months',
    value: THREE_MONTHS,
    subText: '3 months',
    abrText: '3M',
  },
};

export const MESSENGER_UPGRADE_ACTION = {
  NONE: 'None',
  UPGRADE: 'Upgrade',
  CREDITS: 'Credits',
};

export type MessengerUpgradeActionType = (typeof MESSENGER_UPGRADE_ACTION)[keyof typeof MESSENGER_UPGRADE_ACTION];

export const WIDTH_OF_PHONE = {
  MIN_DEVICE_320: 320,
  MAX_DEVICE_374: 374,
  DEFAULT: 768,
};

export const TYPE_NOTIFICATION = {
  FRIENDS: 'Friends',
  VALIDATIONS: 'Validations',
  REQUEST_TO_JOIN: 'RequestToJoin',
  GROUP_INVITATION: 'GroupInvitation',
};

export const TIMESTAMP_RESET_CALL_LOGIN = 1000 * 60 * 5; // 5 minutes

export const MAIL_OUT_CATEGORIES = {
  EVENT: 'event',
  DATE_FINDER: 'dateFinder',
  RATING: 'rating',
  ARTICLE: 'article',
  VERIFICATION: 'verification',
  DEAL_BREAKER: 'dealBreaker',
  UPGRADE_PAGE: 'upgradePage',
  RHP_COIN: 'rhpCoin',
};

export type MailoutCategoriesType = (typeof MAIL_OUT_CATEGORIES)[keyof typeof MAIL_OUT_CATEGORIES];

export const TYPE_WALLET_RENDER = {
  WALLET: 'wallet',
  UPDATE: 'update',
  ADD: 'add',
};

type IQueryTabs = {
  all: string;
  matching: string;
  newest: string;
  recently_active: string;
  near_by: string;
  traveling: string;
  active_now: string;
  spotlight: string;
  [key: string]: string;
};

export const QUERY_TABS: IQueryTabs = Object.freeze({
  all: 'All',
  matching: 'Matching',
  newest: 'New',
  recently_active: 'Active',
  near_by: 'NearBy',
  traveling: 'Traveling',
  active_now: 'ActiveNow',
  spotlight: 'Spotlight',
});

type TabQuery = {
  All: string;
  Matching: string;
  New: string;
  Active: string;
  NearBy: string;
  Traveling: string;
  ActiveNow: string;
  Spotlight: string;
  [key: string]: string;
};

export const TAB_QUERYS: TabQuery = Object.freeze({
  All: 'all',
  Matching: 'matching',
  New: 'newest',
  Active: 'recently_active',
  NearBy: 'near_by',
  Traveling: 'traveling',
  ActiveNow: 'active_now',
  Spotlight: 'spotlight',
});

export const SECURE_ACCOUNT_MODAL = 'SecureAccountModal';

export const SIZE_PRODUCT = {
  X_SMALL: { text: 'Xsmall', id: 1, value: 1 },
  SMALL: { text: 'Small', id: 2, value: 2 },
  MEDIUM: { text: 'Medium', id: 3, value: 3 },
  LARGE: { text: 'Large', id: 4, value: 4 },
  X_LARGE: { text: 'Xlarge', id: 5, value: 5 },
};

export const COLOR_PRODUCT = {
  WHITE: { text: 'White', id: 1, value: 1 },
  RED: { text: 'Red', id: 2, value: 2 },
  GREEN: { text: 'Green', id: 3, value: 3 },
};

export const CURRENCY_CODE = {
  AUS_DOLLAR: 'AUD',
  DIAMONDS: 'D',
};

export const TYPE_PAYMENT = {
  DIAMONDS: 'diamond',
  MONEY: 'money',
  APPLE_PAY: 'apple-pay',
  GOOGLE_PAY: 'google-pay',
};

export const TYPE_RENDER_CREDIT_CARD = {
  TYPE_DETAIL: 'type1',
  TYPE_FULL: 'type2',
};

export const CODE_PRODUCT_ORDER = {
  AUD: 'AUD',
  DIAMOND: 'D',
};
export const GoogleCaptchaKey = {
  SITE_KEY: '6LfgzrQUAAAAAGWi1uwmw-2sVec0qj91P7SVG_qs',
  URL: 'https://redhotpie.com.au',
};

export const OPERATING_SYSTEM = {
  ANDROID: 'Android',
  IOS: 'iOS',
  UNKNOWN: 'unknown',
};

export const TIME_OUT_CHECK_MESSAGE_AUTHORIZE = 2 * 60 * 1000;

export const CUSTOM_EVENT_MODAL = 'closeModal';
export const CUSTOM_EVENT_GROUP_CHAT_HEADER = 'closeOptionHeader';
export const CUSTOM_EVENT_GROUP_CHAT_FOOTER = 'closeOptionFooter';

export const SCORE_STAR_DEFAULT = 4;

export const LENGTH_CARD_NUMBER = 16;

export const TEXT_RANGE = {
  MIN_DEFAULT: 5,
  MIN_DEFAULT_GROUP: 50,
  MAX_DEFAULT: 100,
  MAX_10000: 10000,
  MAX_1000: 1000,
  MAX_3500: 3500,
  MAX_3000: 3000,
  MAX_4000: 4000,
  MAX_2000: 2000,
  MAX_500: 500,
  MIN_10: 10,
};

export const PARAMS_URI = {
  IS_GROUP_CHAT: 'gr',
  BACK_URL: 'backUrl',
  BURL: 'burl',
  USERNAME: 'userName',
  CURRENT_NODE: 'curNode',
};

export const MEMBER_ROLE = {
  OWNER: 'owner',
  MEMBER: 'member',
};

export const TYPES_MODAL = {
  VALIDATION: 'isShowValidationModal',
  FRIEND: 'isShowFriendModal',
};

export const BUTTON_TYPE = {
  LARGE: 'large',
  SMALL: 'small',
};

export const IMG_YOUTUBE = 'https://img.youtube.com/vi/code/0.jpg';
export const IMG_MAX_YOUTUBE = 'https://img.youtube.com/vi/code/maxresdefault.jpg';
export const IMG_MAX_VIMEO = 'https://vumbnail.com/code.jpg';
export const YOUTUBE_URL = 'https://www.youtube.com/watch?v=code';
export const YOUTUBE_URL_MOBILE = 'https://youtu.be';

export const INDEX_POPULAR_EVENT = {
  POPULAR_EVENT: 0,
  RECOMMENDED_EVENT: 1,
  INTERESTED_IN: 2,
};

export const FROM_DELETE_COMMENT = {
  EVENT: 'event',
  STORY: 'story',
};

export const TIMEOUT_FORCE_RECONNECT = 10000;

export const FROM_EVENT = {
  DETAIL: 'detail',
};

export const TYPE_ALL_PROP = {
  FRIEND: 'fri',
  VALIDATION: 'val',
  INTEREST_DATE_FINDER: 'int-date',
  INTEREST_EVENT: 'int-evt',
  COMMENT_USER_LIKE: 'cmt-us-li',
  COMMENT_FR_USER_LIKE: 'cmt-fr-us-li',
};

export const PRODUCT_GROUP = {
  CONVERSATION_CREDITS: 'ConversationCredits',
  STORE_CREDITS: 'StoreCredits',
};

export const TOTAL_SHOW_SHARED_PHOTOS = 5;

export const SCROLL = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
};

export const VIDEO_TYPE = {
  YOUTUBE: 'Youtube',
  VIMEO: 'Vimeo',
  ANT_MEDIA: 'AntMedia',
  ANT_MEDIA_2: 'Antmedia',
};
export const GiftLevel = {
  Level1: 1,
  Level2: 2,
  Level3: 3,
  Level4: 4,
  Level5: 5,
  Level6: 6,
};

export const MAXIMUM_RESEND_MESSAGE_TIME = 5;

export const GIFT_LEVEL = {
  [GiftLevel.Level1]: {
    image: 'giftIconLevel1',
    imageSvg: giftIconLevel1.default,
  },
  [GiftLevel.Level2]: {
    image: 'giftIconLevel2',
    imageSvg: giftIconLevel2.default,
  },
  [GiftLevel.Level3]: {
    image: 'giftIconLevel3',
    imageSvg: giftIconLevel3.default,
  },
  [GiftLevel.Level4]: {
    image: 'giftIconLevel4',
    imageSvg: giftIconLevel4.default,
  },
  [GiftLevel.Level5]: {
    image: 'giftIconLevel5',
    imageSvg: giftIconLevel5.default,
  },
  [GiftLevel.Level6]: {
    image: 'giftIconLevel6',
    imageSvg: giftIconLevel6.default,
  },
};

export const ACTION_TYPE = {
  MESSAGE_INTEREST: 'message-interest',
  DELETE_INTEREST: 'delete-interest',
  TICKET_LINK: 'ticket-link',
  GROUP_CHAT: 'group-chat',
};

export type ActionType = (typeof ACTION_TYPE)[keyof typeof ACTION_TYPE];

export const GROUP_CHAT_STATUS = {
  ALL: 'All',
  IN_CHAT: 'InChat',
  OUT_CHAT: 'OutChat',
};

export const STEP_MODAL = {
  PAUSE_ACCOUNT_MODAL: 0,
  DELETE_ACCOUNT_STEP_1: 1,
  DELETE_ACCOUNT_STEP_2: 2,
  PAUSE_ACCOUNT_STEP_1: 3,
  PAUSE_ACCOUNT_STEP_2: 7,
  RENDER_SUBSCRIPTION: 4,
  RENDER_CONGRATULATION: 5,
  RENDER_CANCEL_MEMBERSHIP: 6,
};

export type StepModalType = (typeof STEP_MODAL)[keyof typeof STEP_MODAL];

export const GALLERY_STATUS = {
  PENDING: 'Pending',
  ACCEPTED: 'Accepted',
  REJECTED: 'Rejected',
  RESET: 'Reset',
};

export const RHP_ERROR_CODE = {
  CODE_1003: {
    ErrorCode: '1003',
  },
};

export const CUSTOM_LISTENER_EVENT = {
  EVENT_SWIPE_RIGHT: 'EVENT_SWIPE_RIGHT',
  EVENT_SCROLL_LEFT: 'EVENT_SCROLL_LEFT',
};

export const STEP_VIDEO = {
  STEP_SELECT_TYPE: '1',
  STEP_ADD_URL: '2',
  STEP_UPLOAD_VIDEO: '3',
};

export const WINDOW_CALL_TYPE = {
  CALL_WINDOW: 'call-window',
  MINIMIZE: 'minimize',
  // REQUESTING_CALL: 'requesting-call',
  NONE: 'none',
};

export const RECEIVING_CALL_TYPE = {
  NONE: 'none',
  BUBBLE: 'bubble',
  INCOMING_CALL_PANEL: 'incoming-call-panel',
};

export const CALL_STATE = {
  RECEIVING: 'receiving',
  REQUESTING: 'requesting',
  IN_CALL: 'in-call',
  IDLE: 'idle',
};

export const INTENTIONS = 'intentions';
export const DEAL_BREAKERS = 'dealBreakers';
export const TIME_DIFF_SERVER = 5000;
export const THEMES = {
  GREEN: 'Green',
  PINK: 'Pink',
  PURPLE: 'Purple',
  BLUE: 'Blue',
};

export type ThemeType = (typeof THEMES)[keyof typeof THEMES];
export const FONT_SIZES = {
  SMALL: 'Small',
  REGULAR: 'Regular',
  MEDIUM: 'Medium',
  LARGE: 'Large',
  HUGE: 'Huge',
};

export const TESTIMONIAL_DESCRIPTION_MAX_LENGTH = 80;

export const PROFILE_VIEW_OPTIONS = [
  { key: 'Everyone', value: 'PrivacySetting.Everyone' },
  { key: 'Matching', value: 'PrivacySetting.MatchingMembersOnly' },
  { key: 'MemberLikedFav', value: 'PrivacySetting.MembersILiked' },
  { key: 'NoOne', value: 'PrivacySetting.NoBody' },
];

export const PROFILE_VIEW_SETTINGS = {
  EVERYONE: 'Everyone',
  MATCHING: 'Matching',
  MEMBER_LIKED_FAV: 'MemberLikedFav',
  NO_ONE: 'NoOne',
};

export const WHO_CAN_VIEW_TYPE = {
  PROFILE: 'profile',
  VALIDATION: 'validations',
  INTIMATE_INFO: 'intimate info',
  ACTIVITY: 'activity',
};

export const PAYMENT_EVENT = {
  TRY_CARD: 'try_card',
};

export const STEP = {
  _1: 1, // Can we get your email
  _2: 2, // Can we get your number
  _3: 3, // Verification code
  _4: 4, // About you
  _5: 5, // Last step
  _6: 6, // Final page
  _7: 7,
  _8: 8,
  _PROMO_CODE: 9999, // Promo code,
  _LOGGED_SCREEN: 8888,
};

export const SPECIAL_CHAR = "[$&+,:;=?@#|'<>.^*()%!]";
export const SPECIAL_CHAR_EMAIL = "[$&+,:;=?#| '<>^*()%!]";

export const VERIFY_CODE_LENGTH = 4;
export const VERIFY_CODE_LENGTH_FORGOT_PASSWORD = 6;

export const QUICK_REG_TYPE = {
  FEED_HOME: 'feed-home',
  EVENT: 'Event',
  GROUP_CHAT: 'group-chat',
  PROFILE: 'Profile',
  CLUB: 'Club',
  FORUM: 'Forum',
  ARTICLE: 'Article',
  GALLERY: 'OnTheGroundGallery',
  POST: 'GroupPost',
  ALBUM: 'GroupAlbum',
  STORY: 'Story',
  ON_THE_GROUND_PHOTO: 'OnTheGroundPhoto',
  ON_THE_GROUND_VIDEO: 'OnTheGroundVideo',
};

export const REASON_INVITE_USER_TO_GROUP = 'We simply invite you to join us.';

export const LIMIT_VALIDATE = 10;

export const MY_TYPE = {
  CONVERSATION: 'conversation',
  BOOSTS: 'boosts',
};

export const BOOSTS_TYPE = {
  PROFILE: 'profile',
  CONVERSATION: 'conversation',
  LIKE: 'Like',
  FAVORITE: 'Favourite',
  INVITE_CREDIT: 'InviteCredit',
};

export const UPGRADE_INFO_DESCRIPTION = [
  {
    key: MEMBER_TYPES.PLUS,
    key2: UPGRADE_MEMBER_SHIP_ID.PLUS,
    name: 'FeedHome.PlusTitle',
    description: 'FeedHome.PlusDes',
  },
  {
    key: MEMBER_TYPES.PREMIUM,
    key2: UPGRADE_MEMBER_SHIP_ID.PREMIUM,
    name: 'FeedHome.PremiumTitle',
    description: 'FeedHome.PremiumDes',
  },
  {
    key: MEMBER_TYPES.PREMIUM_PLUS,
    key2: UPGRADE_MEMBER_SHIP_ID.PREMIUM_PLUS,
    name: 'FeedHome.PremiumPlusTitle',
    description: 'FeedHome.PremiumPlusDes',
  },
  {
    key: MEMBER_TYPES.PLATINUM,
    key2: UPGRADE_MEMBER_SHIP_ID.PLATINUM,
    name: 'FeedHome.PlatinumTitle',
    description: 'FeedHome.PlatinumDes',
  },
  {
    key: MEMBER_TYPES.DIAMOND,
    key2: UPGRADE_MEMBER_SHIP_ID.DIAMOND,
    name: 'FeedHome.DiamondTitle',
    description: 'FeedHome.DiamondDes',
  },
];
export const RHP_COIN_BUY_TYPE = {
  Normal: 'Normal',
  NotEnoughCoin: 'NotEnoughCoin',
};

export const MAX_RETRY_GET_IMAGE_THUMB = 5;

export const QUICK_REGISTRATION_BG = {
  VNL: 'vnl',
  PL: 'pl',
  KTCH: 'ktch',
  BD: 'bd',
  NONE: 'none',
};

export const PROFILE_MEMBER_TYPE = {
  1: 'Man',
  2: 'Woman',
  4: 'CoupleMF',
  8: 'Group',
  16: 'CoupleFF',
  32: 'CoupleMM',
  64: 'TV',
  128: 'TW',
  256: 'TM',
};

export const COUPLE_TYPE = {
  HIM: 1,
  HER: 2,
};

export const GENDER_TYPES = {
  MAN: 1,
  WOMAN: 2,
  COUPLE: 4,
};

export const PROMO_CODE_POSITION = {
  START: 'START',
  END: 'END',
};

export const MEMBER_TYPE_CHANGE_TYPE = {
  COMPLIMENTARY: 'Complimentary',
  CHARGED: 'Charged',
};

export const EVENT_SELECTION_TYPE = {
  CURRENT: 'Current',
  PAST: 'Past',
  ALL: 'All',
};

export const COMMUNITY_DATA_KEY = {
  ARTICLE: 'article',
  STORIES: 'stories',
  OTG: 'otg',
  OTG_PHOTO: 'otgPhoto',
  OTG_VIDEO: 'otgVideo',
  QUSETION_ANSWER: 'questionAndAnswer',
};

export const ACCOUNT_STATUS = {
  ACTIVE: 'Active',
  PAUSED: 'Paused',
  INACTIVE: 'Inactive',
  AUTHENTICATION_REQUIRE: 'AuthenticationRequired',
};
export type AccountStatusType = (typeof ACCOUNT_STATUS)[keyof typeof ACCOUNT_STATUS];

export const EVENT_FILTER = {
  TRAVEL_EVENTS: 'Travel Events',
};

export const CONSUMABLE_TYPE = {
  MEMBER_TYPE_CHANGE: 'MemberTypeChange',
  UN_DELETE_USER: 'UnDeleteUser',
};

export const EVENT_MODE = {
  CREATE: 'create',
  EDIT: 'edit',
  DUPLICATE: 'duplicate',
};

export const CREATE_TYPE = {
  EVENT: 'event',
  CLUB: 'club',
};

export const PURCHASE_CATEGORY = {
  MEMBERSHIP: 'Membership',
  CREDITS: 'Credits',
  COINS: 'Coins',
};

export const JOIN_GROUP_STATUS = {
  PENDING: 'Pending',
  NOTJOINED: 'NotJoined',
  APPROVED: 'Approved',
};

export const CLUB_PRIVACY_TYPE = {
  PUBLIC: 'Public',
  PRIVATE: 'Private',
};
export const CLUB_CAN_JOIN_STATUS = {
  CANJOIN: 'CanJoin',
  INVITE_ONLY: 'InviteOnly',
};
export const ACCESSIBILITY_STATUS = {
  Visible: 'Visible',
};
export const CLUB_VISIBILITY_TYPE = {
  NotSpecified: 'NotSpecified',
  All: 'All',
  MemberOnly: 'MemberOnly',
};
export const QUICK_REG_VERSION = {
  V2: 'v2',
  V2_1: 'v2.1',
};

export const GROUP_CHOOSE_TYPE = {
  PRIVACY: 'privacy',
  VISIBILITY: 'visibility',
};

export const ContentApprovalStatus = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  RESTRICTED: 'Restricted',
};
export const ClubMediaParentType = {
  Album: 'Album',
  Post: 'Post',
};
export const POST_ACTION = {
  PHOTO: 'p',
  VIDEO: 'v',
  EVENT: 'e',
};
export const ClubMediaType = {
  Photo: 'Photo',
  Video: 'Video',
};

export const NOTIFICATION_DETAIL = {
  LIKE: 'like',
  REQUEST: 'rq',
  EVENT_INTERESTED: 'evitr',
};

export const IS_LOADING = 'isLoading';
export const GroupMatchCriteria = {
  All: -1,
  Matched: 1,
  Unmatched: 0,
};

export const LIMIT_RENDER = 3;

export const MIN_DIMENSION_IMAGE = {
  WIDTH: 200,
  HEIGHT: 200,
};

export const MAX_PHOTO_SIZE = {
  text: '5MB',
  number: 5242880,
};
export const MAX_VIDEO_SIZE = {
  text: '15MB',
  number: 15728640,
};
export const INVITE_TYPE = {
  GROUP: 'Group',
  EVENT: 'Event',
  GROUP_CHAT: 'GroupChat',
};
export const INVITE_LIMIT = 'LimitReached';

export const CREATE_POST_TYPE = {
  PHOTO: 'Photo',
  VIDEO: 'Video',
  PHOTO_CAMERA: 'PhotoCamera',
  VIDEO_CAMERA: 'VideoCamera',
};

export const GROUP_NAME_REGEX = /^[a-zA-Z0-9][a-zA-Z0-9_ ]*[a-zA-Z0-9]$/;

export const DRESS_CODE_LIMIT = 150;

export const MAXIMUM_PHOTO_PER_GALLERY = 50;

export const DEFAULT_SIZE_GET_REPLIES = 5;

export const DETAIL_TYPE = {
  COMMENTS: 'Comment',
  LIKES: 'Like',
};

export const VERIFICATION_TYPE = {
  SINGLE: 'Single',
  FIRST_PARTNER: 'FirstPartner',
  SECOND_PARTNER: 'SecondPartner',
};

export const TIMEOUT_RECONNECTING_LABEL = 1000 * 10; // 10 seconds

export const GROUP_CREATE_TAG = {
  DESCRIPTION: 'd',
  RULES: 'r',
};

export const placements = Object.freeze({
  top: 'rc-popover--top',
  right: 'rc-popover--right',
  bottom: 'rc-popover--bottom',
  left: 'rc-popover--left',
  'simple-left': 'rc-popover--left simple-left',
  'top-left': 'rc-popover--top-left',
  'left-top': 'rc-popover--left-top',
  'top-right': 'rc-popover--top-right',
  'right-top': 'rc-popover--right-top',
  'bottom-left': 'rc-popover--bottom-left',
  'left-bottom': 'rc-popover--left-bottom',
  'bottom-right': 'rc-popover--bottom-right',
  'right-bottom': 'rc-popover--right-bottom',
});

export const REGISTRATION_ERROR_TYPE = {
  USERNAME_INVALID_LENGTH: 'UsernameInvalidLength',
  USERNAME_INVALID_CHARACTERS: 'UsernameInvalidCharacters',
  USERNAME_IN_USE: 'UserNameInUse',
  INVALID_EMAIL: 'InvalidEmail',
  SUCCESS: 'Success',
};

export const NO_TRANSLATE = 'notranslate';
export const TRANSLATE = 'translate';
export const SUPPORTED_LANGUAGES = ['en', 'es', 'de', 'nl', 'it', 'fr', 'pt', 'th', 'id', 'vi'];
export const DEFAULT_PAGE_LANGUAGE = 'en';

export const STEP_V2 = {
  PROMO_CODE: 0,
  GENDER: 1,
  BIRTHDAY: 2,
  LOOKING_FOR: 3,
  LAST_STEP: 4,
  DONE: 5,
};
